const pl = {
  _name: 'Polski',
  _flag: '🇵🇱',

    'comm.anonymousVisitor': 'Anonimowy gość',
  'comm.deletedVisitor': 'Usunięty gość',
'notifAuto.timezone': 'Strefa czasowa',
  'notifAuto.timezoneHint': 'Określa, kiedy wysyłane są przypomnienia',
  'notifAuto.tzKyiv': 'Kijów (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Warszawa (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Berlin (UTC+1/+2)',
  'notifAuto.tzParis': 'Paryż (UTC+1/+2)',
  'notifAuto.tzLondon': 'Londyn (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Madryt (UTC+1/+2)',
  'notifAuto.tzRome': 'Rzym (UTC+1/+2)',
  'notifAuto.tzNewYork': 'Nowy Jork (UTC-5/-4)',

  'errors.rateLimited': 'Zbyt wiele zapytań. Spróbuj za {seconds} s 🙂',
  'errors.serverError': 'Błąd serwera. Spróbuj ponownie za chwilę',
  'errors.networkError': 'Brak połączenia. Sprawdź internet',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Monitor Biznesu',
  'nav.dashboard': 'Panel',
  'nav.clients': 'Klienci',
  'nav.communication': 'Komunikacja',
  'nav.staff': 'Personel',
  'nav.inventory': 'Magazyn',
  'nav.salary': 'Wynagrodzenia',
  'nav.finances': 'Finanse',
  'nav.system': 'System',
  'nav.integrations': 'Integracje',
  'nav.sales': 'Sprzedaż',

  // ── Navigation items ──
  'nav.pos': 'Sklep',
  'nav.salesProducts': 'Wysyłka z magazynu',
  'nav.salesServices': 'Rezerwacja usług',
  'nav.clientsBase': 'Baza klientów',
  'nav.categories': 'Kategorie klientów',
  'nav.messages': 'Wiadomości',
  'nav.employees': 'Pracownicy',
  'nav.schedule': 'Grafik pracy',
  'nav.scheduleTemplates': 'Szablony grafików',
  'nav.services': 'Usługi',
  'nav.tariffPlans': 'Plany taryfowe',
  'nav.products': 'Produkty',
  'nav.stock': 'Stany magazynowe',
  'nav.purchases': 'Zakupy',
  'nav.movements': 'Ruchy magazynowe',
  'nav.orders': 'Zamówienia',
  'nav.salaryCalc': 'Obliczenia',
  'nav.salarySchemes': 'Schematy motywacyjne',
  'nav.financialOps': 'Operacje finansowe',
  'nav.cashRegister': 'Kasa',
  'nav.reports': 'Raporty',
  'nav.financialResult': 'Wynik finansowy',
  'nav.users': 'Użytkownicy',
  'nav.roles': 'Role',
  'nav.checkbox': 'Checkbox POS',
  'nav.telegram': 'Przypomnienia Telegram',
  'nav.sms': 'Wysyłka SMS',
  'nav.email': 'Wysyłka Email',
  'nav.novaPoshta': 'Nova Poshta',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Wiadomości z ogłoszeń + synchronizacja katalogu',
  'olx.connected': 'Połączono',
  'olx.notConnected': 'Nie połączono',
  'olx.connectIntro': 'Połącz konto OLX przez OAuth, aby otrzymywać wiadomości z ogłoszeń w CRM i publikować produkty jako ogłoszenia.',
  'olx.connectBtn': 'Połącz OLX',
  'olx.tabOpened': 'OLX otwarty w nowej karcie. Autoryzuj i wróć.',
  'olx.connectFailed': 'Błąd połączenia:',
  'olx.connectedToast': 'OLX połączono',
  'olx.confirmDisconnect': 'Odłączyć integrację OLX?',
  'olx.disconnected': 'OLX odłączono',
  'olx.disconnectBtn': 'Odłącz',
  'olx.testBtn': 'Testuj połączenie',
  'olx.testOk': 'Połączono jako: {name} (ID {id})',
  'olx.testFailed': 'Test nieudany',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Uprawnienia',
  'olx.connectedAt': 'Połączono',
  'olx.reconnectRequired': 'Wymagana ponowna autoryzacja',
  'olx.reconnectExplain': 'OLX cofnął nasze tokeny (zwykle po 30 dniach nieaktywności lub zmianie hasła). Kliknij „Połącz OLX", aby kontynuować odbieranie wiadomości.',
  'olx.refreshBtn': 'Sprawdź nowe wiadomości',
  'olx.refreshFound': 'Pobrano {n} nowych wiadomości — sprawdź w Komunikacji',
  'olx.refreshNoNew': 'Brak nowych wiadomości',
  'olx.refreshFailed': 'Odświeżenie nieudane',
  'comm.olxThreadMissing': 'Nie udało się określić wątku OLX',
  'olx.howItWorks': 'Jak to działa',
  'olx.step1': 'Kliknij „Połącz OLX" — autoryzacja OLX otworzy się w nowej karcie.',
  'olx.step2': 'Zaloguj się na konto OLX i przyznaj dostęp aplikacji.',
  'olx.step3': 'Wróć tutaj — status odświeży się automatycznie; zweryfikuj przyciskiem „Testuj połączenie".',
  'olx.capabilities': 'Co odblokowuje integracja',
  'olx.capInboxTitle': 'Czaty z ogłoszeń — w CRM',
  'olx.capInboxText': 'Każda wiadomość kupującego z Twoich ogłoszeń OLX trafia do Sidebar → Komunikacja. Sprawdzanie co 10 min; użyj „Sprawdź nowe wiadomości" powyżej dla natychmiastowego pobrania.',
  'olx.capOutboundTitle': 'Odpowiadaj z CRM bezpośrednio w czacie OLX',
  'olx.capOutboundText': 'Otwórz wątek w Komunikacji, wybierz kanał OLX — Twój tekst trafi do czatu OLX kupującego, jakbyś pisał z olx.ua.',
  'olx.capPublishTitle': 'Publikuj produkty jako ogłoszenia OLX',
  'olx.capPublishText': 'Sidebar → Inwentarz → otwórz produkt → „Opublikuj na OLX". Tytuł, opis, cena i zdjęcie są pre-wypełnione — wybierz kategorię, miasto, kontakt, a ogłoszenie trafi do moderacji OLX.',
  'olx.limitations': 'Ograniczenia',
  'olx.limitationsText': 'Zamówienia OLX Delivery nie są jeszcze udostępniane przez API partnerskie. Zarządzaj nimi na olx.ua.',
  'nav.locations': 'Lokalizacje',
  'nav.myPlan': 'Mój Plan',
  'nav.onlineBooking': 'Rezerwacja online',
  'nav.help': 'Pomoc',
  'booking.title': 'Rezerwacja online',
  'booking.subtitle': 'Konfiguracja publicznej strony rezerwacji dla klientów',
  'booking.enable': 'Włącz rezerwację online',
  'booking.yourLink': 'Twój link',
  'booking.copy': 'Kopiuj',
  'booking.urlCopied': 'Link skopiowany',
  'booking.linkHint': 'Udostępnij ten link klientom — na Instagramie, Telegramie, stronie WWW',
  'booking.businessInfo': 'Informacje o firmie',
  'booking.businessName': 'Nazwa firmy',
  'booking.businessNameHint': 'Jak klienci Cię zobaczą',
  'booking.slug': 'Identyfikator URL',
  'booking.slugHint': 'Litery łacińskie, cyfry, myślniki. Np: moj-salon',
  'booking.description': 'Opis',
  'booking.descriptionHint': 'Krótki opis Twojej firmy',
  'booking.themeColor': 'Kolor motywu',
  'booking.locale': 'Język strony',
  'booking.rules': 'Zasady rezerwacji',
  'booking.minHours': 'Minimalny czas',
  'booking.hours': 'godz.',
  'booking.minHoursHint': 'Z jakim wyprzedzeniem można zarezerwować',
  'booking.maxDays': 'Maks. głębokość',
  'booking.days': 'dni',
  'booking.maxDaysHint': 'Na ile dni do przodu dostępna jest rezerwacja',
  'booking.allowedServices': 'Usługi do rezerwacji online',
  'booking.allowedServicesHint': 'Wybierz usługi dostępne online. Jeśli nic nie wybrano — wszystkie są dostępne.',
  'booking.allowedStaff': 'Specjaliści do rezerwacji online',
  'booking.allowedStaffHint': 'Wybierz specjalistów dostępnych online. Jeśli nic nie wybrano — wszyscy są dostępni.',
  'booking.selectAll': 'Zaznacz wszystko',
  'booking.deselectAll': 'Odznacz wszystko',
  'booking.tabGeneral': 'Ogólne',
  'booking.tabServices': 'Usługi',
  'booking.tabProducts': 'Produkty',
  'booking.tabAfter': 'Po rezerwacji',
  'booking.serviceCategories': 'Kategorie usług',
  'booking.serviceCategoriesHint': 'Wybierz kategorie do rezerwacji online. Jeśli żadna — wszystkie dostępne.',
  'booking.productCategories': 'Kategorie produktów',
  'booking.productCategoriesHint': 'Wybierz kategorie do sprzedaży online. Jeśli żadna — wszystkie dostępne.',
  'booking.noCategoriesYet': 'Brak kategorii. Utwórz je w odpowiedniej sekcji.',
  'booking.mode': 'Tryb pracy',
  'booking.modeServices': 'Usługi',
  'booking.modeShop': 'Sklep',
  'booking.modeBoth': 'Oba',
  'booking.modeHint': 'Usługi — rezerwacja wizyt. Sklep — zamówienia online. Oba — usługi i produkty.',
  'booking.shopSettings': 'Ustawienia sklepu',
  'booking.shopMinOrder': 'Min. zamówienie',
  'booking.shopShowOutOfStock': 'Brak w magazynie',
  'booking.shopShowOutOfStockLabel': 'Pokaż produkty niedostępne',
  'booking.shopDelivery': 'Metody dostawy',
  'booking.deliveryPickup': 'Odbiór osobisty',
  'booking.deliveryNP': 'Nova Poshta',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Kurier',
  'booking.gallery': 'Galeria',
  'booking.galleryHint': 'Zdjęcia prac, wnętrza, produktów — do 10 zdjęć',
  'booking.galleryCount': 'zdjęć',
  'booking.promo': 'Baner promocyjny',
  'booking.promoEnable': 'Pokaż baner',
  'booking.promoText': 'Tekst promocji',
  'booking.promoPlaceholder': 'Np.: -20% na pierwszą wizytę',
  'booking.promoColor': 'Kolor',
  'booking.colorScheme': 'Schemat kolorów',
  'booking.bgColor': 'Kolor tła',
  'booking.presetLight': 'Jasny',
  'booking.presetDark': 'Ciemny',
  'booking.presetWarm': 'Ciepły',
  'booking.presetFresh': 'Świeży',
  'booking.presetRose': 'Różowy',
  'booking.presetPurple': 'Fioletowy',
  'booking.branding': 'Branding',
  'booking.logo': 'Logo',
  'booking.uploadLogo': 'Wgraj logo',
  'booking.changeLogo': 'Zmień logo',
  'booking.headerImage': 'Obraz nagłówka',
  'booking.uploadImage': 'Wgraj zdjęcie',
  'booking.changeImage': 'Zmień zdjęcie',
  'booking.logoTooLarge': 'Logo jest za duże. Maksymalnie 1 MB.',
  'booking.imageTooLarge': 'Obraz jest za duży. Maksymalnie 5 MB.',
  'booking.headerImageHint': 'Zdjęcie Twojego biznesu — salon, studio, sklep',
  'booking.contacts': 'Kontakty',
  'booking.contactsHint': 'Adres i godziny pracy pobierane z ustawień lokalizacji',
  'booking.address': 'Adres',
  'booking.addressHint': 'Ulica, numer, miasto',
  'booking.businessPhone': 'Telefon',
  'booking.website': 'Strona WWW',
  'booking.workingHours': 'Godziny pracy',
  'booking.workingHoursHint': 'Pon-Pt 9:00-18:00',
  'booking.afterBooking': 'Po rezerwacji',
  'booking.successMsg': 'Wiadomość potwierdzająca',
  'booking.successMsgHint': 'Np: Czekamy na Ciebie! Nie zapomnij dokumentu.',
  'booking.cancelPolicy': 'Polityka anulowania',
  'booking.cancelPolicyHint': 'Np: Anulowanie możliwe do 24 godzin przed wizytą',
  'booking.disableTitle': 'Wyłączyć rezerwację online?',
  'booking.disableText': 'Klienci nie będą mogli rezerwować online. Możesz ponownie włączyć w dowolnym momencie.',
  'booking.disableConfirm': 'Wyłącz',

  // ── Calendar months & days ──
  'months.0': 'Styczeń', 'months.1': 'Luty', 'months.2': 'Marzec',
  'months.3': 'Kwiecień', 'months.4': 'Maj', 'months.5': 'Czerwiec',
  'months.6': 'Lipiec', 'months.7': 'Sierpień', 'months.8': 'Wrzesień',
  'months.9': 'Październik', 'months.10': 'Listopad', 'months.11': 'Grudzień',
  'dow.0': 'Pn', 'dow.1': 'Wt', 'dow.2': 'Śr',
  'dow.3': 'Cz', 'dow.4': 'Pt', 'dow.5': 'So', 'dow.6': 'Nd',

  // ── Common UI ──
  'common.save': 'Zapisz',
  'common.saving': 'Zapisywanie...',
  'common.saved': 'Zapisano',
  'common.cancel': 'Anuluj',
  'common.delete': 'Usuń',
  'common.edit': 'Edytuj',
  'common.add': 'Dodaj',
  'common.search': 'Szukaj',
  'onboarding.title': 'Skonfiguruj swoją firmę',
  'onboarding.subtitle': '{done} z {total} kroków ukończonych',
  'onboarding.allDone': 'Wszystko skonfigurowane!',
  'onboarding.allDoneHint': 'Jesteś gotowy do pracy 💪',
  'onboarding.stepBusiness': 'Typ działalności wybrany',
  'onboarding.stepStaff': 'Dodaj pierwszego pracownika',
  'onboarding.stepService': 'Dodaj pierwszą usługę',
  'onboarding.stepAppointment': 'Utwórz pierwszą wizytę',
  'onboarding.stepClient': 'Dodaj pierwszego klienta',
  'onboarding.noStaffYet': 'Brak pracowników',
  'onboarding.noStaffHint': 'Dodaj pierwszego pracownika, aby zacząć przyjmować wizyty',
  'onboarding.goAddStaff': '+ Dodaj pracownika',
  'gsearch.placeholder': 'Szukaj klientów, wizyt, pracowników...',
  'gsearch.quickActions': 'Szybkie akcje',
  'gsearch.customers': 'Klienci',
  'gsearch.staff': 'Pracownicy',
  'gsearch.appointments': 'Wizyty',
  'gsearch.noResults': 'Nic nie znaleziono',
  'gsearch.goCalendar': 'Harmonogram — dziś',
  'gsearch.goClients': 'Baza klientów',
  'gsearch.goFinances': 'Finanse',
  'gsearch.goDashboard': 'Panel',
  'gsearch.newClient': 'Nowy klient',
  'common.close': 'Zamknij',
  'common.loading': 'Ładowanie...',
  'common.yes': 'Tak',
  'common.no': 'Nie',
  'common.and': 'i',
  'common.confirm': 'Potwierdź',
  'common.back': 'Wstecz',
  'common.next': 'Dalej',
  'common.create': 'Utwórz',
  'common.actions': 'Akcje',
  'common.name': 'Imię',
  'common.phone': 'Telefon',
  'common.email': 'Email',
  'common.date': 'Data',
  'common.time': 'Czas',
  'common.status': 'Status',
  'common.total': 'Razem',
  'common.price': 'Cena',
  'common.quantity': 'Ilość',
  'common.note': 'Notatka',
  'common.all': 'Wszystkie',
  'common.filter': 'Filtr',
  'common.export': 'Eksport',
  'common.shown': 'Pokazano',
  'common.of': 'z',
  'common.logout': 'Wyloguj',
  'common.profile': 'Profil',
  'common.settings': 'Ustawienia',
  'common.language': 'Język',

  // ── Clients page ──
  'clients.title': 'Baza klientów',
  'clients.subtitle': 'Zarządzanie kartami klientów',
  'clients.addClient': 'Dodaj klienta',
  'clients.import': 'Importuj',
  'import.title': 'Importuj klientów',
  'import.uploadHint': 'Załaduj plik z bazą klientów. Obsługiwane są Excel i CSV.',
  'import.maxRows': 'maksymalnie {max} wierszy',
  'import.tooManyRowsTitle': 'Plik jest zbyt duży',
  'import.tooManyRowsBody': 'Plik zawiera {count} wierszy — maksymalna liczba wierszy na import to {max}. Podziel plik na mniejsze części lub skontaktuj się z pomocą techniczną.',
  'import.selectFile': 'Wybierz plik',
  'import.downloadTemplate': 'Pobierz szablon',
  'import.or': 'lub',
  'import.rows': 'wierszy',
  'import.fieldName': 'Imię i nazwisko',
  'import.fieldLastName': 'Nazwisko',
  'import.fieldFirstName': 'Imię',
  'import.fieldPhone': 'Telefon',
  'import.fieldAdditionalPhone': 'Dodatkowy tel.',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Płeć',
  'import.fieldBirthday': 'Data urodzenia',
  'import.fieldCategory': 'Kategoria',
  'import.fieldCardNumber': 'Nr karty',
  'import.fieldNote': 'Notatka',

  'importProducts.btn': 'Importuj',
  'importProducts.btnTitle': 'Masowy import produktów z Excel/CSV',
  'importProducts.title': 'Import produktów',
  'importProducts.uploadHint': 'Wgraj plik Excel lub CSV z produktami. Pola wymagane: nazwa i cena sprzedaży.',
  'importProducts.maxRows': 'maksymalnie {max} wierszy',
  'importProducts.tooManyRowsTitle': 'Plik za duży',
  'importProducts.tooManyRowsBody': 'Plik zawiera {count} wierszy — max na jeden import to {max}. Podziel plik na mniejsze.',
  'importProducts.selectFile': 'Wybierz plik',
  'importProducts.downloadTemplate': 'Pobierz szablon',
  'importProducts.or': 'lub',
  'importProducts.rows': 'wierszy',
  'importProducts.fieldName': 'Nazwa',
  'importProducts.fieldSku': 'SKU',
  'importProducts.fieldCategory': 'Kategoria',
  'importProducts.fieldUnit': 'Jednostka',
  'importProducts.fieldMinStock': 'Min. stan',
  'importProducts.fieldSellPrice': 'Cena sprzedaży',
  'importProducts.statusCol': 'Status',
  'importProducts.mapHint': 'Dopasuj kolumny pliku do pól produktu. Pola wymagane oznaczone gwiazdką.',
  'importProducts.notMapped': 'nie wybrano',
  'importProducts.back': 'Wstecz',
  'importProducts.next': 'Dalej',
  'importProducts.startOver': 'Inny plik',
  'importProducts.willImport': 'zostanie zaimportowanych',
  'importProducts.willSkip': 'zostanie pominiętych',
  'importProducts.newCategories': 'nowych kategorii',
  'importProducts.newCategoriesWarning': 'Plik zawiera kategorie, które jeszcze nie istnieją — zostaną utworzone automatycznie podczas importu.',
  'importProducts.errMissingName': 'Pusta nazwa',
  'importProducts.errInvalidPrice': 'Nieprawidłowa cena',
  'importProducts.errInvalidMinStock': 'Nieprawidłowy min. stan',
  'importProducts.errSkuExisting': 'SKU już istnieje',
  'importProducts.previewTruncated': 'Pokazano pierwszych 100 z {count}',
  'importProducts.importing': 'Importowanie...',
  'importProducts.importBtn': 'Importuj {count}',
  'importProducts.doneTitle': 'Zaimportowano {count} produktów',
  'importProducts.doneNewCategories': 'Utworzono {count} nowych kategorii',
  'importProducts.doneSkipped': 'Pominięto {count} wierszy',
  'importProducts.close': 'Zamknij',
  'importProducts.toastSuccess': 'Produkty zaimportowane',

  'importServices.btn': 'Importuj',
  'importServices.btnTitle': 'Masowy import usług z Excel/CSV',
  'importServices.title': 'Import usług',
  'importServices.uploadHint': 'Wgraj plik Excel lub CSV z usługami. Wymagane: nazwa i cena. Domyślny czas trwania: 30 min.',
  'importServices.maxRows': 'maksymalnie {max} wierszy',
  'importServices.tooManyRowsTitle': 'Plik za duży',
  'importServices.tooManyRowsBody': 'Plik zawiera {count} wierszy — max na jeden import to {max}.',
  'importServices.selectFile': 'Wybierz plik',
  'importServices.downloadTemplate': 'Pobierz szablon',
  'importServices.or': 'lub',
  'importServices.rows': 'wierszy',
  'importServices.fieldName': 'Nazwa',
  'importServices.fieldGroup': 'Grupa',
  'importServices.fieldPrice': 'Cena',
  'importServices.fieldDuration': 'Czas (min)',
  'importServices.statusCol': 'Status',
  'importServices.mapHint': 'Dopasuj kolumny pliku do pól usługi. Pola wymagane oznaczone gwiazdką.',
  'importServices.notMapped': 'nie wybrano',
  'importServices.back': 'Wstecz',
  'importServices.next': 'Dalej',
  'importServices.startOver': 'Inny plik',
  'importServices.willImport': 'zostanie zaimportowanych',
  'importServices.willSkip': 'zostanie pominiętych',
  'importServices.newGroups': 'nowych grup',
  'importServices.newGroupsWarning': 'Plik zawiera grupy, które jeszcze nie istnieją — zostaną utworzone automatycznie.',
  'importServices.errMissingName': 'Pusta nazwa',
  'importServices.errInvalidPrice': 'Nieprawidłowa cena',
  'importServices.errInvalidDuration': 'Nieprawidłowy czas (1-1440 min)',
  'importServices.errNameExisting': 'Usługa już istnieje',
  'importServices.previewTruncated': 'Pokazano pierwszych 100 z {count}',
  'importServices.importing': 'Importowanie...',
  'importServices.importBtn': 'Importuj {count}',
  'importServices.doneTitle': 'Zaimportowano {count} usług',
  'importServices.doneNewGroups': 'Utworzono {count} nowych grup',
  'importServices.doneSkipped': 'Pominięto {count} wierszy',
  'importServices.close': 'Zamknij',
  'importServices.toastSuccess': 'Usługi zaimportowane',

  'import.skip': 'pomiń',
  'import.phoneRequired': 'Pole "Telefon" jest wymagane',
  'import.preview': 'Podgląd',
  'import.back': 'Wstecz',
  'import.adjustColumns': 'Dostosuj kolumny',
  'import.newClients': 'Nowi klienci',
  'import.duplicates': 'Duplikaty (pominięte)',
  'import.duplicate': 'duplikat',
  'import.new': 'nowy',
  'import.status': 'Status',
  'import.andMore': '...i jeszcze {count}',
  'import.importing': 'Importowanie...',
  'import.importBtn': 'Importuj ({count})',
  'import.success': 'Zaimportowano {count} klientów!',
  'import.skippedDuplicates': '{count} duplikatów pominiętych',
  'import.error': 'Błąd importu',
  'import.close': 'Zamknij',
  'helpPage.title': 'Help',
  'helpPage.subtitle': 'Guides and instructions for Systemic CRM',
  'clients.searchPlaceholder': 'Szukaj po imieniu, telefonie, email, numerze karty...',
  'clients.allCategories': 'Wszystkie kategorie',
  'clients.clientsCount': 'Klientów',
  'clients.grid': 'Siatka',
  'clients.list': 'Lista',
  'clients.deleteTitle': 'Usunąć klienta?',
  'clients.deleteMessage': 'Zamierzasz usunąć kartę klienta',
  'clients.cannotDeleteTitle': 'Nie można usunąć',
  'clients.cannotDeleteMessage': 'Klient ma wizyty lub historię finansową i nie może zostać usunięty',
  'clients.duplicatePhone': 'Klient z tym numerem telefonu już istnieje',
  'clients.duplicatePhoneWithName': 'Klient z tym telefonem już istnieje: {name}',
  'clients.openExisting': 'Otwórz klienta',
  'clients.understood': 'Rozumiem',
  'clients.deleteWarning': 'Ta akcja jest nieodwracalna. Wszystkie dane klienta zostaną utracone.',

  // ── Delete modal ──
  'delete.title': 'Potwierdź usunięcie',
  'delete.message': 'Zamierzasz usunąć rekord',
  'delete.confirm': 'Tak, usuń',
  'delete.warning': 'Ta akcja jest nieodwracalna. Wszystkie dane zostaną utracone.',

  // ── Sidebar ──
  'sidebar.crmSystem': 'System CRM',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Logowanie',
  'login.setupTitle': 'Konfiguracja systemu',
  'login.setupSubtitle': 'Utwórz konto administratora',
  'login.subtitle': 'Wprowadź dane logowania',
  'login.email': 'Email',
  'login.password': 'Hasło',
  'login.submit': 'Zaloguj się',
  'login.setupSubmit': 'Utwórz administratora',
  'login.wait': 'Proszę czekać…',
  'login.forgotPassword': 'Zapomniałeś hasła?',
  'login.resetTitle': 'Resetowanie hasła',
  'login.resetSubtitle': 'Podaj email — wyślemy instrukcje resetowania',
  'login.resetSend': 'Wyślij',
  'login.resetSentHint': 'Sprawdź swoją skrzynkę — wysłaliśmy instrukcje',
  'login.backToLogin': 'Powrót do logowania',
  'login.nameLabel': 'Imię',
  'login.namePlaceholder': 'Twoje imię',
  'login.businessLabel': 'Nazwa firmy',
  'login.businessPlaceholder': 'Mój salon / sklep / studio',
  'login.errorEnterBusiness': 'Wprowadź nazwę firmy',
  'login.businessTypeLabel': 'Typ działalności',
  'login.businessTypePlaceholder': 'Wybierz typ działalności...',
  'login.errorSelectBusinessType': 'Wybierz typ działalności',
  'login.showPassword': 'Pokaż hasło',
  'login.hidePassword': 'Ukryj hasło',
  'login.errorInvalidCreds': 'Nieprawidłowy email lub hasło',
  'login.errorTooMany': 'Zbyt wiele prób. Spróbuj później.',
  'login.errorGeneric': 'Błąd logowania: ',
  'login.errorEnterName': 'Wprowadź imię',
  'login.errorEnterEmail': 'Wprowadź email',
  'login.errorMinPassword': 'Hasło musi mieć co najmniej 6 znaków',
  'login.errorSetup': 'Błąd: ',
  'login.tabLogin': 'Logowanie',
  'login.tabRegister': 'Rejestracja',
  'login.registerTitle': 'Utwórz konto',
  'login.registerSubtitle': '7 dni za darmo, wszystkie moduły w cenie',
  'login.registerSubmit': 'Zarejestruj się',
  'login.registerSuccess': 'Konto utworzone! Logowanie...',
  'login.errorEmailExists': 'Ten email jest już zarejestrowany',
  'login.errorRegister': 'Błąd rejestracji: ',
  'login.confirmPassword': 'Potwierdź hasło',
  'login.errorPasswordMismatch': 'Hasła nie pasują do siebie',
  'login.agreeTerms': 'Rejestrując się, akceptujesz',
  'login.agreeCheckbox': 'Akceptuję',
  'login.errorAgreeTerms': 'Musisz zaakceptować regulamin',
  'login.terms': 'Regulamin',
  'login.privacy': 'Politykę prywatności',

  // ── Blocked ──
  'blocked.title': 'Konto zablokowane',
  'blocked.desc': 'Skontaktuj się z administratorem, aby przywrócić dostęp',
  'blocked.trialExpired': 'Okres próbny zakończony',
  'blocked.trialExpiredDesc': 'Wybierz plan, aby kontynuować',
  'blocked.paymentOverdue': 'Subskrypcja przeterminowana',
  'blocked.paymentOverdueDesc': 'Twoja subskrypcja wygasła. Odnów ją, aby kontynuować pracę.',
  'blocked.subscriptionExpiredDesc': 'Twoja subskrypcja wygasła. Odnów ją, aby kontynuować pracę.',
  'blocked.contact': 'Skontaktuj się z pomocą',
  'blocked.logout': 'Wyloguj się',

  // ── My Plan ──
  'myPlan.title': 'Mój Plan',
  'myPlan.subtitle': 'Zarządzanie subskrypcją',
  'myPlan.loadError': 'Nie udało się załadować danych planu',
  'myPlan.trial': 'Próbny',
  'myPlan.active': 'Aktywny',
  'myPlan.trialExpired': 'Okres próbny wygasł',
  'myPlan.blocked': 'Zablokowany',
  'myPlan.daysLeft': 'dni pozostało',
  'myPlan.month': 'mies',
  'myPlan.year': 'rok',
  'myPlan.orYearly': 'lub',
  'myPlan.chooseBillingPeriod': 'wybierz okres płatności',
  'myPlan.periodMonthly': 'Miesięcznie',
  'myPlan.periodYearly': 'Rocznie',
  'myPlan.yearlySaving': 'oszczędzasz {n} ₴ vs miesięcznie',
  'myPlan.monthlyTotal': '{n} ₴/rok',
  'myPlan.proceedToPayment': 'Przejdź do płatności',
  'myPlan.cancel': 'Anuluj',
  'myPlan.oldRateTitle': 'Masz starszą stawkę',
  'myPlan.oldRateText': 'Obecnie płacisz {old} ₴; aktualna stawka dla {plan} to {new} ₴. Możesz zachować starą stawkę bezterminowo lub przejść na nową.',
  'myPlan.upgradeRate': 'Przejdź na nową stawkę',
  'myPlan.users': 'Użytkownicy',
  'myPlan.locations': 'Lokalizacje',
  'myPlan.availablePlans': 'Dostępne plany',
  'myPlan.popular': 'Popularny',
  'myPlan.usersIncl': 'użytkowników',
  'myPlan.locationsIncl': 'lokalizacji',
  'myPlan.allModules': 'Wszystkie 46 modułów',
  'myPlan.trialActive': 'Próba aktywna',
  'myPlan.currentPlan': 'Bieżący plan',
  'myPlan.upgrade': 'Wybierz plan',
  'myPlan.changePlan': 'Zmień plan',
  'myPlan.trialHint': 'Po zakończeniu okresu próbnego wybierz plan, aby kontynuować. Wszystkie dane zostaną zachowane.',
  'myPlan.limitUsers': 'Osiągnięto limit użytkowników. Zmień plan, aby dodać więcej.',
  'myPlan.limitLocations': 'Osiągnięto limit lokalizacji. Zmień plan, aby dodać więcej.',
  'myPlan.cancelSubscription': 'Anuluj subskrypcję',
  'myPlan.cancelledNotice': 'Subskrypcja anulowana. Plan pozostaje aktywny do końca opłaconego okresu.',
  'myPlan.cancelTitle': 'Anulować subskrypcję?',
  'myPlan.cancelDescription': 'Twój plan pozostanie aktywny do końca opłaconego okresu. Następnie konto zostanie przeniesione na plan próbny.',
  'myPlan.cancelReasonLabel': 'Powód anulowania (opcjonalnie)',
  'myPlan.cancelReasonPlaceholder': 'Powiedz nam, dlaczego zdecydowałeś się anulować...',
  'myPlan.confirmCancel': 'Tak, anuluj',
  'myPlan.keepSubscription': 'Zachowaj subskrypcję',
  'myPlan.cancelError': 'Błąd anulowania',
  'myPlan.subscriptionExpired': 'wygasła',

  // ── Checkout (post-registration) ──
  'checkout.title': 'Twoje konto jest gotowe!',
  'checkout.subtitle': 'Wybierz jak zacząć z Systemic CRM',
  'checkout.recommended': 'Zalecane',
  'checkout.payNow': 'Zapłać i zacznij',
  'checkout.trialTitle': 'Bezpłatny okres próbny',
  'checkout.days': 'dni',
  'checkout.trialFeature1': 'Pełny dostęp do wszystkich funkcji',
  'checkout.trialFeature2': 'Bez zobowiązań',
  'checkout.trialFeature3': 'Dane zostają zachowane po płatności',
  'checkout.tryFree': 'Wypróbuj za darmo',

  // ── Dashboard ──
  'dash.title': 'Panel',
  'dash.myOffice': 'Mój gabinet',
  'dash.subtitle': 'Ekran główny',
  'dash.personalStats': 'Statystyki osobiste',
  'dash.todayAppointments': 'Wizyty dzisiaj',
  'dash.completed': 'zakończone',
  'dash.todayRevenue': 'Przychód dzisiaj',
  'dash.clientsCount': 'Klientów',
  'dash.newThisMonth': 'w tym miesiącu',
  'dash.unread': 'Nieprzeczytane',
  'dash.todaySchedule': 'Grafik na dziś',
  'dash.allAppointments': 'Wszystkie wizyty',
  'dash.noAppointmentsToday': 'Brak wizyt na dziś',
  'dash.moreAppointments': 'wizyt',
  'dash.weekRevenue': 'Przychód tygodniowy',
  'dash.needsAttention': 'Wymaga uwagi',
  'dash.unreadMessages': 'nieprzeczytanych wiadomości',
  'dash.lowStock': 'niski stan magazynowy',
  'dash.topClients': 'Top klienci (miesiąc)',
  'dash.noPaymentsThisMonth': 'Brak płatności w tym miesiącu',
  'dash.birthdays': 'Urodziny',
  'dash.noBirthdaysThisWeek': 'Brak urodzin w tym tygodniu',
  'dash.today': 'Dzisiaj!',
  'dash.tomorrow': 'Jutro',
  'dash.inDays': 'Za {n} dn.',
  'dash.congratulate': 'Pogratuluj',
  'dash.atRisk': 'Zagrożeni utratą',
  'dash.allClientsActive': 'Wszyscy klienci są aktywni',
  'dash.daysWithoutVisit': 'dni bez wizyty',
  'dash.write': 'Napisz',
  'dash.todayOrderSales': 'Sprzedaż produktów',
  'dash.serviceSales': 'Sprzedaż usług',
  'dash.appointmentsToday': 'wizyt dziś',
  'dash.ordersToday': 'zamówień dziś',
  'dash.activeOrders': 'aktywnych',
  'dash.recentOrders': 'Ostatnie zamówienia',
  'dash.allOrders': 'Wszystkie zamówienia',
  'dash.items': 'pozycji',
  'dash.statusWaiting': 'Oczekuje',
  'dash.statusConfirmed': 'Zakończone',
  'dash.statusArrived': 'Przyszedł',
  'dash.statusNoShow': 'Nie przyszedł',
  'dash.dowSun': 'Nd', 'dash.dowMon': 'Pn', 'dash.dowTue': 'Wt',
  'dash.dowWed': 'Śr', 'dash.dowThu': 'Cz', 'dash.dowFri': 'Pt', 'dash.dowSat': 'So',

  // ── Profile modal ──
  'profile.title': 'Profil',
  'profile.name': 'Imię',
  'profile.namePlaceholder': 'Twoje imię',
  'profile.email': 'Email',
  'profile.changePassword': 'Zmień hasło',
  'profile.passwordHint': 'Zostaw pola puste, jeśli nie chcesz zmieniać hasła',
  'profile.currentPassword': 'Obecne hasło',
  'profile.newPassword': 'Nowe hasło',
  'profile.newPasswordPlaceholder': 'Minimum 6 znaków',
  'profile.confirmPassword': 'Potwierdź hasło',
  'profile.confirmPasswordPlaceholder': 'Powtórz nowe hasło',
  'profile.saved': 'Zapisano!',
  'profile.passwordChanged': 'Hasło zmienione',
  'profile.homePage': 'Strona główna',
  'profile.startingLocation': 'Początkowa lokalizacja',
  'profile.startingLocationAuto': 'Automatycznie (domyślnie)',
  'profile.homeBizMonitor': 'Monitor Biznesu',
  'profile.homeDashboard': 'Panel',
  'profile.homeCalendar': 'Kalendarz',
  'profile.homeClients': 'Klienci',
  'profile.homePos': 'Sklep',
  'profile.homeOrders': 'Zamówienia',
  'profile.homeFinances': 'Finanse',
  'profile.homeCommunication': 'Wiadomości',
  'profile.homeStaff': 'Pracownicy',
  'profile.homeStock': 'Stany magazynowe',
  'profile.homePurchases': 'Zakupy',
  'profile.homeProduction': 'Produkcja',
  'profile.homeSalary': 'Wynagrodzenia',
  'profile.homeCashRegister': 'Kasa',
  'profile.homeReports': 'Raporty',
  'profile.homeFinResult': 'Wynik finansowy',
  'profile.profileUpdated': 'Profil zaktualizowany',
  'profile.errorEnterName': 'Wprowadź imię',
  'profile.errorEnterCurrentPassword': 'Wprowadź obecne hasło',
  'profile.errorMinPassword': 'Nowe hasło musi mieć co najmniej 6 znaków',
  'profile.errorPasswordMismatch': 'Hasła nie są zgodne',
  'profile.errorWrongPassword': 'Nieprawidłowe obecne hasło',
  'profile.errorTooMany': 'Zbyt wiele prób. Spróbuj później.',
  'profile.errorGeneric': 'Błąd: ',

  // ── Calendar page ──
  'cal.monthGen.0': 'stycznia', 'cal.monthGen.1': 'lutego', 'cal.monthGen.2': 'marca',
  'cal.monthGen.3': 'kwietnia', 'cal.monthGen.4': 'maja', 'cal.monthGen.5': 'czerwca',
  'cal.monthGen.6': 'lipca', 'cal.monthGen.7': 'sierpnia', 'cal.monthGen.8': 'września',
  'cal.monthGen.9': 'października', 'cal.monthGen.10': 'listopada', 'cal.monthGen.11': 'grudnia',
  'cal.weekday.0': 'Niedziela', 'cal.weekday.1': 'Poniedziałek', 'cal.weekday.2': 'Wtorek',
  'cal.weekday.3': 'Środa', 'cal.weekday.4': 'Czwartek', 'cal.weekday.5': 'Piątek', 'cal.weekday.6': 'Sobota',
  'cal.today': 'Dzisiaj',
  'cal.daySchedule': 'Grafik na dzień',
  'cal.appointments': 'wizyt',
  'cal.working': 'Pracuje',
  'cal.dayOff': 'Wolne',
  'cal.noStaffWorking': 'Brak pracujących pracowników w tym dniu',
  'cal.clickToAdd': 'Kliknij na godzinę, aby dodać wizytę',
  'cal.service': 'Usługa',
  'cal.paid': 'Opłacone',
  'cal.unpaid': 'Nieopłacone',
  'cal.batchBooking': 'Rezerwacja grupowa',
  'cal.batchCreated': 'Utworzono wizyt',
  'cal.fiscalReceiptCreated': 'Paragon fiskalny utworzony',
  'cal.fiscalReceiptError': 'Błąd fiskalizacji',
  'cal.refundRecorded': 'Zwrot zarejestrowany',
  'cal.cannotDeletePaid': 'Nie można usunąć opłaconej wizyty. Najpierw dokonaj zwrotu.',

  // ── Appointment modal ──
  'apt.newTitle': 'Nowa wizyta',
  'apt.editTitle': 'Edycja wizyty',
  'apt.closeEsc': 'Zamknij (Esc)',
  'apt.client': 'Klient',
  'apt.nameOrPhone': 'Imię lub telefon',
  'apt.startTyping': 'Zacznij pisać...',
  'apt.phone': 'Telefon',
  'apt.viewProfile': 'Przejdź do profilu',
  'apt.dateAndTime': 'Data i czas',
  'apt.date': 'Data',
  'apt.startTime': 'Początek',
  'apt.endTime': 'Koniec',
  'apt.servicesAndPayment': 'Usługi i płatność',
  'apt.pricelist': 'Cennik',
  'apt.addService': 'Dodaj usługę',
  'apt.standardPrice': 'Cena standardowa',
  'apt.tariffPlan': 'Plan taryfowy',
  'apt.min': 'min',
  'apt.discount': 'Rabat',
  'apt.uah': 'UAH',
  'apt.total': 'Razem',
  'apt.toPay': 'Do zapłaty',
  'apt.paymentMethod': 'Metoda płatności',
  'apt.cash': 'Gotówka',
  'apt.terminal': 'Terminal',
  'apt.transfer': 'Przelew',
  'apt.paid': 'Opłacone',
  'apt.clientGave': 'Klient dał',
  'apt.change': 'Reszta',
  'apt.note': 'Notatka',
  'apt.author': 'Autor',
  'apt.notePlaceholder': 'Komentarz do wizyty...',
  'apt.notesPlaceholder': 'Komentarz do wizyty...',
  'apt.book': 'Zarezerwuj',
  'apt.saveChanges': 'Zapisz zmiany',
  'apt.cancel': 'Anuluj',
  'apt.delete': 'Usuń',
  'apt.printBill': 'Rachunek',
  'apt.deleteTitle': 'Usunąć wizytę?',
  'apt.deleteMessage': 'Zamierzasz usunąć tę wizytę. Tej akcji nie można cofnąć.',
  'apt.payBtn': 'Zapłać',
  'apt.confirmPayment': 'Potwierdzić płatność?',
  'apt.refund': 'Zwrot',
  'apt.refundTitle': 'Zwrot środków',
  'apt.refundMessage': 'Czy na pewno chcesz zwrócić środki za tę wizytę?',
  'apt.refundWarning': 'Tej akcji nie można cofnąć.',
  'apt.confirmRefund': 'Potwierdź zwrot',
  'apt.refunded': 'Zwrócono',
  'apt.back': 'Wstecz',
  'apt.batchBooking': 'Rezerwacja grupowa',
  'apt.createMultiple': 'Utwórz kilka',
  'apt.materials': 'Materiały',
  'apt.product': 'Produkt',
  'apt.qty': 'Ilość',
  'apt.pcs': 'szt',
  'apt.add': 'Dodaj',
  'apt.noProductsAdded': 'Nie dodano produktów',
  'apt.noProductsInStock': 'Brak produktów w magazynie',
  'apt.notEnough': 'Niewystarczająco',
  'apt.notEnoughInStock': 'Niewystarczająco w magazynie',
  'apt.notEnoughStock': 'Niewystarczający stan',
  'apt.appointmentNote': 'Notatka do wizyty',
  'apt.clientDocs': 'Dokumenty klienta',
  'apt.addDocument': 'Dodaj dokument',
  'apt.docName': 'Nazwa dokumentu',
  'apt.docNamePlaceholder': 'Wprowadź nazwę...',
  'apt.docText': 'Treść dokumentu',
  'apt.noDocsYet': 'Brak dokumentów',
  'apt.attachFile': 'Załącz plik',
  'apt.maxFileSize': 'Maks. rozmiar pliku: 2 MB',
  'apt.errClientName': 'Wprowadź imię klienta',
  'apt.errClientPhone': 'Wprowadź telefon klienta',
  'apt.errDate': 'Wybierz datę',
  'apt.errDiscount': 'Rabat nie może przekraczać kwoty',
  'apt.errDayOff': 'Specjalista nie pracuje w tym dniu',
  'apt.errOutsideWorkingHours': 'Czas jest poza godzinami pracy ({start} – {end})',
  'apt.errOverlap': 'Czas nakłada się z wizytą {start}–{end} ({client})',
  'apt.workingHoursHint': 'Godziny pracy: {start} – {end}',
  'apt.statusWaiting': 'Oczekuje',
  'apt.statusConfirmed': 'Zakończone',
  'apt.statusArrived': 'Przyszedł',
  'apt.statusNoShow': 'Nie przyszedł',

  // ── Batch appointment modal ──
  'batchApt.title': 'Rezerwacja grupowa',
  'batchApt.subtitle': 'Tworzenie kilku wizyt jednocześnie',
  'batchApt.closeEsc': 'Zamknij (Esc)',
  'batchApt.client': 'Klient',
  'batchApt.nameOrPhone': 'Imię lub telefon',
  'batchApt.phone': 'Telefon',
  'batchApt.staffMember': 'Specjalista',
  'batchApt.service': 'Usługa',
  'batchApt.discount': 'Rabat',
  'batchApt.uah': 'UAH',
  'batchApt.addDate': 'Dodaj datę',
  'batchApt.delete': 'Usuń',
  'batchApt.entries': 'wizyt',
  'batchApt.entrySingle': 'wizyta',
  'batchApt.entryPlural': 'wizyt',
  'batchApt.create': 'Utwórz',
  'batchApt.cancel': 'Anuluj',
  'batchApt.errClientName': 'Wprowadź imię klienta',
  'batchApt.errClientPhone': 'Wprowadź telefon klienta',
  'batchApt.errDiscount': 'Rabat nie może przekraczać kwoty',
  'batchApt.errNoRows': 'Dodaj co najmniej jedną wizytę',

  // ── Customer card ──
  'custCard.edit': 'Edytuj',
  'custCard.delete': 'Usuń',
  'custCard.book': 'Zarezerwuj',
  'custCard.order': 'Zamówienie',
  'custCard.sell': 'Sprzedaj',
  'custCard.sellProduct': 'Produkt',
  'custCard.sellService': 'Usługa',
  'custCard.sellSubscription': 'Abonament',
  'custCard.openFinances': 'Finanse',
  'custCard.paid': 'Opłacone',
  'custCard.sold': 'Sprzedano',
  'custCard.balance': 'Saldo',
  'custCard.importance': 'Ważność',
  'custCard.forbidOnlineBooking': 'Zakaz rezerwacji online',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'Nie znaleziono klientów',
  'custGrid.tryChangeSearch': 'Spróbuj zmienić zapytanie lub filtr kategorii',

  // ── Customer modal ──
  'custModal.newCustomer': 'Nowy klient',
  'custModal.editCustomer': 'Edycja klienta',
  'custModal.closeEsc': 'Zamknij (Esc)',
  'custModal.tabMain': 'Główne',
  'custModal.tabDetails': 'Szczegóły',
  'custModal.tabVisits': 'Wizyty',
  'custModal.tabFinancial': 'Finanse',
  'custModal.tabAnalytics': 'Analityka',
  'custModal.tabNotes': 'Notatki',
  'custModal.tabDocuments': 'Dokumenty',
  'custModal.personalData': 'Dane osobowe',
  'custModal.fullName': 'Imię i nazwisko',
  'custModal.fullNamePlaceholder': 'Wprowadź pełne imię',
  'custModal.mobilePhone': 'Telefon komórkowy',
  'custModal.additionalPhone': 'Dodatkowy telefon',
  'custModal.birthDate': 'Data urodzenia',
  'custModal.day': 'Dzień',
  'custModal.month': 'Miesiąc',
  'custModal.year': 'Rok',
  'custModal.gender': 'Płeć',
  'custModal.genderMale': 'Mężczyzna',
  'custModal.genderFemale': 'Kobieta',
  'custModal.genderOther': 'Inne',
  'custModal.cardNumber': 'Numer karty',
  'custModal.profilePhoto': 'Zdjęcie profilowe',
  'custModal.uploadPhoto': 'Wgraj zdjęcie',
  'custModal.changePhoto': 'Zmień zdjęcie',
  'custModal.deletePhoto': 'Usuń zdjęcie',
  'custModal.avatar': 'Awatar',
  'custModal.categoryAndClassification': 'Kategoria i klasyfikacja',
  'custModal.category': 'Kategoria',
  'custModal.importanceLabel': 'Ważność',
  'custModal.discountLabel': 'Rabat',
  'custModal.discountRange': '0–100%',
    'custModal.referral': 'Referral program',
  'custModal.referredBy': 'Referred by',
  'custModal.referredByHint': 'Select the client who referred this person',
'custModal.restrictions': 'Ograniczenia',
  'custModal.forbidOnlineBooking': 'Zakaz rezerwacji online',
  'custModal.forbidOnlineBookingDesc': 'Klient nie będzie mógł zarezerwować samodzielnie',
  'custModal.telegramReminders': 'Przypomnienia Telegram',
  'custModal.telegramConnected': 'Telegram podłączony',
  'custModal.setupTelegramBot': 'Skonfiguruj bota Telegram',
  'custModal.sendLinkToCustomer': 'Wyślij link do klienta',
  'custModal.send': 'Wyślij',
  'custModal.sending': 'Wysyłanie...',
  'custModal.specifyPhoneFirst': 'Najpierw podaj telefon',
  'custModal.save': 'Zapisz',
  'custModal.cancel': 'Anuluj',
  'custModal.close': 'Zamknij',
  'custModal.editBtn': 'Edytuj',
  'custModal.viewCustomer': 'Karta klienta',
  'custModal.back': 'Wstecz',
  'custModal.next': 'Dalej',
  'custModal.nameRequired': 'Imię jest wymagane',
  'custModal.phoneRequired': 'Telefon jest wymagany',
  'custModal.nameDuplicate': 'Klient o tej nazwie już istnieje',
  'custModal.phoneDuplicate': 'Klient z tym numerem telefonu już istnieje',
  'custModal.note': 'Notatka',
  'custModal.notePlaceholder': 'Dodaj notatkę...',
  'custModal.comments': 'Komentarze',
  'custModal.commentsPlaceholder': 'Napisz komentarz...',
  'custModal.writeMessagePlaceholder': 'Napisz wiadomość...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Historia wizyt',
  'custModal.totalVisits': 'Łącznie wizyt',
  'custModal.lastVisit': 'Ostatnia wizyta',
  'custModal.visitFrequency': 'Częstotliwość wizyt',
  'custModal.days': 'dn.',
  'custModal.visitsByMonth': 'Wizyty wg miesięcy',
  'custModal.noVisitsYet': 'Brak wizyt',
  'custModal.tabOrders': 'Zakupy',
  'custModal.orderHistory': 'Historia zamówień',
  'custModal.ordersTotal': 'Zamówień',
  'custModal.ordersDelivered': 'Dostarczono',
  'custModal.ordersPaid': 'Zapłacono',
  'custModal.noOrdersYet': 'Brak zakupów',
  'custModal.posSalesCount': 'Sprzedaży',
  'custModal.orderStatusNew': 'Nowe',
  'custModal.orderStatusConfirmed': 'Potwierdzone',
  'custModal.orderStatusPacked': 'Spakowane',
  'custModal.orderStatusShipped': 'Wysłane',
  'custModal.orderStatusDelivered': 'Dostarczone',
  'custModal.orderStatusCancelled': 'Anulowane',
  'custModal.posCompleted': 'Zakończone',
  'custModal.posSourceLabel': 'Sklep',
  'custModal.orderSourceLabel': 'Zamówienie',
  'custModal.subscriptionsLabel': 'Abonamenty',
  'custModal.completed': 'Zakończone',
  'custModal.noShow': 'Nie przyszedł',
  'custModal.statusWaiting': 'Oczekuje',
  'custModal.statusConfirmed': 'Zakończone',
  'custModal.statusArrived': 'Przyszedł',
  'custModal.statusNoShow': 'Nie przyszedł',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Wskaźniki finansowe',
  'custModal.finPaid': 'Opłacone',
  'custModal.finBalance': 'Saldo',
  'custModal.avgCheck': 'Śr. rachunek',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Naliczenia',
  'custModal.noChargesYet': 'Brak naliczeń',
  'custModal.noPaymentsYet': 'Brak płatności',
  'custModal.date': 'Data',
  'custModal.dateTime': 'Data/czas',
  'custModal.service': 'Usługa',
  'custModal.serviceLabel': 'Usługa',
  'custModal.price': 'Cena',
  'custModal.discount': 'Rabat',
  'custModal.total': 'Razem',
  'custModal.paidLabel': 'Płatność',
  'custModal.payment': 'Płatność',
  'custModal.paymentMethod': 'Metoda płatności',
  'custModal.amount': 'Kwota',
  'custModal.totalAmount': 'Kwota łączna',
  'custModal.methodCash': 'Gotówka',
  'custModal.methodCard': 'Karta',
  'custModal.methodTransfer': 'Przelew',
  'custModal.cash': 'Gotówka',
  'custModal.terminal': 'Terminal',
  'custModal.transfer': 'Przelew',
  'custModal.online': 'Online',
  'custModal.refund': 'Zwrot',
  'custModal.sold': 'Sprzedano',
  'custModal.finCharged': 'Naliczono',
  'custModal.serviceCharges': 'Naliczenia za usługi',
  'custModal.productCharges': 'Naliczenia za produkty',
  'custModal.productLabel': 'Produkt',
  'custModal.noProductChargesYet': 'Brak sprzedaży produktów',
  'custModal.time': 'Czas',
  'custModal.unknown': 'Nieznane',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Ulubiony specjalista',
  'custModal.favoriteService': 'Ulubiona usługa',
  'custModal.favoriteProduct': 'Ulubiony produkt',
  'custModal.lastActivity': 'Ostatnia aktywność',
  'custModal.spendingBreakdown': 'Podział wydatków',
  'custModal.purchasesByMonth': 'Zakupy miesięczne',
  'custModal.churn_low': 'Klient aktywny',
  'custModal.churn_medium': 'Ryzyko odejścia — dawno nie odwiedzał',
  'custModal.churn_high': 'Wysokie ryzyko odejścia — potrzebny kontakt',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Dokumenty klienta',
  'custModal.addDocument': 'Dodaj dokument',
  'custModal.addDoc': 'Dodaj',
  'custModal.addBtn': 'Dodaj',
  'custModal.noDocumentsYet': 'Brak dokumentów',
  'custModal.docName': 'Nazwa dokumentu',
  'custModal.docNamePlaceholder': 'Wprowadź nazwę...',
  'custModal.docNameRequired': 'Wprowadź nazwę dokumentu',
  'custModal.docText': 'Treść dokumentu',
  'custModal.docTextPlaceholder': 'Wprowadź treść...',
  'custModal.attachFile': 'Załącz plik',
  'custModal.fileUpTo2MB': 'Plik do 2 MB',
  'custModal.fileTooLarge': 'Plik za duży (maks. 2 MB)',
  'custModal.emptyDocument': 'Pusty dokument',
  'custModal.deleteDoc': 'Usuń dokument',
  'custModal.deleteThisDoc': 'Usunąć ten dokument?',
  'custModal.deleteBtn': 'Usuń',
  'custModal.download': 'Pobierz',
  'custModal.copy': 'Kopiuj',
  'custModal.specifyPhoneForDocs': 'Podaj telefon dla dokumentów',
  'custModal.loading': 'Ładowanie...',
  'custModal.error': 'Błąd',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'Styczeń', 'custModal.monthFeb': 'Luty', 'custModal.monthMar': 'Marzec',
  'custModal.monthApr': 'Kwiecień', 'custModal.monthMay': 'Maj', 'custModal.monthJun': 'Czerwiec',
  'custModal.monthJul': 'Lipiec', 'custModal.monthAug': 'Sierpień', 'custModal.monthSep': 'Wrzesień',
  'custModal.monthOct': 'Październik', 'custModal.monthNov': 'Listopad', 'custModal.monthDec': 'Grudzień',
  'custModal.monthAbbrJan': 'Sty', 'custModal.monthAbbrFeb': 'Lut', 'custModal.monthAbbrMar': 'Mar',
  'custModal.monthAbbrApr': 'Kwi', 'custModal.monthAbbrMay': 'Maj', 'custModal.monthAbbrJun': 'Cze',
  'custModal.monthAbbrJul': 'Lip', 'custModal.monthAbbrAug': 'Sie', 'custModal.monthAbbrSep': 'Wrz',
  'custModal.monthAbbrOct': 'Paź', 'custModal.monthAbbrNov': 'Lis', 'custModal.monthAbbrDec': 'Gru',
  'custModal.monthShortJan': 'Sty', 'custModal.monthShortFeb': 'Lut', 'custModal.monthShortMar': 'Mar',
  'custModal.monthShortApr': 'Kwi', 'custModal.monthShortMay': 'Maj', 'custModal.monthShortJun': 'Cze',
  'custModal.monthShortJul': 'Lip', 'custModal.monthShortAug': 'Sie', 'custModal.monthShortSep': 'Wrz',
  'custModal.monthShortOct': 'Paź', 'custModal.monthShortNov': 'Lis', 'custModal.monthShortDec': 'Gru',

  // ── Categories page ──
  'categories.title': 'Kategorie klientów',
  'categories.subtitle': 'Zarządzanie kategoriami i poziomami ważności',
  'categories.categoriesTab': 'Kategorie',
  'categories.importanceTab': 'Ważność',
  'categories.categoriesDesc': 'Grupuj klientów wg typów',
  'categories.importanceDesc': 'Określ poziomy ważności klientów',
  'categories.addCategory': 'Dodaj kategorię',
  'categories.newCategory': 'Nowa kategoria',
  'categories.editCategory': 'Edytuj kategorię',
  'categories.noCategories': 'Brak kategorii',
  'categories.categoryName': 'Nazwa kategorii',
  'categories.name': 'Nazwa',
  'categories.namePlaceholder': 'Wprowadź nazwę...',
  'categories.nameDuplicate': 'Kategoria o tej nazwie już istnieje',
  'categories.importanceDuplicate': 'Poziom ważności o tej nazwie już istnieje',
  'categories.icon': 'Ikona',
  'categories.changeIcon': 'Zmień ikonę',
  'categories.chooseIcon': 'Wybierz ikonę',
  'categories.color': 'Kolor',
  'categories.bgColor': 'Kolor tła',
  'categories.textColor': 'Kolor tekstu',
  'categories.borderColor': 'Kolor ramki',
  'categories.indicatorColor': 'Kolor wskaźnika',
  'categories.preview': 'Podgląd',
  'categories.save': 'Zapisz',
  'categories.cancel': 'Anuluj',
  'categories.delete': 'Usuń',
  'categories.edit': 'Edytuj',
  'categories.add': 'Dodaj',
  'categories.confirmDelete': 'Czy na pewno chcesz usunąć?',
  'categories.hasCustomersBlocked': 'Ta kategoria ma klientów i nie może być usunięta',
  'categories.yes': 'Tak',
  'categories.no': 'Nie',
  'categories.addLevel': 'Dodaj poziom',
  'categories.newImportanceLevel': 'Nowy poziom ważności',
  'categories.editLevel': 'Edytuj poziom',
  'categories.noImportanceLevels': 'Brak poziomów ważności',
  'categories.levelName': 'Nazwa poziomu',
  'categories.levelPlaceholder': 'Wprowadź nazwę poziomu...',
  'categories.iconBusiness': 'Biznes',
  'categories.iconClients': 'Klienci',
  'categories.iconNature': 'Natura',
  'categories.iconOther': 'Inne',
  'categories.iconStatus': 'Status',
  'categories.iconSymbols': 'Symbole',

  // ── Staff page ──
  'staff.title': 'Pracownicy',
  'staff.subtitle': 'Zarządzanie personelem',
  'staff.addStaff': 'Dodaj pracownika',
  'staff.searchPlaceholder': 'Szukaj po imieniu, stanowisku, telefonie...',
  'staff.activeStaff': 'Aktywnych',
  'staff.activeStaffDesc': 'pracowników',
  'staff.statusActive': 'Aktywny (pokaż w kalendarzu)',
  'staff.statusActiveHidden': 'Aktywny (ukryj z kalendarza)',
  'staff.statusDismissed': 'Zwolniony',
  'staff.shown': 'Pokazano',
  'staff.of': 'z',
  'staff.total': 'łącznie',
  'staff.notFound': 'Nie znaleziono pracowników',
  'staff.notFoundHint': 'Spróbuj zmienić zapytanie',
  'staff.newStaff': 'Nowy pracownik',
  'staff.editStaff': 'Edycja pracownika',
  'staff.closeEsc': 'Zamknij (Esc)',
  'staff.tabMain': 'Główne',
  'staff.tabDetails': 'Szczegóły',
  'staff.tabServices': 'Usługi',
  'staff.tabSchedule': 'Grafik',
  'staff.personalData': 'Dane osobowe',
  'staff.fullName': 'Pełne imię',
  'staff.fullNamePlaceholder': 'Wprowadź pełne imię',
  'staff.nameRequired': 'Imię jest wymagane',
  'staff.nameDuplicate': 'Pracownik o tej nazwie już istnieje',
  'staff.phoneDuplicate': 'Pracownik z tym numerem telefonu już istnieje',
  'staff.phone': 'Telefon',
  'staff.position': 'Stanowisko',
  'staff.positionPlaceholder': 'Wprowadź stanowisko...',
  'staff.status': 'Status',
  'staff.active': 'Aktywny',
  'staff.profilePhoto': 'Zdjęcie profilowe',
  'staff.uploadPhoto': 'Wgraj zdjęcie',
  'staff.changePhoto': 'Zmień zdjęcie',
  'staff.avatar': 'Awatar',
  'staff.avatarColor': 'Kolor awatara',
  'staff.birthDate': 'Data urodzenia',
  'staff.day': 'Dzień',
  'staff.month': 'Miesiąc',
  'staff.year': 'Rok',
  'staff.address': 'Adres',
  'staff.addressPlaceholder': 'Wprowadź adres...',
  'staff.note': 'Notatka',
  'staff.notePlaceholder': 'Dodaj notatkę...',
  'staff.salaryScheme': 'Schemat naliczania',
  'staff.notSelected': 'Nie wybrano',
  'staff.locations': 'Lokalizacje',
  'staff.servicesEmpty': 'Nie przypisano usług',
  'staff.servicesHint': 'Wybierz usługi świadczone przez tego pracownika',
  'staff.priceUah': 'Cena (UAH)',
  'staff.uah': 'UAH',
  'staff.min': 'min',
  'staff.mins': 'min',
  'staff.workSchedule': 'Grafik pracy',
  'staff.dayOff': 'Wolne',
  'staff.save': 'Zapisz',
  'staff.saveChanges': 'Zapisz zmiany',
  'staff.cancel': 'Anuluj',
  'staff.back': 'Wstecz',
  'staff.next': 'Dalej',
  'staff.add': 'Dodaj',
  'staff.edit': 'Edytuj',
  'staff.delete': 'Usuń',
  'staff.deleteConfirmTitle': 'Usunąć pracownika?',
  'staff.deleteForever': 'Usuń na stałe',
  'staff.hasAppointments': 'Pracownik ma wizyty i nie może być usunięty',
  'staff.understood': 'Rozumiem',
  'staff.scheduleConflict': 'Konflikt grafiku',
  'staff.dayMon': 'Pn', 'staff.dayTue': 'Wt', 'staff.dayWed': 'Śr',
  'staff.dayThu': 'Cz', 'staff.dayFri': 'Pt', 'staff.daySat': 'So', 'staff.daySun': 'Nd',
  'staff.monthJan': 'Styczeń', 'staff.monthFeb': 'Luty', 'staff.monthMar': 'Marzec',
  'staff.monthApr': 'Kwiecień', 'staff.monthMay': 'Maj', 'staff.monthJun': 'Czerwiec',
  'staff.monthJul': 'Lipiec', 'staff.monthAug': 'Sierpień', 'staff.monthSep': 'Wrzesień',
  'staff.monthOct': 'Październik', 'staff.monthNov': 'Listopad', 'staff.monthDec': 'Grudzień',

  // ── Schedule page ──
  'schedule.title': 'Grafik pracy',
  'schedule.subtitle': 'Zarządzanie grafikiem pracy pracowników',
  'schedule.active': 'Aktywnych',
  'schedule.inactive': 'Nieaktywnych',
  'schedule.staffMember': 'Pracownik',
  'schedule.hrsPerWeek': 'Godz/tydz',
  'schedule.prevWeek': '← Poprzedni tydzień',
  'schedule.nextWeek': 'Następny tydzień →',
  'schedule.current': 'Bieżący',
  'schedule.working': 'Pracuje',
  'schedule.dayOff': 'Wolne',
  'schedule.noActiveStaff': 'Brak aktywnych pracowników',
  'schedule.noActiveStaffHint': 'Dodaj pracowników w sekcji "Personel"',
  'schedule.scheduleSettings': 'Ustawienia grafiku',
  'schedule.dayType': 'Typ dnia',
  'schedule.workDay': 'Dzień roboczy',
  'schedule.workHours': 'Godziny pracy',
  'schedule.breaks': 'Przerwy',
  'schedule.noBreaks': 'Brak przerw',
  'schedule.oneBreak': '1 przerwa',
  'schedule.nBreaks': 'przerw',
  'schedule.addBreak': 'Dodaj przerwę',
  'schedule.deleteBreak': 'Usuń przerwę',
  'schedule.save': 'Zapisz',
  'schedule.cancel': 'Anuluj',
  'schedule.apply': 'Zastosuj',
  'schedule.vacation': 'Urlop',
  'schedule.sickLeave': 'Zwolnienie lekarskie',
  'schedule.repeat1': '2 tygodnie (1 cykl)',
  'schedule.repeatN': '{n} tygodni',
  'schedule.repeatWeekly': 'Co tydzień (rok)',
  'schedule.templateAppliedWeeks': 'Szablon zastosowany na {n} tygodni',
  'schedule.scheduleTemplate': 'Szablon grafiku',
  'schedule.noTemplate': 'Bez szablonu',
  'schedule.saveTwoWeeksTemplate': 'Zapisz jako szablon (2 tygodnie)',
  'schedule.templateDuplicate': 'A template with this name already exists',
  'schedule.templateNamePlaceholder': 'Nazwa szablonu...',
  'schedule.scheduleConflict': 'Konflikt grafiku',
  'schedule.appointmentConflict': 'Nie można zmienić grafiku: wizyta o {time} ({count} szt.) wypada poza nowymi godzinami pracy',
  'schedule.h': 'godz',
  'schedule.hrs': 'godz',
  'schedule.min': 'min',
  'schedule.dayMonFull': 'Poniedziałek', 'schedule.dayTueFull': 'Wtorek', 'schedule.dayWedFull': 'Środa',
  'schedule.dayThuFull': 'Czwartek', 'schedule.dayFriFull': 'Piątek', 'schedule.daySatFull': 'Sobota', 'schedule.daySunFull': 'Niedziela',
  'schedule.dayMon': 'Pn', 'schedule.dayTue': 'Wt', 'schedule.dayWed': 'Śr',
  'schedule.dayThu': 'Cz', 'schedule.dayFri': 'Pt', 'schedule.daySat': 'So', 'schedule.daySun': 'Nd',

  // ── Schedule templates page ──
  'schedTpl.title': 'Szablony grafików',
  'schedTpl.subtitle': 'Tworzenie i zarządzanie szablonami grafików pracy',
  'schedTpl.templates': 'Szablonów',
  'schedTpl.newTemplate': 'Nowy szablon',
  'schedTpl.noTemplates': 'Brak szablonów',
  'schedTpl.noTemplatesHint': 'Utwórz szablon grafiku do szybkiego zastosowania',
  'schedTpl.templateSettings': 'Ustawienia szablonu',
  'schedTpl.templateNamePlaceholder': 'Nazwa szablonu...',
  'schedTpl.dayType': 'Typ dnia',
  'schedTpl.workDay': 'Dzień roboczy',
  'schedTpl.dayOff': 'Wolne',
  'schedTpl.vacation': 'Urlop',
  'schedTpl.sickLeave': 'Zwolnienie lekarskie',
  'schedTpl.workHours': 'Godziny pracy',
  'schedTpl.breaks': 'Przerwy',
  'schedTpl.noBreaks': 'Brak przerw',
  'schedTpl.addBreak': 'Dodaj przerwę',
  'schedTpl.save': 'Zapisz',
  'schedTpl.cancel': 'Anuluj',
  'schedTpl.create': 'Utwórz',
  'schedTpl.delete': 'Usuń',
  'schedTpl.rename': 'Zmień nazwę',
  'schedTpl.deleteTitle': 'Usunąć szablon?',
  'schedTpl.deleteMessage': 'Zamierzasz usunąć ten szablon. Tej akcji nie można cofnąć.',
  'schedTpl.hPerWeek': 'godz/tydz',
  'schedTpl.hrs': 'godz',
  'schedTpl.min': 'min',
  'schedTpl.workShort': 'Rob',
  'schedTpl.offShort': 'Wol',
  'schedTpl.week1': 'Tydzień 1',
  'schedTpl.week2': 'Tydzień 2',
  'schedTpl.dayMonFull': 'Poniedziałek', 'schedTpl.dayTueFull': 'Wtorek', 'schedTpl.dayWedFull': 'Środa',
  'schedTpl.dayThuFull': 'Czwartek', 'schedTpl.dayFriFull': 'Piątek', 'schedTpl.daySatFull': 'Sobota', 'schedTpl.daySunFull': 'Niedziela',
  'schedTpl.dayMon': 'Pn', 'schedTpl.dayTue': 'Wt', 'schedTpl.dayWed': 'Śr',
  'schedTpl.dayThu': 'Cz', 'schedTpl.dayFri': 'Pt', 'schedTpl.daySat': 'So', 'schedTpl.daySun': 'Nd',

  // ── Services page ──
  'services.title': 'Usługi',
  'services.subtitle': 'Katalog usług',
  'services.servicesCount': 'Usług',
  'services.groups': 'Grup',
  'services.addService': 'Dodaj usługę',
  'services.newGroup': 'Nowa grupa',
  'services.emptyCatalog': 'Katalog usług jest pusty',
  'services.emptyCatalogHint': 'Dodaj grupę i usługi',
  'services.noServicesInGroup': 'W tej grupie nie ma usług',
  'services.serviceName': 'Nazwa usługi',
  'services.durationMin': 'Czas trwania (min)',
  'services.durationMinError': 'Czas trwania musi być większy niż 0',
  'services.priceUah': 'Cena (UAH)',
  'services.priceNegativeError': 'Cena nie może być ujemna',
  'services.nameDuplicate': 'Usługa o tej nazwie już istnieje',
  'services.groupDuplicate': 'Grupa o tej nazwie już istnieje',
  'services.min': 'min',
  'services.uah': 'UAH',
  'services.save': 'Zapisz',
  'services.cancel': 'Anuluj',
  'services.edit': 'Edytuj',
  'services.delete': 'Usuń',
  'services.renameGroup': 'Zmień nazwę grupy',
  'services.deleteGroup': 'Usuń grupę',
  'services.deleteGroupTitle': 'Usunąć grupę?',
  'services.deleteGroupMessage': 'Wszystkie usługi w tej grupie również zostaną usunięte.',
  'services.deleteServiceTitle': 'Usunąć usługę?',
  'services.deleteServiceMessage': 'Tej akcji nie można cofnąć.',
  'services.cannotDelete': 'Nie można usunąć',
  'services.serviceHasAppointments': 'Ta usługa ma wizyty i nie może być usunięta',
  'services.groupHasAppointments': 'Ta grupa ma usługi z wizytami i nie może być usunięta',
  'services.cannotDeleteGroupHasServices': 'Najpierw przenieś lub usuń usługi z tej grupy',
  'services.deleteError': 'Błąd usuwania',
  'services.understood': 'Rozumiem',

  // ── Tariff plans page ──
  'tariffs.title': 'Plany taryfowe',
  'tariffs.subtitle': 'Zarządzanie planami taryfowymi',
  'tariffs.tariffsCount': 'Taryf',
  'tariffs.addTariff': 'Dodaj taryfę',
  'tariffs.noTariffs': 'Brak planów taryfowych',
  'tariffs.newTariffPlan': 'Nowy plan taryfowy',
  'tariffs.editTariff': 'Edytuj taryfę',
  'tariffs.tariffName': 'Nazwa taryfy',
  'tariffs.tariffNamePlaceholder': 'Wprowadź nazwę taryfy...',
  'tariffs.nameDuplicate': 'Taryfa o tej nazwie już istnieje',
  'tariffs.tariffType': 'Typ taryfy',
  'tariffs.discount': 'Rabat',
  'tariffs.surcharge': 'Dopłata',
  'tariffs.noChange': 'Bez zmian',
  'tariffs.priceModifierPercent': 'Modyfikator ceny (%)',
  'tariffs.percentModifier': '% modyfikator',
  'tariffs.modifier': 'Modyfikator',
  'tariffs.modifierHint': 'Wartość ujemna — rabat, dodatnia — dopłata',
  'tariffs.modifierPlaceholder': 'Na przykład: -10 lub +15',
  'tariffs.activeCheckbox': 'Aktywny',
  'tariffs.active': 'Aktywny',
  'tariffs.inactive': 'Nieaktywny',
  'tariffs.tabServices': 'Usługi',
  'tariffs.tabProducts': 'Produkty',
  'tariffs.servicePrices': 'Ceny usług',
  'tariffs.customPriceServices': 'Indywidualne ceny usług',
  'tariffs.customPriceProducts': 'Indywidualne ceny produktów: {n}',
  'tariffs.productPrices': 'Ceny produktów',
  'tariffs.productPricesHint': 'Wyszukaj i dodaj produkty, aby ustawić ceny promocyjne',
  'tariffs.searchProduct': 'Szukaj produktu po nazwie lub numerze...',
  'tariffs.noCategory': 'Bez kategorii',
  'tariffs.priceList': 'Cennik',
  'tariffs.leaveEmptyDefault': 'Pozostaw puste dla ceny standardowej',
  'tariffs.uah': 'UAH',
  'tariffs.save': 'Zapisz',
  'tariffs.create': 'Utwórz',
  'tariffs.cancel': 'Anuluj',
  'tariffs.edit': 'Edytuj',
  'tariffs.delete': 'Usuń',
  'tariffs.deleteConfirm': 'Czy na pewno chcesz usunąć tę taryfę?',
  'tariffs.cannotDelete': 'Nie można usunąć taryfy',
  'tariffs.appointmentsCount': 'wizyt',
  'tariffs.ordersCount': 'zamówień',
  'tariffs.yes': 'Tak',
  'tariffs.no': 'Nie',

  // ── Finances page ──
  'fin.title': 'Operacje finansowe',
  'fin.subtitle': 'Dziennik płatności i zwrotów',
  'fin.searchPlaceholder': 'Szukaj po kliencie, telefonie, usłudze...',
  'fin.period': 'Okres',
  'fin.today': 'Dzisiaj',
  'fin.week': 'Tydzień',
  'fin.month': 'Miesiąc',
  'fin.from': 'od',
  'fin.to': 'do',
  'fin.allTime': 'Cały czas',
  'fin.typeLabel': 'Typ',
  'fin.all': 'Wszystkie',
  'fin.payments': 'Płatności',
  'fin.refunds': 'Zwroty',
  'fin.type_all': 'Wszystkie',
  'fin.type_payment': 'Płatność',
  'fin.type_refund': 'Zwrot',
  'fin.type_product_sale': 'Sprzedaż produktu',
  'fin.methodLabel': 'Metoda płatności',
  'fin.cash': 'Gotówka',
  'fin.terminal': 'Terminal',
  'fin.transfer': 'Przelew',
  'fin.online': 'Online',
  'fin.total': 'Łącznie',
  'fin.uah': 'UAH',
  'fin.exportExcel': 'Eksport Excel',
  'fin.exportFileName': 'Operacje_finansowe',
  'fin.noOperations': 'Brak operacji',
  'fin.noOperationsHint': 'Spróbuj zmienić filtry lub okres',
  'fin.colDate': 'Data',
  'fin.colClient': 'Klient',
  'fin.colPhone': 'Telefon',
  'fin.colService': 'Usługa',
  'fin.colMaster': 'Specjalista',
  'fin.colType': 'Typ',
  'fin.colPayMethod': 'Metoda płatności',
  'fin.colMethod': 'Metoda',
  'fin.colAmount': 'Kwota',
  'fin.colSum': 'Kwota',
  'fin.colAuthor': 'Autor',
  'fin.colReceipt': 'Paragon',
  'fin.service': 'Usługa',
  'fin.receipt': 'Paragon',
  'fin.receiptNum': 'Paragon nr',
  'fin.receiptSubtitle': 'Paragon fiskalny',
  'fin.receiptDate': 'Data',
  'fin.receiptClient': 'Klient',
  'fin.receiptPhone': 'Telefon',
  'fin.receiptMaster': 'Specjalista',
  'fin.receiptMethod': 'Metoda płatności',
  'fin.receiptTotal': 'Kwota',
  'fin.receiptThanks': 'Dziękujemy za wizytę!',
  'fin.printReceipt': 'Drukuj paragon',
  'fin.fiscalCode': 'Kod fiskalny',
  'fin.noFiscal': 'Bez fiskalizacji',
  'fin.retryFiscal': 'Ponów fiskalizację',
  'fin.fiscalRetrySuccess': 'Fiskalizacja ponowiona pomyślnie',
  'fin.fiscalRetryError': 'Błąd ponownej fiskalizacji',

  // ── Cash register page ──
  'cashReg.title': 'Kasa',
  'cashReg.subtitle': 'Zarządzanie zmianami kasowymi',
  'cashReg.currentShift': 'Bieżąca zmiana',
  'cashReg.openNewShift': 'Otwórz nową zmianę',
  'cashReg.openNewShiftHint': 'Zmiana nie jest otwarta. Otwórz zmianę, aby przyjmować płatności.',
  'cashReg.openingBalance': 'Saldo początkowe',
  'cashReg.openingBalanceLabel': 'Saldo początkowe kasy',
  'cashReg.openShift': 'Otwórz zmianę',
  'cashReg.closeShift': 'Zamknij zmianę',
  'cashReg.prro': 'POS',
  'cashReg.processing': 'Przetwarzanie...',
  'cashReg.opened': 'Otwarta',
  'cashReg.closed': 'Zamknięta',
  'cashReg.openedAt': 'Otwarta o',
  'cashReg.openBal': 'Saldo otw.',
  'cashReg.closeBal': 'Saldo zamkn.',
  'cashReg.revenue': 'Przychód',
  'cashReg.totalRevenue': 'Łączny przychód',
  'cashReg.operations': 'Operacji',
  'cashReg.inRegister': 'W kasie',
  'cashReg.cash': 'Gotówka',
  'cashReg.terminal': 'Terminal',
  'cashReg.transfer': 'Przelew',
  'cashReg.uah': 'UAH',
  'cashReg.shift': 'Zmiana',
  'cashReg.shiftLog': 'Dziennik zmian',
  'cashReg.historyEmpty': 'Historia zmian jest pusta',
  'cashReg.historyEmptyHint': 'Tutaj pojawią się zamknięte zmiany',
  'cashReg.shiftOpened': 'Zmiana otwarta',
  'cashReg.shiftClosed': 'Zmiana zamknięta',
  'cashReg.checkboxNotConfigured': 'Aby korzystać z kasy, skonfiguruj połączenie z Checkbox ПРРО w Ustawienia → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Przychody za okres',
  'reports.reportType_work_hours': 'Godziny pracy',
  'reports.reportType_services_sales': 'Sprzedaż usług',
  'reports.reportType_mutual': 'Rozliczenia z klientami',
  'reports.reportType_inventory_flow': 'Przepływ towarów',
  'reports.reportType_client_analytics': 'Analityka klientów',
  'reports.reportType_staff_revenue': 'Przychody wg pracowników',
  'reports.reportType_service_profitability': 'Rentowność usług',
  'reports.reportType_abc_analysis': 'Analiza ABC produktów',
  'reports.reportType_revenue_dynamics': 'Dynamika przychodów',
  'reports.reportType_discount_analytics': 'Analityka rabatów',
  'reports.reportType_purchases_by_supplier': 'Zakupy wg dostawców',
  'reports.reportType_purchase_dynamics': 'Dynamika zakupów',
  'reports.reportType_top_purchased_products': 'Top kupowane produkty',
  'reports.reportType_supplier_price_compare': 'Porównanie cen dostawców',
  'reports.reportType_product_turnover': 'Rotacja produktów',
  'reports.reportType_subscriptions': 'Abonamenty',
  'reports.subsEmpty': 'Brak abonamentów w wybranym okresie',
  'reports.subsAll': 'Wszystkie',
  'reports.subsActive': 'Aktywne',
  'reports.subsNearExpiry': 'Wkrótce wygasną',
  'reports.subsNearExpiryHint': 'wygasają za <14 dni',
  'reports.subsExpired': 'Wygasłe',
  'reports.subsUsedUp': 'Wykorzystane',
  'reports.subsRefunded': 'Anulowane',
  'reports.subsRevenue': 'Przychód',
  'reports.subsSold': 'sprzedanych',
  'reports.subsUnusedVisits': 'Niewykorzystane wizyty',
  'reports.subsUnusedHint': 'w aktywnych + wygasłych',
  'reports.subsPurchaseDate': 'Data zakupu',
  'reports.subsPlan': 'Plan',
  'reports.subsBoughtVisits': 'Kupione',
  'reports.subsUsage': 'Wykorzystanie',
  'reports.subsPaid': 'Zapłacono',
  'reports.subsValidUntil': 'Ważny do',
  'reports.subsStatus': 'Status',
  'reports.reportType_no_shows': 'Analiza nieobecności',
  'reports.nsEmpty': 'Brak wizyt w wybranym okresie',
  'reports.nsTotal': 'Razem wizyt',
  'reports.nsNoShow': 'Nieobecność',
  'reports.nsCancelled': 'Anulowane',
  'reports.nsLostRevenue': 'Utracony przychód',
  'reports.nsRepeatOffenders': 'Recydywiści (≥2 nieob.)',
  'reports.nsByStaff': 'Według pracownika',
  'reports.nsByService': 'Według usługi (top-15 problemy)',
  'reports.nsNoShowPct': '% Nieobecność',
  'reports.nsCancelPct': '% Anulowanie',
  'reports.nsRepeatOffendersTitle': 'Klienci recydywiści',
  'reports.nsRepeatOffendersHint': '≥2 nieobecności w okresie',
  'reports.nsLastNoShow': 'Ostatnia nieobecność',
  'reports.reportType_service_profitability': 'Rentowność usług',
  'reports.reportType_payment_methods': 'Metody płatności',
  'reports.reportType_sales_by_channel': 'Sprzedaż wg kanału',
  'reports.reportType_customer_ltv': 'LTV / Klienci VIP',
  'reports.profitEmpty': 'Brak usług w wybranym okresie',
  'reports.profitRevenue': 'Przychód',
  'reports.profitCost': 'Koszt',
  'reports.profitGross': 'Zysk',
  'reports.profitMargin': 'Marża',
  'reports.profitVisits': 'Wizyty',
  'reports.group': 'Grupa',
  'reports.visits': 'Wizyty',
  'reports.pmEmpty': 'Brak transakcji w wybranym okresie',
  'reports.tryChangeDate': 'Spróbuj zmienić okres',
  'reports.pmMethod': 'Metoda',
  'reports.pmCount': 'Transakcji',
  'reports.pmAmount': 'Kwota',
  'reports.pmShare': 'Udział',
  'reports.pmTotalTx': 'Transakcji',
  'reports.pmMethodsCount': 'Użyte metody',
  'reports.pmCash': 'Gotówka',
  'reports.pmTerminal': 'Terminal',
  'reports.pmOnline': 'Online',
  'reports.pmTransfer': 'Przelew',
  'reports.pmSubscription': 'Abonament',
  'reports.pmGiftCard': 'Karta podarunkowa',
  'reports.pmPoints': 'Punkty lojalnościowe',
  'reports.pmUnknown': 'Nieokreślone',
  'reports.ltvEmpty': 'Brak klientów w wybranym okresie',
  'reports.ltvCustomers': 'Klienci',
  'reports.ltvTotalRevenue': 'Przychód całkowity',
  'reports.ltvAvgTicket': 'Średni rachunek',
  'reports.ltvVip': 'VIP klienci (top 20%)',
  'reports.ltvSleepingVip': 'Uśpieni VIP',
  'reports.ltvSleepingHint': '>60 dni bez wizyty',
  'reports.ltvTotal': 'Suma',
  'reports.ltvLastVisit': 'Ostatnia wizyta',
  'reports.ltvSleepingBadge': '😴 Uśpiony VIP',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Archiwum wynagrodzeń',
  'reports.reportType_salary_efficiency': 'Efektywność personelu (ROI)',
  'reports.reportType_salary_ratio': 'Wskaźnik wynagrodzeń do przychodów',
  'reports.salaryArchiveEmpty': 'Brak zapisanych zestawień wynagrodzeń',
  'reports.salaryArchiveEmptyHint': 'Oblicz wynagrodzenia w "Obliczanie wynagrodzeń" — pojawi się tutaj.',
  'reports.salaryArchiveMonth': 'Miesiąc',
  'reports.salaryArchiveSavedAt': 'Zapisano',
  'reports.salaryFund': 'Fundusz całkowity',
  'reports.salaryStaffCount': 'Pracowników',
  'reports.salaryAvg': 'Średnio',
  'reports.salaryRevenue': 'Przychód miesiąca',
  'reports.salaryScheme': 'Schemat',
  'reports.salaryByRules': 'Wg reguł',
  'reports.salaryAdjustments': 'Korekty',
  'reports.salaryEffEmpty': 'Brak obliczonych wynagrodzeń w okresie',
  'reports.salaryEffEmptyHint': 'Spróbuj okres gdzie wynagrodzenia są już obliczone.',
  'reports.salaryEffRevenue': 'Przychód',
  'reports.salaryEffSalary': 'Wynagrodzenie',
  'reports.salaryEffProfit': 'Marża',
  'reports.salaryEffAvgRoi': 'Średnie ROI',
  'reports.salaryEffRoiHint': '>3 zdrowy, <1.5 problem',
  'reports.salaryRatioEmpty': 'Brak historii wynagrodzeń',
  'reports.salaryRatioCurrent': 'Aktualny wskaźnik',
  'reports.salaryRatioAvg': 'Średnia okresu',
  'reports.salaryRatioTrend': 'Zmiana vs poprzedni miesiąc',
  'reports.salaryRatioHealthy': 'Zdrowy zakres',
  'reports.salaryRatioHealthyHint': 'dla branży urody',
  'reports.salaryRatioPct': 'Wskaźnik',
  'reports.loading': 'Ładowanie…',
  'reports.reportType_sales_managers': 'Menedżerowie sprzedaży',
  'reports.smEmpty': 'Brak zamówień w wybranym okresie',
  'reports.smUnknown': '— Nieokreślony',
  'reports.smManagersCount': 'Menedżerów',
  'reports.smOrdersCreated': 'Utworzonych zamówień',
  'reports.smDelivered': 'Dostarczono',
  'reports.smNetRevenue': 'Przychód netto',
  'reports.smAvgCheck': 'Średni rachunek',
  'reports.smManager': 'Menedżer',
  'reports.smCreated': 'Utworzył',
  'reports.smCancelled': 'Anulowane',
  'reports.smReturned': 'Zwroty',
  'reports.smCancelRate': '% Anulowanie',
  'reports.smReturnRate': '% Zwrot',
  'reports.smAvgTime': 'Dni do dostawy',
  'reports.reportType_admin_activity': 'Aktywność administratorów',
  'reports.aaEmpty': 'Brak aktywności createdBy w okresie',
  'reports.aaAdmins': 'Aktywni admini',
  'reports.aaTotalApts': 'Utworzonych wizyt',
  'reports.aaTotalProcessed': 'Przetworzono pieniędzy',
  'reports.aaSubsRevenue': 'Przychód z abonamentów',
  'reports.aaAdmin': 'Admin',
  'reports.aaApts': 'Wizyt',
  'reports.aaConfirmed': 'Potw.',
  'reports.aaNoShowPct': '% Nieob.',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Kwota',
  'reports.aaSubsSold': 'Abon.',
  'reports.aaSubsRev': 'Abon. ₴',
  'reports.aaDiscounts': 'Rabaty ₴',
  'reports.groupSales': 'Przychody i sprzedaż',
  'reports.groupCustomers': 'Klienci',
  'reports.groupStaff': 'Personel i wynagrodzenia',
  'reports.groupLoyalty': 'Lojalność i promo',
  'reports.groupInventory': 'Magazyn',
  'reports.groupProcurement': 'Zakupy',
  'reports.reportType_loyalty_points': 'Punkty lojalnościowe',
  'reports.reportType_coupons': 'Kupony',
  'reports.lpEmpty': 'Brak aktywności lojalnościowej w okresie',
  'reports.lpEarned': 'Naliczono',
  'reports.lpRedeemed': 'Wykorzystano',
  'reports.lpReversed': 'Stornowane',
  'reports.lpReversedHint': 'zwroty / anulowania',
  'reports.lpNet': 'Netto okresu',
  'reports.lpSourcesTitle': 'Źródło punktów',
  'reports.lpSource': 'Źródło',
  'reports.lpPoints': 'Punkty',
  'reports.lpShare': 'Udział',
  'reports.lpRefService': 'Usługi',
  'reports.lpRefProduct': 'Produkty',
  'reports.lpRefOrder': 'Zamówienia',
  'reports.lpRefReferral': 'Polecenia',
  'reports.lpRefBirthday': 'Urodziny',
  'reports.lpRefManual': 'Ręcznie',
  'reports.lpRefSubscription': 'Abonament',
  'reports.lpRefOther': 'Inne',
  'reports.cpEmpty': 'Nie masz jeszcze kuponów',
  'reports.cpEmptyHint': 'Dodaj kupony w Lojalności, aby zobaczyć statystyki.',
  'reports.cpTotal': 'Łącznie kuponów',
  'reports.cpUsedInPeriod': 'Wykorzystane w okresie',
  'reports.cpDiscount': 'Udzielono zniżek',
  'reports.cpOrderAmount': 'Przychód z kuponów',
  'reports.cpCode': 'Kod',
  'reports.cpType': 'Typ',
  'reports.cpValue': 'Wartość',
  'reports.cpUsage': 'Użyto',
  'reports.cpInPeriod': 'W okresie',
  'reports.cpOrderSum': 'Przychód ₴',
  'reports.cpStatus': 'Status',
  'reports.cpStatusActive': 'Aktywny',
  'reports.cpStatusExpired': 'Wygasły',
  'reports.cpStatusExhausted': 'Wyczerpany',
  'reports.cpStatusDisabled': 'Wyłączony',
  'reports.reportType_production_runs': 'Produkcja',
  'reports.reportType_cash_shifts_report': 'Zmiany kasowe',
  'reports.reportType_heatmap_dow_hour': 'Mapa cieplna dzień × godzina',
  'reports.prEmpty': 'Brak produkcji w wybranym okresie',
  'reports.prRuns': 'Partii',
  'reports.prCancelled': 'anulowano',
  'reports.prOutputQty': 'Ilość wyjściowa',
  'reports.prInputCost': 'Koszt materiałów',
  'reports.prAvgUnitCost': 'Śr. koszt jedn.',
  'reports.prRecipe': 'Receptura',
  'reports.csEmpty': 'Brak zmian kasowych w wybranym okresie',
  'reports.csEmptyHint': 'Zmiany synchronizują się z Checkbox.',
  'reports.csShifts': 'Zmian',
  'reports.csCash': 'Gotówka',
  'reports.csCard': 'Karta',
  'reports.csAvgDuration': 'Śr. czas trwania',
  'reports.csDiscrep': 'Z rozbieżnością',
  'reports.csOpened': 'Otwarto',
  'reports.csClosed': 'Zamknięto',
  'reports.csLocation': 'Lokalizacja',
  'reports.csOpenBal': 'Start ₴',
  'reports.csCloseBal': 'Koniec ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Otwarta',
  'reports.hmEmpty': 'Brak wizyt w wybranym okresie',
  'reports.hmTotal': 'Razem wizyt',
  'reports.hmPeak': 'Godzina szczytu',
  'reports.hmTopDay': 'Top dzień',
  'reports.hmRecords': 'wizyt',
  'reports.hmLow': 'Niski',
  'reports.hmMedium': 'Średni',
  'reports.hmHigh': 'Wysoki',
  'reports.hmPeakLegend': 'Szczyt',
  'reports.dowMon': 'Pon',
  'reports.dowTue': 'Wt',
  'reports.dowWed': 'Śr',
  'reports.dowThu': 'Czw',
  'reports.dowFri': 'Pt',
  'reports.dowSat': 'Sob',
  'reports.dowSun': 'Nd',
  'reports.period_day': 'Dzień',
  'reports.period_week': 'Tydzień',
  'reports.period_month': 'Miesiąc',
  'reports.period_year': 'Rok',
  'reports.period_custom': 'Własny',
  'period.today': 'Dziś',
  'period.yesterday': 'Wczoraj',
  'period.thisWeek': 'Ten tydzień',
  'period.lastWeek': 'Poprzedni tydzień',
  'period.thisMonth': 'Ten miesiąc',
  'period.lastMonth': 'Poprzedni miesiąc',
  'period.thisQuarter': 'Ten kwartał',
  'period.thisYear': 'Ten rok',
  'period.last30': 'Ostatnie 30 dni',
  'period.last90': 'Ostatnie 90 dni',
  'period.custom': 'Dowolny',
  'reports.title': 'Raporty',
  'reports.subtitle': 'Analityka i raporty',
  'reports.allStaff': 'Wszyscy pracownicy',
  'reports.allClients': 'Wszyscy klienci',
  'reports.allCategories': 'Wszystkie kategorie',
  'reports.allProducts': 'Wszystkie produkty',
  'reports.allLocations': 'Wszystkie lokalizacje',
  'reports.appointments': 'Wizyty',
  'reports.clients': 'Klienci',
  'reports.masters': 'Specjaliści',
  'reports.revenue': 'Przychód',
  'reports.service': 'Usługa',
  'reports.serviceOrProduct': 'Produkt/Usługa',
  'reports.client': 'Klient',
  'reports.master': 'Specjalista',
  'reports.date': 'Data',
  'reports.dateTime': 'Data/czas',
  'reports.time': 'Czas',
  'reports.duration': 'Czas trwania',
  'reports.price': 'Cena',
  'reports.discount': 'Rabat',
  'reports.paid': 'Opłacone',
  'reports.payment': 'Płatność',
  'reports.method': 'Metoda',
  'reports.cash': 'Gotówka',
  'reports.online': 'Online',
  'reports.total': 'Łącznie',
  'reports.grandTotal': 'Ogółem',
  'reports.sum': 'Kwota',
  'reports.position': 'Pozycja',
  'reports.positions': 'pozycji',
  'reports.product': 'Produkt',
  'reports.category': 'Kategoria',
  'reports.qty': 'Ilość',
  'reports.pcs': 'szt',
  'reports.cost': 'Koszt własny',
  'reports.balance': 'Saldo',
  'reports.debt': 'Dług',
  'reports.charges': 'Naliczenia',
  'reports.productCharges': 'Naliczenia za produkty',
  'reports.serviceRefunds': 'Zwroty za uslugi',
  'reports.subscriptionVisit': 'Wizyta z abonamentu',
  'reports.charged': 'Naliczono',
  'reports.visits': 'Wizyty',
  'reports.days': 'dn.',
  'reports.hrs': 'godz',
  'reports.min': 'min',
  'reports.avgCheck': 'Śr. rachunek',
  'reports.avgDuration': 'Śr. czas trwania',
  'reports.totalClients': 'Łącznie klientów',
  'reports.totalHours': 'Łącznie godzin',
  'reports.servicesSold': 'Wykonanych usług',
  'reports.withDiscount': 'Z rabatem',
  'reports.utilization': 'Obciążenie',
  'reports.worked': 'Przepracowano',
  'reports.workingHours': 'Godzin pracy',
  'reports.noVisitDays': 'Dni bez wizyty',
  'reports.forOrder': 'Do zamówienia',
  'reports.mainRegister': 'Kasa główna',
  'reports.settlementAccount': 'Rachunek rozliczeniowy',
  'reports.other': 'Inne',
  'reports.incoming': 'Przyjęcie',
  'reports.incomingQty': 'Ilość przyjęć',
  'reports.incomingSum': 'Kwota przyjęć',
  'reports.incomings': 'Przyjęcia',
  'reports.writeoff': 'Odpis',
  'reports.writeoffsExpenses': 'Odpisy/wydatki',
  'reports.writtenOff': 'Odpisano',
  'reports.writtenOffQty': 'Ilość odpisów',
  'reports.writtenOffSum': 'Kwota odpisów',
  'reports.remainQty': 'Ilość pozostała',
  'reports.remainSum': 'Kwota pozostała',
  'reports.transferMove': 'Przesunięcie',
  'reports.together': 'Razem',
  'reports.exportExcel': 'Eksportuj do Excela',
  'reports.exportPdf': 'Drukuj / PDF',
  'reports.print': 'Drukuj',
  'reports.noService': 'Bez usługi',
  'reports.noDataForPeriod': 'Brak danych za wybrany okres',
  'reports.noCompletedForPeriod': 'Brak zakończonych wizyt za wybrany okres',
  'reports.noRecordsForPeriod': 'Brak rekordów za wybrany okres',
  'reports.noInventoryForPeriod': 'Brak danych magazynowych za wybrany okres',
  'reports.segment_all': 'Wszyscy',
  'reports.segment_no30': 'Brak wizyty 30+ dni',
  'reports.segment_new': 'Nowi',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'Jednorazowi',
  'reports.segment_services_only': 'Tylko usługi',
  'reports.segment_products_only': 'Tylko towary',
  'reports.productContactsCol': 'Zam. na tow.',
  'reports.serviceContactsCol': 'Zam. na usł.',
  'reports.servicesIncome': 'Usługi ₴',
  'reports.productsIncome': 'Towary ₴',
  'reports.lastContact': 'Ost. kontakt',
  'reports.operations': 'Operacji',
  'reports.noClientsInSegment': 'Brak klientów w tym segmencie',
  'reports.tryChangeDateOrStaff': 'Spróbuj zmienić datę lub pracownika',
  'reports.tryChangeDateOrFilters': 'Spróbuj zmienić datę lub filtry',
  'reports.tryChangeDateOrClient': 'Spróbuj zmienić datę lub klienta',
  'reports.servicesRevenue': 'Przychody z usług',
  'reports.productSales': 'Sprzedaż produktów',
  'reports.totalRevenue': 'Łączny przychód',
  'reports.share': 'Udział',
  'reports.materialCosts': 'Koszty materiałów',
  'reports.margin': 'Marża',
  'reports.abcClass': 'Klasa',
  'reports.abcLeaders': 'liderzy',
  'reports.abcMiddle': 'średni',
  'reports.abcSlow': 'wolnorotujące',
  'reports.avgPerDay': 'Śr. dziennie',
  'reports.discountCount': 'Liczba rabatów',
  'reports.discountSum': 'Kwota rabatów',
  'reports.discountShare': 'Udział rabatów',
  'reports.noDiscountsForPeriod': 'Brak rabatów za wybrany okres',
  'reports.grossPrice': 'Cena brutto',
  'reports.avgDiscount': 'Śr. rabat',
  'reports.supplier': 'Dostawca',
  'reports.allSuppliers': 'Wszyscy dostawcy',
  'reports.suppliersCount': 'Dostawców',
  'reports.invoices': 'Faktur',
  'reports.avgPrice': 'Śr. cena',
  'reports.noPurchasesForPeriod': 'Brak zakupów za wybrany okres',
  'reports.productUnits': 'Jednostek towaru',
  'reports.invoiceCount': 'Ilość faktur',
  'reports.netto': 'Netto',
  'reports.peakDay': 'Szczyt',
  'reports.purchases': 'Zakupy',
  'reports.categories': 'Kategorii',
  'reports.remainder': 'Pozostało',
  'reports.ordered': 'Zamówiono',
  'reports.returned': 'Zwrócono',
  'reports.received': 'Otrzymano',
  'reports.productsCompared': 'Produktów porównano',
  'reports.noPriceComparison': 'Brak danych do porównania',
  'reports.needMultipleSuppliers': 'Potrzebne zakupy jednego produktu od różnych dostawców',
  'reports.turnoverRatio': 'Rotacja',
  'reports.turnoverStatus': 'Status',
  'reports.highTurnover': 'Wysoka',
  'reports.medTurnover': 'Średnia',
  'reports.lowTurnover': 'Niska',

  // ── Financial result page ──
  'finResult.month_jan': 'Styczeń', 'finResult.month_feb': 'Luty', 'finResult.month_mar': 'Marzec',
  'finResult.month_apr': 'Kwiecień', 'finResult.month_may': 'Maj', 'finResult.month_jun': 'Czerwiec',
  'finResult.month_jul': 'Lipiec', 'finResult.month_aug': 'Sierpień', 'finResult.month_sep': 'Wrzesień',
  'finResult.month_oct': 'Październik', 'finResult.month_nov': 'Listopad', 'finResult.month_dec': 'Grudzień',
  'finResult.sourceDeleted': 'Ten dokument został usunięty z systemu',
  'finResult.title': 'Wynik finansowy',
  'finResult.subtitle': 'Analiza przychodów i wydatków',
  'finResult.allLocations': 'Wszystkie lokalizacje',
  'finResult.income': 'Przychód',
  'finResult.incomes': 'Przychody',
  'finResult.expenses': 'Wydatki',
  'finResult.financialResult': 'Wynik finansowy',
  'finResult.profitability': 'Rentowność',
  'finResult.sales': 'Sprzedaż',
  'finResult.servicesCompleted': 'Wykonanych usług',
  'finResult.productSales': 'Sprzedaż produktów',
  'finResult.orderProductSales': 'Sprzedaż produktów (wysyłka)',
  'finResult.posProductSales': 'Sprzedaż produktów (POS / sklep)',
  'finResult.aptProductSales': 'Sprzedaż produktów w usługach',
  'finResult.subscriptions': 'Abonamenty',
  'finResult.refunds': 'zwroty',
  'finResult.cogsOrders': 'Koszt — wysyłki',
  'finResult.cogsAppointments': 'Koszt — usługi',
  'finResult.cogsPos': 'Koszt — sklep',
  'finResult.cogsWriteoffs': 'Koszt innych odpisów',
  'finResult.orders': 'Zamówień',
  'finResult.visits': 'Wizyt',
  'finResult.salaries': 'Wynagrodzenia',
  'finResult.addExpense': 'Dodaj wydatek',
  'finResult.otherIncome': 'Inne przychody',
  'finResult.addOtherIncome': 'Dodaj inny przychód',
  'finResult.incomeName': 'Nazwa przychodu',
  'finResult.deleteIncomeConfirm': 'Usunąć ten przychód?',
  'finResult.exportExcel': 'Eksport do Excel',
  'finResult.add': 'Dodaj',
  'finResult.cancel': 'Anuluj',
  'finResult.delete': 'Usuń',
  'finResult.expenseName': 'Nazwa wydatku',
  'finResult.expenseSum': 'Kwota',
  'finResult.monthly': 'Miesięcznie',
  'finResult.monthlyOption': 'Miesięczny',
  'finResult.oneTime': 'Jednorazowy',
  'finResult.oneTimeOption': 'Jednorazowy',
  'finResult.deleteExpenseTitle': 'Usunąć wydatek?',
  'finResult.deleteExpenseConfirm': 'Czy na pewno chcesz usunąć ten wydatek?',
  'finResult.notCalculated': 'Nie obliczono',
  'finResult.print': 'Drukuj',
  'finResult.printPdf': 'Drukuj PDF',
  'finResult.dynamics6months': 'Dynamika za 6 miesięcy',
  'finResult.expenseStructure': 'Struktura kosztów',
  'finResult.incomeStructure': 'Struktura przychodów',
  'finResult.donutServices': 'Usługi',
  'finResult.donutProducts': 'Towary',
  'finResult.noIncomeYet': 'Brak przychodów w tym miesiącu',
  'finResult.salaryFundTitle': 'Struktura funduszu wynagrodzeń',
  'finResult.salaryNotCalculated': 'Wynagrodzenia za ten miesiąc nie zostały jeszcze obliczone',
  'finResult.salaryNoData': 'Brak danych do wyświetlenia',
  'finResult.fundSalary': 'Stała pensja',
  'finResult.fundPercent': 'Procentowa',
  'finResult.fundHybrid': 'Za działanie',
  'finResult.vsPrev': 'do pop.',
  'finResult.cashFlowTitle': 'Przepływ pieniędzy (dziennie)',
  'finResult.cashFlowEmpty': 'Brak transakcji w tym miesiącu',
  'finResult.cashFlowReceipts': 'Wpływy',
  'finResult.cashFlowRefunds': 'Zwroty',
  'finResult.cashFlowNet': 'Przepływ netto',
  'finResult.groupCogsProducts': 'Koszt towarów',
  'finResult.groupSalaries': 'Wynagrodzenia',
  'finResult.groupFixed': 'Koszty stałe',
  'finResult.groupOther': 'Spisanie i inne',
  'finResult.noExpensesYet': 'Brak wydatków w tym miesiącu',
  'finResult.effectiveFrom': 'Obowiązuje od',
  'finResult.edit': 'Edytuj',
  'finResult.save': 'Zapisz',
  'finResult.applyForwardOnly': 'Zastosuj tylko od wybranego miesiąca w przód (zachowaj poprzednią kwotę dla wcześniejszych miesięcy)',
  'finResult.total': 'Łącznie',
  'finResult.hintAddNew': 'Wydatek będzie obowiązywał od {month} (dopóki go nie zmienisz).',
  'finResult.hintMutateSingle': 'Kwota zostanie zaktualizowana dla: {month}',
  'finResult.hintMutateRange': 'Kwota zostanie zaktualizowana dla: {from} — {to}',
  'finResult.hintMutateForward': 'Kwota zostanie zaktualizowana dla: {month} i wszystkich kolejnych miesięcy',
  'finResult.hintSplit': 'Zostanie utworzona nowa wersja od {newMonth}. Poprzednie miesiące ({oldFrom} — {oldTo}) zachowają {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Produkty',
  'invProd.subtitle': 'Zarządzanie produktami, kategoriami i magazynami',
  'invProd.tabProducts': 'Produkty',
  'invProd.tabCategories': 'Kategorie',
  'invProd.tabWarehouses': 'Magazyny',
  'invProd.statProducts': 'Produktów',
  'invProd.statCategories': 'Kategorii',
  'invProd.statWarehouses': 'Magazynów',
  'invProd.productsCount': 'Produktów',
  'invProd.positionsCount': 'Pozycji',
  'invProd.searchPlaceholder': 'Szukaj po nazwie, numerze katalogowym...',
  'invProd.allCategories': 'Wszystkie kategorie',
  'invProd.addProduct': 'Dodaj produkt',
  'invProd.newProduct': 'Nowy produkt',
  'invProd.editProduct': 'Edytuj produkt',
  'invProd.emptyProducts': 'Brak produktów',
  'invProd.emptyProductsHint': 'Dodaj pierwszy produkt',
  'invProd.emptyCategories': 'Utwórz swoją pierwszą kategorię produktów',
  'invProd.emptyCategoriesHint': 'Kategorie pomagają organizować produkty i szybko znajdować to, czego potrzebujesz',
  'invProd.emptyWarehouses': 'Dodaj swój pierwszy magazyn',
  'invProd.emptyWarehousesHint': 'Magazyny są potrzebne do kontroli stanów i realizacji zakupów',
  'invProd.colName': 'Nazwa',
  'invProd.colSku': 'Nr katalogowy',
  'invProd.colCategory': 'Kategoria',
  'invProd.colUnit': 'Jednostka',
  'invProd.colStock': 'Stan',
  'invProd.colMin': 'Min.',
  'invProd.colSellPrice': 'Cena sprzedaży',
  'invProd.labelName': 'Nazwa',
  'invProd.labelSku': 'Nr katalogowy',
  'invProd.labelCategory': 'Kategoria',
  'invProd.labelUnit': 'Jednostka miary',
  'invProd.labelMinStock': 'Min. stan',
  'invProd.labelSellPrice': 'Cena sprzedaży',
  'invProd.labelImageUrl': 'URL obrazu',
  'invProd.labelImage': 'Zdjęcie produktu',
  'invProd.uploadImage': 'Wgraj zdjęcie',
  'invProd.maxSize': 'do 200 KB',
  'invProd.pasteUrl': 'Lub wklej URL',
  'invProd.noCategory': 'Bez kategorii',
  'invProd.unitPcs': 'szt',
  'invProd.unitG': 'g',
  'invProd.unitKg': 'kg',
  'invProd.unitMl': 'ml',
  'invProd.unitL': 'l',
  'invProd.unitPack': 'op',
  'invProd.save': 'Zapisz',
  'invProd.cancel': 'Anuluj',
  'invProd.publishOnOlx': 'Opublikuj na OLX',
  'invProd.olxPublished': 'OLX: ogłoszenie utworzone',
  'olxPublish.title': 'Publikacja na OLX',
  'olxPublish.fieldTitle': 'Tytuł ogłoszenia',
  'olxPublish.fieldDescription': 'Opis',
  'olxPublish.descriptionHint': 'OLX zwykle wymaga ~80+ znaków. Opisz produkt, stan, szczegóły.',
  'olxPublish.fieldCategory': 'Kategoria',
  'olxPublish.suggesting': 'Dobieram kategorię z tytułu…',
  'olxPublish.noCategorySuggestions': 'Nie udało się dobrać kategorii. Doprecyzuj tytuł lub wpisz ID poniżej.',
  'olxPublish.orManualCategoryId': 'lub wpisz ID kategorii OLX',
  'olxPublish.fieldCity': 'Miasto',
  'olxPublish.cityPlaceholder': 'Zacznij wpisywać, np. „Kyiv"',
  'olxPublish.searching': 'Szukam…',
  'olxPublish.fieldPrice': 'Cena',
  'olxPublish.fieldPhotoUrl': 'URL zdjęcia',
  'olxPublish.fieldContactName': 'Imię kontaktu',
  'olxPublish.contactNamePlaceholder': 'Jak podpisać ogłoszenie',
  'olxPublish.fieldContactPhone': 'Telefon',
  'olxPublish.errorTitle': 'OLX zwrócił błąd:',
  'olxPublish.showRawError': 'Pokaż pełną odpowiedź OLX',
  'olxPublish.categoryAttrsTitle': 'OLX wymaga dodatkowych pól dla tej kategorii:',
  'olxPublish.loadingAttrs': 'Ładowanie pól kategorii…',
  'olxPublish.choose': 'wybierz',
  'olxPublish.fieldDistrict': 'Dzielnica',
  'olxPublish.loadingDistricts': 'Ładowanie dzielnic miasta…',
  'olxPublish.success': 'Ogłoszenie utworzone, wysłane do moderacji OLX',
  'olxPublish.cancel': 'Anuluj',
  'olxPublish.publish': 'Opublikuj',
  'invProd.add': 'Dodaj',
  'invProd.delete': 'Usuń',
  'invProd.deleteProduct': 'Usuń produkt',
  'invProd.deleteCategory': 'Usuń kategorię',
  'invProd.deleteWarehouse': 'Usuń magazyn',
  'invProd.deleteConfirmMsg': 'Czy na pewno chcesz usunąć?',
  'invProd.cannotDelete': 'Nie można usunąć',
  'invProd.errName': 'Wprowadź nazwę',
  'invProd.nameDuplicate': 'Produkt o tej nazwie już istnieje',
  'invProd.catDuplicate': 'Kategoria o tej nazwie już istnieje',
  'invProd.whDuplicate': 'Magazyn o tej nazwie już istnieje',
  'invProd.understood': 'Rozumiem',
  'invProd.newCategoryPlaceholder': 'Nazwa nowej kategorii',
  'invProd.newWarehousePlaceholder': 'Nazwa nowego magazynu',
  'invProd.blockProduct': 'Produkty',
  'invProd.blockCategory': 'Kategorie',
  'invProd.blockWarehouse': 'Magazyny',

  // ── Inventory stock page ──
  'invStock.title': 'Stany magazynowe',
  'invStock.subtitle': 'Kontrola stanów na magazynach',
  'invStock.statProducts': 'Produktów',
  'invStock.statLow': 'Niski stan',
  'invStock.searchPlaceholder': 'Szukaj po nazwie...',
  'invStock.allCategories': 'Wszystkie kategorie',
  'invStock.allWarehouses': 'Wszystkie magazyny',
  'invStock.lowStockOnly': 'Tylko niski stan',
  'invStock.emptyTitle': 'Brak danych',
  'invStock.emptyHint': 'Dodaj produkty w sekcji "Produkty"',
  'invStock.colProduct': 'Produkt',
  'invStock.colCategory': 'Kategoria',
  'invStock.colUnit': 'Jednostka',
  'invStock.colTotal': 'Stan',
  'invStock.colMin': 'Min.',
  'invStock.colStatus': 'Status',
  'invStock.statusLow': 'Niski',
  'invStock.statusEmpty': 'Brak',
  'invStock.available': 'Dostępne',
  'invStock.transfer': 'Przesunięcie',
  'invStock.transferTitle': 'Przesunięcie produktu',
  'invStock.transferBtn': 'Przesuń',
  'invStock.labelProduct': 'Produkt',
  'invStock.labelFromWarehouse': 'Z magazynu',
  'invStock.labelToWarehouse': 'Do magazynu',
  'invStock.labelQuantity': 'Ilość',
  'invStock.cancel': 'Anuluj',

  // ── Inventory purchases page ──
  'invPurch.title': 'Zakupy',
  'invPurch.subtitle': 'Ewidencja zakupów produktów',
  'invPurch.statPurchases': 'Zakupów',
  'invPurch.searchPlaceholder': 'Szukaj po dostawcy...',
  'invPurch.newPurchase': 'Nowy zakup',
  'invPurch.emptyTitle': 'Brak zakupów',
  'invPurch.emptyHint': 'Utwórz pierwszy zakup',
  'invPurch.colDate': 'Data',
  'invPurch.colSupplier': 'Dostawca',
  'invPurch.colWarehouse': 'Magazyn',
  'invPurch.colItems': 'Pozycje',
  'invPurch.colTotal': 'Suma',
  'invPurch.modalTitle': 'Nowy zakup',
  'invPurch.labelSupplier': 'Dostawca',
  'invPurch.supplierPlaceholder': 'Wprowadź nazwę dostawcy...',
  'invPurch.labelDestWarehouse': 'Magazyn docelowy',
  'invPurch.sectionProducts': 'Produkty',
  'invPurch.selectProduct': 'Wybierz produkt',
  'invPurch.searchProduct': 'Szukaj produktu...',
  'invPurch.noProducts': 'Nie znaleziono produktów',
  'invPurch.addItem': 'Dodaj produkt',
  'invPurch.qty': 'Ilość',
  'invPurch.pricePerUnit': 'Cena za szt.',
  'invPurch.totalSum': 'Kwota łączna',
  'invPurch.pos': 'pozycji',
  'invPurch.units': 'jednostek',
  'invPurch.receive': 'Przyjmij',
  'invPurch.cancel': 'Anuluj',
  'invPurch.errWarehouse': 'Wybierz magazyn',
  'invPurch.errItems': 'Dodaj co najmniej jeden produkt',
  'invPurch.errNegPrice': 'Cena nie może być ujemna',
  'invPurch.errZeroPrice': 'Podaj cenę zakupu dla każdego produktu',
  'invPurch.periodWeek': 'Tydzień',
  'invPurch.periodMonth': 'Miesiąc',
  'invPurch.periodYear': 'Rok',
  'invPurch.periodAll': 'Cały czas',
  'invPurch.periodCustom': 'Dowolny',
  'invPurch.returnToSupplier': 'Zwrot do dostawcy',
  'invPurch.returnTitle': 'Zwrot do dostawcy',
  'invPurch.returnHint': 'Podaj ilość do zwrotu',
  'invPurch.returnAmount': 'Kwota zwrotu',
  'invPurch.confirmReturn': 'Zwróć',
  'invPurch.returnSuccess': 'Zwrot zrealizowany',
  'invPurch.allReturned': 'Wszystkie produkty już zwrócone lub brak na stanie',
  'invPurch.deletePurchase': 'Usuń zakup',
  'invPurch.deleteTitle': 'Usuwanie zakupu',
  'invPurch.deleteWarning': 'Czy na pewno? Następujące towary zostaną wycofane ze stanu:',
  'invPurch.deleteStockNote': 'Ilości na stanie zostaną odpowiednio zmniejszone.',
  'invPurch.deleteConfirm': 'Usuń',
  'invPurch.deleteBlockedTitle': 'Usunięcie niemożliwe',
  'invPurch.deleteBlockedText': 'Tego zakupu nie można usunąć, ponieważ istnieją późniejsze ruchy dla tych produktów:',
  'invPurch.deleteBlockedHint': 'Najpierw usuń lub anuluj późniejsze operacje, a następnie spróbuj ponownie.',
  'invPurch.understood': 'Rozumiem',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Przyjęcia towarów',
  'invPurch.tabSuppliers': 'Dostawcy',
  'invPurch.selectSupplier': 'Wybierz dostawcę',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Szukaj dostawcy...',
  'invPurch.newSupplier': 'Nowy dostawca',
  'invPurch.editSupplier': 'Edytuj dostawcę',
  'invPurch.statSuppliers': 'dostawców',
  'invPurch.emptySuppliersTitle': 'Brak dostawców',
  'invPurch.emptySuppliersHint': 'Dodaj dostawców dla wygodnej ewidencji zakupów',
  'invPurch.colSupplierName': 'Nazwa',
  'invPurch.colContact': 'Osoba kontaktowa',
  'invPurch.colPhone': 'Telefon',
  'invPurch.colEdrpou': 'NIP',
    'invPurch.supplierDuplicate': 'A supplier with this name already exists',
'invPurch.supplierName': 'Nazwa',
  'invPurch.supplierNamePh': 'Sp. z o.o. "Dostawca"',
  'invPurch.contactPerson': 'Osoba kontaktowa',
  'invPurch.contactPersonPh': 'Nazwisko Imię',
  'invPurch.phone': 'Telefon',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Dane bankowe',
  'invPurch.edrpou': 'NIP',
  'invPurch.mfo': 'Kod banku',
  'invPurch.iban': 'IBAN / Numer rachunku',
  'invPurch.supplierNotes': 'Notatki',
  'invPurch.supplierNotesPh': 'Dodatkowe informacje o dostawcy...',
  'invPurch.create': 'Utwórz',
  'invPurch.deleteSupplierTitle': 'Usunąć dostawcę?',
  'invPurch.deleteSupplierWarning': 'Czy na pewno chcesz usunąć dostawcę',

  // ── Inventory movements page ──
  'invMov.title': 'Ruchy magazynowe',
  'invMov.subtitle': 'Historia ruchów produktów na magazynach',
  'invMov.statOperations': 'Operacji',
  'invMov.filterType': 'Typ',
  'invMov.filterAll': 'Wszystkie',
  'invMov.filterPurchase': 'Zakup',
  'invMov.filterWriteoff': 'Odpis',
  'invMov.filterTransfer': 'Przesunięcie',
  'invMov.filterAppointment': 'Wizyta',
  'invMov.filterOrder': 'Zamówienie',
  'invMov.filterReturn': 'Zwrot',
  'invMov.filterAllProducts': 'Wszystkie produkty',
  'invMov.emptyTitle': 'Brak operacji',
  'invMov.emptyHint': 'Tutaj będą wyświetlane wszystkie operacje z produktami',
  'invMov.colDate': 'Data',
  'invMov.colType': 'Typ',
  'invMov.colProduct': 'Produkt',
  'invMov.colQty': 'Ilość',
  'invMov.colCost': 'Koszt',
  'invMov.colWarehouse': 'Magazyn',
  'invMov.colAuthor': 'Autor',
  'invMov.colDetails': 'Szczegóły',
  'invMov.typePurchase': 'Zakup',
  'invMov.typeWriteoff': 'Odpis',
  'invMov.typeTransfer': 'Przesunięcie',
  'invMov.typeAppointment': 'Wizyta',
  'invMov.typeSale': 'Sprzedaż',
  'invMov.typeOrder': 'Zamówienie',
  'invMov.typeOrderCancel': 'Anulowanie zamówienia',
  'invMov.typeSaleCancel': 'Anulowanie sprzedaży',
  'invMov.typeAppointmentCancel': 'Anulowanie wizyty',
  'invMov.typeReturn': 'Zwrot towaru',
  'invMov.supplier': 'Dostawca',
  'invMov.writeoffTitle': 'Odpis produktu',
  'invMov.writeoffBtn': 'Odpisz',
  'invMov.writeoffConfirm': 'Potwierdź odpis',
  'invMov.labelProduct': 'Produkt',
  'invMov.labelQuantity': 'Ilość',
  'invMov.labelWarehouse': 'Magazyn',
  'invMov.labelReason': 'Przyczyna',
  'invMov.labelNote': 'Notatka',
  'invMov.available': 'Dostępne',
  'invMov.cancel': 'Anuluj',
  'invMov.reasonExpired': 'Przeterminowane',
  'invMov.reasonDamaged': 'Uszkodzone',
  'invMov.reasonLost': 'Utracone',
  'invMov.reasonUsed': 'Zużyte',
  'invMov.reasonOther': 'Inne',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'Styczeń', 'salCalc.month_feb': 'Luty', 'salCalc.month_mar': 'Marzec',
  'salCalc.month_apr': 'Kwiecień', 'salCalc.month_may': 'Maj', 'salCalc.month_jun': 'Czerwiec',
  'salCalc.month_jul': 'Lipiec', 'salCalc.month_aug': 'Sierpień', 'salCalc.month_sep': 'Wrzesień',
  'salCalc.month_oct': 'Październik', 'salCalc.month_nov': 'Listopad', 'salCalc.month_dec': 'Grudzień',
  'salCalc.title': 'Obliczanie wynagrodzeń',
  'salCalc.subtitle': 'Naliczanie wynagrodzenia',
  'salCalc.selectMonthHint': 'Wybierz miesiąc do obliczenia',
  'salCalc.calculate': 'Oblicz',
  'salCalc.save': 'Zapisz',
  'salCalc.loadSaved': 'Wczytaj zapisane',
  'salCalc.exportExcel': 'Eksport Excel',
  'salCalc.staffCount': 'Pracowników',
  'salCalc.staffWithSchemes': 'Ze schematami',
  'salCalc.allStaff': 'Wszyscy',
  'salCalc.noDataTitle': 'Brak danych',
  'salCalc.noDataDesc': 'Wybierz miesiąc i naciśnij "Oblicz"',
  'salCalc.noStaffTitle': 'Brak pracowników',
  'salCalc.noStaffDesc': 'Dodaj pracowników w sekcji "Personel"',
  'salCalc.totalByRules': 'Wg reguł',
  'salCalc.manualAdjustments': 'Korekty',
  'salCalc.totalLabel': 'Łącznie',
  'salCalc.grandTotal': 'Kwota łączna',
  'salCalc.adjustments': 'Korekty',
  'salCalc.addAdjustment': 'Dodaj korektę',
  'salCalc.adjDescPlaceholder': 'Opis...',
  'salCalc.adjAmountPlaceholder': 'Kwota',
  'salCalc.edit': 'Edytuj',
  'salCalc.back': 'Wstecz',
  'salCalc.cancel': 'Anuluj',
  'salCalc.saved': 'Zapisano',
  'salCalc.savedNotice': 'Obliczenie zapisane',
  'salCalc.overwriteTitle': 'Nadpisać?',
  'salCalc.overwriteDesc': 'Dla tego miesiąca istnieje już zapisane obliczenie. Nadpisać?',
  'salCalc.overwrite': 'Nadpisz',
  'salCalc.hourlyRate': 'Stawka godzinowa',
  'salCalc.monthlySalary': 'Pensja miesięczna',
  'salCalc.monthlyFixed': 'stała miesięczna',
  'salCalc.tiered': 'progi',
  'salCalc.dailyRate': 'Stawka dzienna',
  'salCalc.fixedPerAppointment': 'Stała za wizytę',
  'salCalc.percentOwnServices': '% od swoich usług',
  'salCalc.percentTotalRevenue': '% od łącznego przychodu',
  'salCalc.percentOwnProductSales': '% own product sales',
  'salCalc.percentAllProductSales': '% all product sales',
  'salCalc.percentCreatedAppointments': '% created appointments',
  'salCalc.fixedPerCreatedAppointment': 'Fixed per created apt',
  'salCalc.percentOwnMaterials': '% materials',
  'salCalc.percentAllServices': '% of all location services',
  'salCalc.hours': 'godz',
  'salCalc.days': 'dn.',
  'salCalc.appts': 'wiz.',
  'salCalc.services': 'usł.',
  'salCalc.individual': 'indywidualnie',
  'salCalc.otherService': 'inne',
  'salCalc.exFileName': 'Wynagrodzenia',
  'salCalc.exStaff': 'Pracownik',
  'salCalc.exScheme': 'Schemat',
  'salCalc.exByRules': 'Wg reguł',
  'salCalc.exAdjustments': 'Korekty',
  'salCalc.exTotal': 'Łącznie',

  // ── Salary schemes page ──
  'salSchemes.title': 'Schematy motywacyjne',
  'salSchemes.subtitle': 'Reguły naliczania wynagrodzenia',
  'salSchemes.schemesCount': 'Schematów',
  'salSchemes.newScheme': 'Nowy schemat',
  'salSchemes.emptyTitle': 'Brak schematów',
  'salSchemes.emptyDesc': 'Utwórz pierwszy schemat naliczania',
  'salSchemes.newSchemeTitle': 'Nowy schemat',
  'salSchemes.editScheme': 'Edytuj schemat',
  'salSchemes.schemeName': 'Nazwa schematu',
  'salSchemes.nameDuplicate': 'Schemat o tej nazwie już istnieje',
  'salSchemes.schemeNamePlaceholder': 'Wprowadź nazwę...',
  'salSchemes.rulesSection': 'Reguły naliczania',
  'salSchemes.groupBase': 'Base',
  'salSchemes.groupServices': 'Services',
  'salSchemes.groupProducts': 'Products',
  'salSchemes.groupGeneral': 'General',
  'salSchemes.groupAdmin': 'Admin',
  'salSchemes.noRules': 'Brak reguł',
  'salSchemes.hourlyRate': 'Stawka godzinowa',
  'salSchemes.dailyRate': 'Stawka dzienna',
  'salSchemes.fixedPerAppointment': 'Stała za wykonaną usługę',
  'salSchemes.percentOwnServices': '% od swoich usług',
  'salSchemes.percentTotalRevenue': '% od łącznego przychodu',
  'salSchemes.hintHourlyRate': 'UAH/godz',
  'salSchemes.hintDailyRate': 'UAH/dzień',
  'salSchemes.hintFixedPer': 'UAH/wizyta',
  'salSchemes.hintPercentOwn': '% od swoich',
  'salSchemes.hintPercentTotal': '% od łącznej',
  'salSchemes.percentOwnProductSales': '% own product sales',
  'salSchemes.hintPercentOwnProducts': '% of products sold by employee',
  'salSchemes.percentAllProductSales': '% all product sales',
  'salSchemes.hintPercentAllProducts': '% of total product sales',
  'salSchemes.percentCreatedAppointments': '% created appointments',
  'salSchemes.hintPercentCreated': '% from appointments created by employee',
  'salSchemes.fixedPerCreatedAppointment': 'Fixed per created appointment',
  'salSchemes.hintFixedCreated': 'Fixed amount per created appointment',
  'salSchemes.percentOwnMaterials': '% materials',
  'salSchemes.hintPercentMaterials': '% of materials in appointments',
  'salSchemes.percentAllServices': '% of all location services',
  'salSchemes.hintPercentAllServices': 'Percentage of total service and subscription revenue at location',
  'salSchemes.subscriptionLabel': 'Subscription services',
  'salSchemes.subModeVisitPrice': 'At subscription price',
  'salSchemes.subModeFullPrice': 'At list price',
  'salSchemes.subModeSkip': 'Do not count',
  'salSchemes.unitHour': 'UAH/godz',
  'salSchemes.unitDay': 'UAH/dzień',
  'salSchemes.unitRecord': 'UAH/wizyta',
  'salSchemes.unitService': 'UAH/usł.',
  'salSchemes.useOverrides': 'Wyjątki dla usług',
  'salSchemes.overrideService': 'Usługa',
  'salSchemes.overrideRate': 'Stawka',
  'salSchemes.overrideAdd': 'Dodaj wyjątek',
  'salSchemes.overrideRemove': 'Usuń wyjątek',
  'salSchemes.overridesShort': 'wyjątków',
  'salSchemes.staffShort': 'prac.',
  'salSchemes.save': 'Zapisz',
  'salSchemes.create': 'Utwórz',
  'salSchemes.cancel': 'Anuluj',
  'salSchemes.editBtn': 'Edytuj',
  'salSchemes.deleteBtn': 'Usuń',
  'salSchemes.delete': 'Usuń',
  'salSchemes.deleteTitle': 'Usunąć schemat?',
  'salSchemes.deleteConfirmText': 'Czy na pewno chcesz usunąć ten schemat?',
  'salSchemes.deleteAssigned': 'Ten schemat jest przypisany pracownikom i nie może być usunięty',
  'salSchemes.understood': 'Rozumiem',
  'salSchemes.monthlySalary': 'Pensja miesięczna',
  'salSchemes.hintMonthlySalary': 'Stała kwota miesięczna niezależnie od grafiku',
  'salSchemes.unitMonth': '₴/mies',
  'salSchemes.useBrackets': 'Progi procentowe',
  'salSchemes.bracketModeProgressive': 'Progresywnie (per próg)',
  'salSchemes.bracketModeFlat': 'Płasko (cała baza wg osiągniętego progu)',
  'salSchemes.bracketFrom': 'Od',
  'salSchemes.bracketTo': 'Do',
  'salSchemes.bracketAdd': 'Dodaj próg',
  'salSchemes.bracketRemove': 'Usuń próg',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox POS',
  'checkbox.subtitle': 'Konfiguracja połączenia z Checkbox',
  'checkbox.licenseKey': 'Klucz licencyjny',
  'checkbox.licenseKeyHint': 'Klucz z panelu Checkbox',
  'checkbox.licenseKeyPlaceholder': 'Wprowadź klucz licencyjny...',
  'checkbox.pinCode': 'PIN-kod kasjera',
  'checkbox.pinCodeHint': 'PIN-kod kasjera z Checkbox',
  'checkbox.pinPlaceholder': 'Wprowadź PIN-kod...',
  'checkbox.save': 'Zapisz',
  'checkbox.saving': 'Zapisywanie...',
  'checkbox.settingsSaved': 'Ustawienia zapisane',
  'checkbox.testConnection': 'Sprawdź połączenie',
  'checkbox.testing': 'Sprawdzanie...',
  'checkbox.connectionSuccess': 'Połączenie udane',
  'checkbox.connectionSuccessToast': 'Checkbox podłączony pomyślnie',
  'checkbox.shiftOpen': 'Zmiana otwarta',
  'checkbox.shiftClosed': 'Zmiana zamknięta',
  'checkbox.guideTitle': 'Jak działa integracja',
  'checkbox.guideStep1': 'Zarejestruj się na checkbox.ua i utwórz kasę. Skopiuj klucz licencyjny ze swojego gabinetu.',
  'checkbox.guideStep2': 'Utwórz kasjera i zanotuj kod PIN. Wklej klucz i PIN powyżej, kliknij "Testuj połączenie".',
  'checkbox.guideStep3': 'Gotowe! Teraz przy przetwarzaniu płatności za zamówienia lub wizyty system automatycznie utworzy paragony fiskalne.',
  'checkbox.guideCapabilities': 'Funkcje:',
  'checkbox.guideCap1': 'Automatyczna fiskalizacja przy płatnościach za zamówienia i wizyty',
  'checkbox.guideCap2': 'Otwieranie i zamykanie zmian kasowych',
  'checkbox.guideCap3': 'Obsługa płatności gotówkowych i bezgotówkowych',
  'checkbox.guideCap4': 'Raport X i raport Z do kontroli kasy',
  'checkbox.taxGroup': 'Grupa podatkowa',
  'checkbox.taxGroupHint': 'Wybierz stawki podatkowe dodawane do każdego paragonu. Kliknij "Sprawdź połączenie" aby załadować dostępne stawki.',
  'checkbox.noTax': 'Bez podatku',

  // ── Nova Poshta settings page ──
  'np.title': 'Nova Poshta',
  'np.subtitle': 'Ustawienia integracji z Nova Poshta',
  'np.apiKey': 'Klucz API',
  'np.apiKeyPlaceholder': 'Wprowadź klucz API Nova Poshta...',
  'np.apiKeyHint': 'Klucz z my.novaposhta.ua → Ustawienia → Bezpieczeństwo',
  'np.save': 'Zapisz',
  'np.saving': 'Zapisywanie...',
  'np.settingsSaved': 'Ustawienia Nova Poshta zapisane',
  'np.error': 'Błąd: ',
  'np.testConnection': 'Testuj połączenie',
  'np.testing': 'Testowanie...',
  'np.connectionSuccess': 'Połączono! Znaleziono nadawców: {count}',
  'np.connectionSuccessToast': 'Nova Poshta połączono pomyślnie',
  'np.connectionFailed': 'Błąd połączenia. Sprawdź klucz API.',
  'np.senderSection': 'Dane nadawcy',
  'np.sender': 'Nadawca (kontrahent)',
  'np.contactPerson': 'Osoba kontaktowa',
  'np.senderPhone': 'Telefon nadawcy',
  'np.senderAddress': 'Adres wysyłki',
  'np.senderAddressHint': 'Oddział Nova Poshta, z którego wysyłasz paczki',
  'np.loadingSenders': 'Ładowanie danych nadawcy...',
  'np.senderWarehouse': 'Oddział nadawcy',
  'np.senderWarehouseHint': 'Twoje konto NP nie ma zarejestrowanych adresów. Wybierz oddział, z którego wysyłasz.',
  'np.senderCity': 'Miasto nadawcy',
  'np.senderCityPlaceholder': 'Wpisz nazwę miasta...',
  'np.senderWarehouseSelect': 'Oddział',
  'np.noWarehouses': 'Nie znaleziono oddziałów',
  'np.clearSelection': 'Wyczyść',
  'np.guideTitle': 'Jak działa integracja',
  'np.guideStep1': 'Zaloguj się na my.novaposhta.ua → Ustawienia → Bezpieczeństwo → skopiuj klucz API.',
  'np.guideStep2': 'Wklej klucz powyżej, kliknij "Testuj połączenie". Wybierz nadawcę, osobę kontaktową i adres.',
  'np.guideStep3': 'Gotowe! Teraz wybierz "Nova Poshta" jako metodę wysyłki przy tworzeniu zamówień.',
  'np.guideCapabilities': 'Funkcje:',
  'np.guideCap1': 'Tworzenie TTN jednym kliknięciem ze strony zamówienia (status "Zapakowane")',
  'np.guideCap2': 'Automatyczna synchronizacja statusu dostawy co 10 minut',
  'np.guideCap3': 'Śledzenie przesyłek w czasie rzeczywistym',
  'np.guideCap4': 'Drukowanie etykiet wysyłkowych',
  'np.guideCap5': 'Automatyczne obliczanie kosztu dostawy przy wyborze oddziału',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Ustawienia integracji',
  'meest.apiToken': 'Token API',
  'meest.apiTokenPlaceholder': 'Wklej token API z gabinetu Meest',
  'meest.apiTokenHint': 'Znajdź na 24.meest.com → Ustawienia → Integracja API',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'Np. b0004cad-27a3-...',
  'meest.contractIdHint': 'Znajdź w gabinecie Meest obok tokenu API',
  'meest.save': 'Zapisz',
  'meest.saving': 'Zapisywanie...',
  'meest.settingsSaved': 'Ustawienia Meest Express zapisane',
  'meest.error': 'Błąd: ',
  'meest.testConnection': 'Testuj połączenie',
  'meest.testing': 'Testowanie...',
  'meest.testingConnection': 'Testowanie połączenia z Meest Express...',
  'meest.connectionSuccess': 'Meest Express połączony pomyślnie',
  'meest.connectionSuccessToast': 'Meest Express połączony',
  'meest.connectionFailed': 'Nie udało się połączyć. Sprawdź token i Contract ID.',
  'meest.senderSection': 'Dane nadawcy',
  'meest.senderName': 'Pełne imię nadawcy',
  'meest.senderNamePlaceholder': 'Nazwisko Imię',
  'meest.senderPhone': 'Telefon nadawcy',
  'meest.senderCity': 'Miasto nadawcy',
  'meest.senderCityPlaceholder': 'Zacznij pisać nazwę miasta',
  'meest.senderBranch': 'Oddział nadawcy',
  'meest.branchPlaceholder': 'Szukaj oddziału',
  'meest.noBranches': 'Nie znaleziono oddziałów',
  'meest.clearSelection': 'Wyczyść',
  'meest.guideTitle': 'Jak działa integracja',
  'meest.guideStep1': 'Zarejestruj się na 24.meest.com i podpisz umowę. W Ustawieniach → Integracja API skopiuj token i Contract ID.',
  'meest.guideStep2': 'Wklej je powyżej, kliknij "Testuj połączenie". Dane nadawcy zostaną wypełnione automatycznie.',
  'meest.guideStep3': 'Gotowe! Teraz wybierz "Meest Express" jako metodę wysyłki przy tworzeniu zamówień.',
  'meest.guideCapabilities': 'Funkcje:',
  'meest.guideCap1': 'Tworzenie przesyłki jednym kliknięciem ze strony zamówienia (status "Zapakowane")',
  'meest.guideCap2': 'Automatyczna synchronizacja statusu dostawy co 10 minut',
  'meest.guideCap3': 'Śledzenie przesyłek w czasie rzeczywistym',
  'meest.guideCap4': 'Drukowanie etykiety na przesyłkę',

  // ── Telegram settings page ──
  'telegram.title': 'Przypomnienia Telegram',
  'telegram.subtitle': 'Konfiguracja bota do przypomnień dla klientów',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Token bota od @BotFather',
  'telegram.saveAndConnect': 'Zapisz i podłącz',
  'telegram.connecting': 'Łączenie...',
  'telegram.checkingBot': 'Sprawdzanie bota...',
  'telegram.settingWebhook': 'Konfiguracja webhooka...',
  'telegram.botConnected': 'Bot podłączony',
  'telegram.botReady': 'Bot gotowy do pracy',
  'telegram.invalidToken': 'Nieprawidłowy token',
  'telegram.webhookError': 'Błąd webhooka',
  'telegram.webhookFailed': 'Nie udało się skonfigurować webhooka',
  'telegram.error': 'Błąd',
  'telegram.howItWorks': 'Jak to działa',
  'telegram.step1': '1. Utwórz bota przez @BotFather w Telegram',
  'telegram.step2': '2. Skopiuj token bota',
  'telegram.step3': '3. Wklej token powyżej i kliknij "Zapisz i podłącz"',
  'telegram.step4': '4. Klienci będą mogli podłączyć się przez link',
  'telegram.guideCapabilities': 'Funkcje:',
  'telegram.guideCap1': 'Automatyczne przypomnienia o wizytach dla klientów',
  'telegram.guideCap2': 'Klienci mogą przeglądać nadchodzące wizyty',
  'telegram.guideCap3': 'Potwierdzenie lub anulowanie wizyty przez bota',
  'telegram.guideCap4': 'Osobisty link dla każdego klienta',

  // ── SMS settings page ──
  'sms.title': 'Wysyłka SMS',
  'sms.subtitle': 'Konfiguracja bramki SMS',
  'sms.provider': 'Dostawca',
  'sms.apiKey': 'Klucz API',
  'sms.apiKeyPlaceholder': 'Wprowadź klucz API...',
  'sms.senderName': 'Nazwa nadawcy',
  'sms.senderNameHint': 'Nazwa, którą zobaczy odbiorca (do 11 znaków)',
  'sms.save': 'Zapisz',
  'sms.settingsSaved': 'Ustawienia zapisane',
  'sms.testConnection': 'Sprawdź połączenie',
  'sms.testing': 'Sprawdzanie...',
  'sms.checkingConnection': 'Sprawdzanie połączenia...',
  'sms.connectionSuccess': 'Połączenie udane',
  'sms.connectionError': 'Błąd połączenia',
  'sms.gatewayWorks': 'Bramka SMS działa',
  'sms.error': 'Błąd',
  'sms.unknown': 'Nieznany błąd',
  'sms.howItWorks': 'Jak to działa',
  'sms.step1': '1. Zarejestruj się u dostawcy SMS',
  'sms.step2': '2. Uzyskaj klucz API',
  'sms.step3': '3. Wklej klucz powyżej i zapisz',
  'sms.step4': '4. Teraz możesz wysyłać SMS do klientów',
  'sms.howToConnect': 'Jak podłączyć {name}',
  'sms.openSite': 'Otwórz stronę {name}',
  'sms.apiKeyLocation': 'Klucz API znajdziesz tutaj: {path}',
  'sms.recommended': 'Zalecane',
  'sms.tagline_turbosms': 'Najpopularniejszy na Ukrainie. Solidny panel, proste API.',
  'sms.tagline_smsclub': 'Elastyczne taryfy, obsługa alpha-name.',
  'sms.tagline_alphasms': 'Przejrzyste ceny, szybka rejestracja.',
  'sms.guide_turbosms.step1': 'Zarejestruj się w TurboSMS i doładuj saldo.',
  'sms.guide_turbosms.step2': 'Zamów alpha-name (nazwę nadawcy) w panelu. Zatwierdzenie zwykle tego samego dnia.',
  'sms.guide_turbosms.step3': 'Wejdź w Profil → API i skopiuj klucz API.',
  'sms.guide_turbosms.step4': 'Wklej klucz + alpha-name poniżej i kliknij „Sprawdź połączenie".',
  'sms.guide_smsclub.step1': 'Załóż konto SMSClub i doładuj saldo.',
  'sms.guide_smsclub.step2': 'Zamów alpha-name w panelu (moderacja ~1 dzień roboczy).',
  'sms.guide_smsclub.step3': 'Otwórz Ustawienia / Profil → znajdź token API.',
  'sms.guide_smsclub.step4': 'Wklej token + alpha-name poniżej i kliknij „Sprawdź połączenie".',
  'sms.guide_alphasms.step1': 'Zarejestruj się w AlphaSMS i doładuj saldo.',
  'sms.guide_alphasms.step2': 'Zamów alpha-name (moderacja zwykle kilka godzin).',
  'sms.guide_alphasms.step3': 'Panel: Ustawienia → API → skopiuj klucz API.',
  'sms.guide_alphasms.step4': 'Wklej klucz + alpha-name poniżej i kliknij „Sprawdź połączenie".',

  // ── Email settings page ──
  'emailSet.title': 'Wysyłka Email',
  'emailSet.subtitle': 'Konfiguracja wysyłki email',
  'emailSet.gmailAddress': 'Adres Gmail',
  'emailSet.gmailHint': 'Adres Gmail, z którego będą wysyłane wiadomości',
  'emailSet.appPassword': 'Hasło aplikacji',
  'emailSet.appPasswordHint': 'Hasło aplikacji Google (nie hasło główne)',
  'emailSet.fromName': 'Nazwa nadawcy',
  'emailSet.fromNameHint': 'Nazwa, którą zobaczy odbiorca',
  'emailSet.save': 'Zapisz',
  'emailSet.settingsSaved': 'Ustawienia zapisane',
  'emailSet.sendTestEmail': 'Wyślij testowy email',
  'emailSet.sendingTest': 'Wysyłanie...',
  'emailSet.testing': 'Testowanie...',
  'emailSet.testSent': 'Testowy email wysłany',
  'emailSet.testSubject': 'Testowy email',
  'emailSet.testBody': 'To jest testowy email z Systemic CRM',
  'emailSet.emailWorks': 'Email działa',
  'emailSet.sendError': 'Błąd wysyłania',
  'emailSet.error': 'Błąd',
  'emailSet.unknown': 'Nieznany błąd',
  'emailSet.howToGetAppPassword': 'Jak uzyskać hasło aplikacji',
  'emailSet.important': 'Ważne',
  'emailSet.importantText': 'Użyj hasła aplikacji, a nie głównego hasła Gmail',
  'emailSet.step1': '1. Zaloguj się na konto Google',
  'emailSet.step2': '2. Przejdź do Bezpieczeństwo → Weryfikacja dwuetapowa',
  'emailSet.step2direct': '2. Włącz weryfikację dwuetapową',
  'emailSet.step3': '3. Przejdź do Hasła aplikacji',
  'emailSet.step4': '4. Utwórz nowe hasło aplikacji',
  'emailSet.step5': '5. Skopiuj wygenerowane hasło',

  // ── Locations settings page ──
  'locations.title': 'Lokalizacje',
  'locations.subtitle': 'Zarządzanie lokalizacjami Twojej firmy',
  'locations.locationsLabel': 'Lokalizacji',
  'locations.staffCount': 'Pracowników',
  'locations.warehousesCount': 'Magazynów',
  'locations.addLocation': 'Dodaj lokalizację',
  'locations.tabMain': 'Ogólne',
  'locations.tabBooking': 'Rezerwacja online',
  'locations.tabCompany': 'Dane firmy',
  'locations.photo': 'Zdjęcie lokalizacji',
  'locations.uploadPhoto': 'Wgraj zdjęcie',
  'locations.changePhoto': 'Zmień zdjęcie',
  'locations.photoHint': 'Zdjęcie wnętrza lub fasady — wyświetlane na stronie rezerwacji',
  'locations.scheduleLabel': 'Godziny pracy',
  'locations.dayOff': 'Wolne',
  'locations.mon': 'Pon', 'locations.tue': 'Wt', 'locations.wed': 'Śr',
  'locations.thu': 'Czw', 'locations.fri': 'Pt', 'locations.sat': 'Sob', 'locations.sun': 'Ndz',
  'locations.workingHoursLabel': 'Godziny pracy',
  'locations.workingHoursPlaceholder': 'Pon-Pt 9:00-18:00, Sob 10:00-15:00',
  'locations.hasLinkedData': 'Nie można usunąć — lokalizacja ma powiązany personel lub magazyny.',
  'locations.limitReached': 'Osiągnięto limit lokalizacji. Zaktualizuj plan.',
  'locations.newLocation': 'Nowa lokalizacja',
  'locations.editLocation': 'Edytuj lokalizację',
  'locations.nameLabel': 'Nazwa',
  'locations.namePlaceholder': 'Wprowadź nazwę...',
  'locations.nameDuplicate': 'Lokalizacja o tej nazwie już istnieje',
  'locations.addressLabel': 'Adres',
  'locations.addressPlaceholder': 'ul. Marszałkowska 1',
  'locations.cityLabel': 'Miasto',
  'locations.cityPlaceholder': 'Warszawa',
  'locations.phoneLabel': 'Telefon',
  'locations.colorLabel': 'Kolor',
  'locations.save': 'Zapisz',
  'locations.cancel': 'Anuluj',
  'locations.add': 'Dodaj',
  'locations.edit': 'Edytuj',
  'locations.delete': 'Usuń',
  'locations.cannotDelete': 'Nie można usunąć',
  'locations.ordersCount': 'Zamówień',
  'locations.needAtLeastOne': 'Potrzebna co najmniej jedna lokalizacja',
  'locations.added': 'Lokalizacja dodana',
  'locations.updated': 'Lokalizacja zaktualizowana',
  'locations.deleted': 'Lokalizacja usunięta',
  'locations.deleteTitle': 'Usuń lokalizację',
  'locations.deleteMessage': 'Czy na pewno? Tej operacji nie można cofnąć.',
  'locations.companyDetailsHint': 'Dane firmy (do faktur i dokumentów)',
  'locations.officialNameLabel': 'Nazwa oficjalna',
  'locations.officialNamePlaceholder': 'Sp. z o.o. "Nazwa" / Działalność gosp.',
  'locations.edrpouLabel': 'NIP / REGON',
  'locations.edrpouShort': 'NIP',
  'locations.bankAccountLabel': 'Rachunek bankowy (IBAN)',
  'locations.bankNameLabel': 'Nazwa banku',
  'locations.bankNamePlaceholder': 'Nazwa banku',

  // ── Users page ──
  'users.title': 'Użytkownicy',
  'users.subtitle': 'Zarządzanie użytkownikami systemu',
  'users.usersCount': 'Użytkowników',
  'users.addUser': 'Dodaj użytkownika',
  'users.limitReached': 'Osiągnięto limit użytkowników. Zaktualizuj plan.',
  'users.newUser': 'Nowy użytkownik',
  'users.editUser': 'Edytuj użytkownika',
  'users.noUsers': 'Brak użytkowników',
  'users.thName': 'Imię',
  'users.thEmail': 'Email',
  'users.thRole': 'Rola',
  'users.thStaff': 'Pracownik',
  'users.thActions': 'Akcje',
  'users.nameLabel': 'Imię',
  'users.namePlaceholder': 'Wprowadź imię...',
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Hasło',
  'users.passwordPlaceholder': 'Minimum 6 znaków',
  'users.passwordMin': 'Hasło minimum 6 znaków',
  'users.roleLabel': 'Rola',
  'users.selectRole': 'Wybierz rolę',
  'users.selectRoleOption': '— Wybierz rolę —',
  'users.showPassword': 'Pokaż hasło',
  'users.hidePassword': 'Ukryj hasło',
  'users.enterName': 'Wprowadź imię',
  'users.enterEmail': 'Wprowadź email',
  'users.emailAlreadyUsed': 'Ten email jest już używany',
  'users.error': 'Błąd',
  'users.edit': 'Edytuj',
  'users.delete': 'Usuń',
  'users.confirmDelete': 'Czy na pewno chcesz usunąć tego użytkownika?',
  'users.yes': 'Tak',
  'users.no': 'Nie',
  'users.staffBinding': 'Powiązanie z pracownikiem',
  'users.noStaffBinding': '— Brak —',
  'users.noPosition': 'bez stanowiska',
  'users.staffBindingHint': 'Link user to employee for salary calculation and work schedule',
  'users.viewScope': 'Data visibility',
  'users.viewScopeAll': 'Show all records and orders',
  'users.viewScopeOwn': 'Show only own',
  'users.viewScopeHint': '"Own only" — user will see only their appointments, orders and sales',
  'users.createWarning': 'Uwaga: po utworzeniu użytkownika możesz zostać wylogowany. Po prostu zaloguj się ponownie.',

  // === Role ===
  'roles.title': 'Role',
  'roles.subtitle': 'Zarządzanie rolami i uprawnieniami dostępu',
  'roles.rolesCount': 'Ról',
  'roles.addRole': 'Dodaj rolę',
  'roles.noRoles': 'Nie ma jeszcze żadnych ról.',
  'roles.systemBadge': 'Systemowa',
  'roles.permsOf': 'uprawnień',
  'roles.newRole': 'Nowa rola',
  'roles.editRole': 'Edytuj rolę',
  'roles.roleName': 'Nazwa roli',
  'roles.roleNamePlaceholder': 'Na przykład: Administrator, Menedżer, Mistrz',
  'roles.nameDuplicate': 'Rola o tej nazwie już istnieje',
  'roles.permissions': 'Uprawnienia dostępu',
  'roles.confirmDelete': 'Usunąć?',
  'roles.cannotDelete': 'Nie można usunąć roli',
  'roles.usersAssigned': 'użytkowników z tą rolą',
  'roles.groupClients': 'Klienci',
  'roles.groupStaff': 'Personel',
  'roles.groupCalendar': 'Kalendarz',
  'roles.groupSales': 'Sprzedaż',
  'roles.groupInventory': 'Magazyn',
  'roles.groupLoyalty': 'Lojalność',
  'roles.groupSalary': 'Wynagrodzenia',
  'roles.groupFinances': 'Finanse i analityka',
  'roles.groupCommunication': 'Komunikacja',
  'roles.groupSettings': 'Ustawienia',
  'roles.groupSystem': 'System',
  'roles.permClientsView': 'Podgląd klientów',
  'roles.permClientsEdit': 'Edycja klientów',
  'roles.permClientsDelete': 'Usuwanie klientów',
  'roles.permClientsCategories': 'Kategorie klientów',
  'roles.permClientsDocuments': 'Dokumenty klientów',
  'roles.permStaffView': 'Podgląd personelu',
  'roles.permStaffEdit': 'Edycja personelu',
  'roles.permScheduleView': 'Grafik pracy',
  'roles.permScheduleEdit': 'Szablony grafików',
  'roles.permServicesView': 'Podgląd usług',
  'roles.permServicesEdit': 'Edycja usług',
  'roles.permCalendarView': 'Podgląd kalendarza',
  'roles.permCalendarCreate': 'Tworzenie wizyt',
  'roles.permCalendarEdit': 'Edycja wizyt',
  'roles.permPosSell': 'Sklep (POS)',
  'roles.permOrdersView': 'Zamówienia (podgląd)',
  'roles.permOrdersCreate': 'Zamówienia (tworzenie)',
  'roles.permOrdersEdit': 'Zamówienia (edycja)',
  'roles.permInvView': 'Produkty i stany',
  'roles.permInvPurchases': 'Zakupy',
  'roles.permInvMovements': 'Ruchy magazynowe',
  'roles.permProductionView': 'Podgląd produkcji',
  'roles.permProductionCreate': 'Tworzenie produkcji',
  'roles.permLoyaltyView': 'Podgląd programów lojalnościowych',
  'roles.permLoyaltyEdit': 'Edycja programów lojalnościowych',
  'roles.permSalaryView': 'Obliczanie wynagrodzeń',
  'roles.permSalaryEdit': 'Schematy motywacyjne',
  'roles.permFinancesView': 'Podgląd finansów',
  'roles.permCashRegister': 'Kasa (Checkbox)',
  'roles.permReportsView': 'Raporty',
  'roles.permFinancialResult': 'Wynik finansowy',
  'roles.permBusinessMonitor': 'Monitor biznesowy',
  'roles.permCommunicationView': 'Wiadomości',
  'roles.permCommSettingsEdit': 'Ustawienia komunikacji',
  'roles.permSettingsLocations': 'Lokalizacje',
  'roles.permSettingsBooking': 'Rezerwacje online',
  'roles.permSettingsIntegrations': 'Integracje',
  'roles.permSettingsTariffs': 'Plany taryfowe',
  'roles.permManageUsers': 'Użytkownicy',
  'roles.permManageRoles': 'Role',
  'roles.permAuditLog': 'Dziennik audytu',

  // === Komunikacja ===
  'comm.title': 'Komunikacja',
  'comm.subtitle': 'Wiadomości i kontakt z klientami',
  'comm.searchPlaceholder': 'Szukaj klienta...',
  'comm.allClients': 'Wszyscy klienci',
  'comm.nothingFound': 'Nic nie znaleziono',
  'comm.noConnectedClients': 'Brak połączonych klientów',
  'comm.you': 'Ty: ',
  'comm.noMessages': 'Brak wiadomości',
  'comm.noHistory': 'Brak historii',
  'comm.selectChat': 'Wybierz czat',
  'comm.selectChatHint': 'Wybierz klienta po lewej, aby rozpocząć komunikację',
  'comm.telegramNotConnected': 'Telegram nie jest połączony',
  'comm.smsNotConfigured': 'Bramka SMS nie jest skonfigurowana',
  'comm.clientNoPhone': 'Klient nie ma numeru telefonu',
  'comm.noPhone': 'Brak telefonu',
  'comm.emailNotConfigured': 'Email nie jest skonfigurowany',
  'comm.clientNoEmail': 'Klient nie ma adresu email',
  'comm.noEmail': 'Brak email',
  'comm.defaultSubject': 'Wiadomość',
  'comm.emailSent': 'Email wysłany',
  'comm.smsSent': 'SMS wysłany',
  'comm.messageSent': 'Wiadomość wysłana',
  'comm.error': 'Błąd: ',
  'comm.linkCopied': 'Link skopiowany',
  'comm.yesterday': 'Wczoraj',
  'comm.clientNoTelegram': 'Klient jeszcze nie połączył Telegrama',
  'comm.sendBotLink': 'Wyślij ten link klientowi:',
  'comm.copy': 'Kopiuj',
  'comm.sendSmsInstead': 'Wyślij SMS zamiast tego',
  'comm.botNotConfigured': 'Bot Telegram nie jest skonfigurowany',
  'comm.configureTelegram': 'Skonfiguruj w System → Powiadomienia Telegram',
  'comm.configureSms': 'Skonfiguruj w System → Wysyłka SMS',
  'comm.addPhoneToCard': 'Dodaj numer telefonu do karty klienta',
  'comm.configureEmail': 'Skonfiguruj w System → Wysyłka Email',
  'comm.addEmailToCard': 'Dodaj email do karty klienta',
  'comm.noMessagesYet': 'Nie ma jeszcze wiadomości. Napisz pierwszy!',
  'comm.openAttachment': 'Otwórz załącznik',
  'comm.attachHintWeb': 'Rozmowa przejdzie na kartę klienta razem z historią; kolejne wiadomości z tego czatu również trafią na kartę.',
  'comm.createCardFromVisitor': 'Utwórz kartę z danych odwiedzającego',
  'comm.cardCreated': 'Karta utworzona',
  'comm.showOlder': 'Pokaż wcześniejsze',
  'comm.emailSubjectPlaceholder': 'Temat wiadomości...',
  'comm.emailPlaceholder': 'Treść wiadomości...',
  'comm.smsPlaceholder': 'Napisz SMS...',
  'comm.sendingVia': 'Bieżący kanał: {channel}',
  'comm.messagePlaceholder': 'Napisz wiadomość...',
  'comm.sendEnter': 'Wyślij (Enter)',

  // ── Orders ──
  'orders.title': 'Zamówienia',
  'orders.subtitle': 'Sprzedaż produktów',
  'orders.statTotal': 'Łącznie',
  'orders.statusNew': 'Nowe',
  'orders.statusPaid': 'Opłacone',
  'orders.searchPlaceholder': 'Szukaj po kliencie lub produkcie...',
  'orders.filterAll': 'Wszystkie',
  'orders.status_new': 'Nowe',
  'orders.status_confirmed': 'Potwierdzone',
  'orders.status_packed': 'Zapakowane',
  'orders.status_shipped': 'Wysłane',
  'orders.status_delivered': 'Odebrane',
  'orders.status_cancelled': 'Anulowane',
  'orders.periodAll': 'Wszystkie',
  'orders.periodWeek': 'Tydzień',
  'orders.periodMonth': 'Miesiąc',
  'orders.periodYear': 'Rok',
  'orders.periodCustom': 'Niestandardowy',
  'orders.newOrder': 'Nowe zamówienie',
  'orders.editOrder': 'Edytuj zamówienie',
  'orders.emptyTitle': 'Brak zamówień',
  'orders.emptyHint': 'Utwórz swoje pierwsze zamówienie sprzedaży',
  'orders.pos': 'poz.',
  'orders.discount': 'Rabat',
  'orders.total': 'Razem',
  'orders.pay_unpaid': 'Nieopłacone',
  'orders.pay_partial': 'Częściowo',
  'orders.pay_paid': 'Opłacone',
  'orders.pay_refunded': 'Zwrócone',
  'orders.refund': 'Zwrot',
  'orders.refunded': 'Płatność zwrócona',
  'orders.refundTitle': 'Zwrot płatności',
  'orders.refundMessage': 'Zwrócić klientowi {amount} ₴?',
  'orders.refundWarning': 'Zostanie utworzona transakcja zwrotu',
  'orders.refundDescription': 'Zwrot za zamówienie',
  'orders.confirmRefund': 'Potwierdź zwrot',
  'orders.refundAmountLabel': 'Kwota zwrotu',
  'orders.paidOf': 'Zapłacono {paid} z {total} ₴',
  'orders.payRemaining': 'Dopłać',
  'orders.payAmountLabel': 'Kwota płatności',
  'orders.fullAmount': 'pełna kwota',
  'orders.returnProducts': 'Zwróć towar',
  'orders.returnTitle': 'Zwrot towaru',
  'orders.returnHint': 'Podaj ilości do zwrotu na magazyn',
  'orders.confirmReturn': 'Potwierdź zwrot',
  'orders.returnFrom': 'Zwrot z zamówienia',
  'orders.fullyReturned': 'Towar zwrócony',
  'orders.partiallyReturned': 'Częściowy zwrot towaru',
  'orders.action_confirmed': 'Potwierdź',
  'orders.action_packed': 'Zapakuj',
  'orders.action_shipped': 'Wyślij',
  'orders.action_delivered': 'Odebrane',
  'orders.action_cancelled': 'Anuluj',
  'orders.markPaid': 'Oznacz jako opłacone',
  'orders.payBtn': 'Zapłać',
  'orders.cashGiven': 'Klient dał',
  'orders.change': 'Reszta',
  'orders.notEnough': 'Brakuje',
  'orders.confirmPayment': 'Potwierdź płatność',
  'orders.back': 'Wstecz',
  'orders.edit': 'Edytuj',
  'orders.errCustomerName': 'Wpisz nazwę klienta',
  'orders.errItems': 'Dodaj co najmniej jeden produkt',
  'orders.errWarehouse': 'Wybierz magazyn',
  'orders.errStockInsufficient': 'Niewystarczające zapasy',
  'orders.errNegPrice': 'Cena nie może być ujemna',
  'orders.errQuantity': 'Podaj ilość dla wybranych produktów',
  'orders.inStock': 'Na stanie',
  'orders.available': 'dostępne',
  'orders.needed': 'potrzebne',
  'orders.paymentDescription': 'Sprzedaż produktów',
  'orders.sectionCustomer': 'Klient',
  'orders.sectionProducts': 'Produkty',
  'orders.sectionPayment': 'Płatność',
  'orders.labelName': 'Imię',
  'orders.namePlaceholder': 'Nazwa klienta',
  'orders.labelPhone': 'Telefon',
  'orders.labelTariff': 'Plan taryfowy',
  'orders.standardPrice': 'Cena standardowa',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Magazyn',
  'orders.selectWarehouse': 'Wybierz magazyn',
  'orders.labelPaymentMethod': 'Metoda płatności',
  'orders.pm_cash': 'Gotówka',
  'orders.pm_terminal': 'Terminal',
  'orders.pm_transfer': 'Przelew',
  'orders.pm_online': 'Online',
  'orders.selectProduct': 'Wybierz produkt',
  'orders.qty': 'Ilość',
  'orders.price': 'Cena',
  'orders.addItem': 'Dodaj produkt',
  'orders.colProduct': 'Produkt',
  'orders.colWarehouse': 'Magazyn',
  'orders.colQty': 'Ilość',
  'orders.colPrice': 'Cena',
  'orders.colDiscount': 'Rabat',
  'orders.colSum': 'Suma',
  'orders.labelDiscount': 'Rabat (₴)',
  'orders.labelNote': 'Notatka',
  'orders.notePlaceholder': 'Komentarz do zamówienia...',
  'orders.cancel': 'Anuluj',
  'orders.save': 'Zapisz',
  'orders.saving': 'Zapisywanie…',
  'orders.searchProduct': 'Szukaj produktu...',
  'orders.noProducts': 'Nie znaleziono produktów',
  'orders.changeProduct': 'Zmień produkt',
  'orders.noWarehouse': 'Brak magazynu z zapasami',
  'orders.noCategory': 'Bez kategorii',
  'orders.printInvoice': 'Faktura',
  'orders.printBill': 'Rachunek',
  'orders.sectionShipping': 'Wysyłka',
  'orders.labelShippingMethod': 'Sposób dostawy',
  'orders.labelShippingAddress': 'Adres dostawy',
  'orders.shippingNone': 'Bez wysyłki (odbiór osobisty)',
  'orders.shippingNP': 'Nova Poshta',
  'orders.shippingPickup': 'Odbiór osobisty',
  'orders.shippingCourier': 'Kurier',
  'orders.shippingOther': 'Inne',
  'orders.shipping_novaposhta': 'Nova Poshta',
  'orders.shipping_pickup': 'Odbiór osobisty',
  'orders.shipping_courier': 'Kurier',
  'orders.shipping_other': 'Inna dostawa',
  'orders.npCity': 'Miasto',
  'orders.npCityPlaceholder': 'Wpisz nazwę miasta...',
  'orders.npWarehouse': 'Oddział / Paczkomat',
  'orders.npWarehousePlaceholder': 'Szukaj oddziału...',
  'orders.npTTN': 'Numer przesyłki',
  'orders.npTTNPlaceholder': 'Numer listu przewozowego',
  'orders.npTrack': 'Śledź',
  'orders.npStatus': 'Status',
  'orders.npFrom': 'Z',
  'orders.npTo': 'Do',
  'orders.npDeliveryTo': 'Dostawa',
  'orders.npDeliveryDate': 'Data dostawy',
  'orders.npTTNOnlyPacked': 'TTN można utworzyć tylko ze statusu «Zapakowano»',
  'orders.npSyncTracking': 'Synchronizuj śledzenie',
  'orders.npSyncing': 'Synchronizacja...',
  'orders.npAutoSyncActive': 'Status zaktualizuje się automatycznie przez Nova Poshta',
  'orders.meestAutoSyncActive': 'Status zaktualizuje się automatycznie przez Meest Express',
  'orders.meestAll': 'Wszystkie',
  'orders.meestOffice': 'Oddziały',
  'orders.meestParcelLocker': 'Paczkomaty',
  'orders.npCodConfirmTitle': 'Utwórz list przewozowy Nova Poshta',
  'orders.meestCodConfirmTitle': 'Utwórz przesyłkę Meest',
  'orders.codChoiceMessage': 'Zamówienie nie jest opłacone. Możesz utworzyć przesyłkę za Pobraniem.',
  'orders.codWithCod': 'Tak, za Pobraniem',
  'orders.codWithoutCod': 'Nie, bez Pobrania',
  'orders.codCancel': 'Anuluj tworzenie listu przewozowego',
  'orders.addressPlaceholder': 'Adres dostawy...',
  'orders.courierAddressPlaceholder': 'Adres dla kuriera...',
  'orders.npSettingsRequired': 'Najpierw skonfiguruj Nova Poshta w System → Nova Poshta',
  'orders.npResaveSettings': 'Zapisz ponownie ustawienia Nova Poshta (System → Nova Poshta → Zapisz), aby zaktualizować dane nadawcy.',
  'orders.npMissingFields': 'Brak danych do utworzenia listu przewozowego. Przejdź do System → Nova Poshta i zapisz ponownie. Brakujące pola',
  'orders.npAddressRequired': 'Podaj miasto i oddział NP w zamówieniu',
  'orders.npRecipientRequired': 'Podaj imię i telefon odbiorcy',
  'orders.npCreateTTN': 'Utwórz list przewozowy',
  'orders.npTTNCreated': 'List przewozowy utworzony',
  'orders.npTTNError': 'Błąd tworzenia',
  'orders.npPrintSticker': 'Drukuj etykietę',
  'orders.npDeliveryPriceLabel': 'Szacunkowy koszt dostawy',
  'orders.npUAH': 'UAH',
  'orders.npCalcPrice': 'Obliczanie kosztu',
  'orders.author': 'Autor',
  'invoice.title': 'Dokument wydania',
  'invoice.date': 'Data',
  'invoice.status': 'Status',
  'invoice.customer': 'Nabywca',
  'invoice.note': 'Uwaga',
  'invoice.items': 'Pozycje',
  'invoice.product': 'Nazwa',
  'invoice.unit': 'Jm.',
  'invoice.qty': 'Ilość',
  'invoice.price': 'Cena',
  'invoice.discountCol': 'Rabat',
  'invoice.sum': 'Wartość',
  'invoice.discount': 'Rabat',
  'invoice.total': 'Razem',
  'invoice.paid': 'Zapłacono',
  'invoice.remaining': 'Pozostało',
  'invoice.seller': 'Sprzedawca',
  'invoice.bankAccount': 'Rachunek',
  'invoice.sellerSign': 'Podpis sprzedawcy',
  'invoice.buyerSign': 'Podpis nabywcy',
  'invoice.pcs': 'szt',

  // ── Bill ──
  'bill.title': 'Rachunek',
  'bill.amountDue': 'Do zapłaty',
  'bill.payTo': 'Dane do przelewu',
  'bill.service': 'usługa',
  'bill.itemName': 'Nazwa',

  // ── Services: default materials ──
  'services.materials': 'Materialy',
  'services.hasMaterials': 'Ma domyslne materialy',
  'services.defaultMaterials': 'Domyslne materialy',
  'services.defaultMaterialsHint': 'Te materialy zostana automatycznie dodane przy wyborze tej uslugi',
  'services.addMaterial': 'Dodaj material',
  'services.noProductsAvailable': 'Brak dostepnych produktow',

  'nav.production': 'Produkcja',

  'production.title': 'Produkcja',
  'production.subtitle': 'Specyfikacje i operacje',
  'production.recipesCount': 'Specyfikacji',
  'production.operationsCount': 'Operacji',
  'production.tab_recipes': 'Specyfikacje',
  'production.tab_produce': 'Produkuj',
  'production.tab_history': 'Historia',
  'production.newRecipe': 'Nowa specyfikacja',
  'production.newProduction': 'Nowa operacja',
  'production.searchRecipes': 'Szukaj specyfikacji...',
  'production.searchHistory': 'Szukaj w historii...',
  'production.noRecipes': 'Brak specyfikacji',
  'production.noRecipesHint': 'Utworz specyfikacje do produkcji wyrobow z surowcow',
  'production.createRecipeFirst': 'Najpierw utworz specyfikacje w zakladce "Specyfikacje"',
  'production.noHistory': 'Historia produkcji jest pusta',
  'production.output': 'Wyjscie',
  'production.inputs': 'Surowce',
  'production.produce': 'Produkuj',
  'production.edit': 'Edytuj',
  'production.delete': 'Usun',
  'production.stockOk': 'Na stanie',
  'production.stockLow': 'Niewystarczajacy',
  'production.inputCost': 'Koszt surowcow',
  'production.unitCost': 'Koszt jednostkowy',
  'production.uah': 'UAH',
  'production.warehouse': 'Magazyn',
  'production.recipeName': 'Nazwa specyfikacji',
  'production.recipeNamePlaceholder': 'Np. "Krem do rak 100ml"',
  'production.selectWarehouse': 'Wybierz magazyn',
  'production.noInputsYet': 'Dodaj surowce do specyfikacji',
  'production.outputSection': 'Gotowy produkt',
  'production.outputProduct': 'Produkt wyjsciowy',
  'production.selectProduct': 'Wybierz produkt',
  'production.outputQty': 'Ilosc',
  'production.inputsSection': 'Surowce (zuzycie)',
  'production.addInput': 'Dodaj surowiec',
  'production.searchProduct': 'Szukaj produktu...',
  'production.qty': 'Ilosc',
  'production.cancel': 'Anuluj',
  'production.save': 'Zapisz',
  'production.create': 'Utworz',
  'production.editRecipe': 'Edytuj specyfikacje',
  'production.recipeCreated': 'Specyfikacja utworzona',
  'production.recipeUpdated': 'Specyfikacja zaktualizowana',
  'production.recipeDeleted': 'Specyfikacja usunieta',
  'production.cannotDeleteRecipe': 'Nie mozna usunac — uzywana w produkcji',
  'production.executeProduction': 'Wykonaj produkcje',
  'production.selectRecipeLabel': 'Specyfikacja',
  'production.selectRecipe': 'Wybierz specyfikacje',
  'production.multiplier': 'Mnoznik (liczba partii)',
  'production.preview': 'Podglad',
  'production.willConsume': 'Zostanie zuzyty',
  'production.willProduce': 'Zostanie wyprodukowany',
  'production.need': 'potrzeba',
  'production.available': 'dostepne',
  'production.note': 'Uwaga',
  'production.notePlaceholder': 'Komentarz do operacji',
  'production.executeProduce': 'Produkuj',
  'production.produced': 'Wyprodukowano: {qty} × {name}',
  'production.errNameRequired': 'Nazwa specyfikacji wymagana',
  'production.errOutputRequired': 'Wybierz produkt wyjsciowy',
  'production.errInputsRequired': 'Dodaj co najmniej jeden surowiec',
  'production.errOutputInInputs': 'Produkt wyjsciowy nie moze byc wsrod surowcow',
  'production.errSelectRecipe': 'Wybierz specyfikacje',
  'production.errSelectWarehouse': 'Wybierz magazyn',
  'production.errMultiplier': 'Mnoznik musi byc >= 1',
  'production.cancelTitle': 'Anulowanie produkcji',
  'production.cancelMessage': 'Anulowac produkcje "{name}" ×{qty}?',
  'production.cancelDescription': 'Gotowy produkt zostanie odjety z magazynu, surowce — zwrocone',
  'production.cancelWarning': 'Tej operacji nie mozna cofnac',
  'production.confirmCancel': 'Potwierdz anulowanie',
  'production.cancelledLabel': 'Anulowano',
  'production.cancelBtn': 'Anuluj',
  'production.alreadyCancelled': 'Ta produkcja zostala juz anulowana',
  'production.cancelNotEnoughStock': 'Nie mozna anulowac — na magazynie pozostalo {available} z {needed} jednostek. Produkt zostal juz wyslany.',
  'production.cancelNote': 'Anulowanie produkcji',
  'production.cancelledSuccess': 'Produkcja anulowana',

  'invMov.typeProductionOut': 'Produkcja (zuzycie)',
  'invMov.typeProductionIn': 'Produkcja (wyjscie)',
  'invMov.filterProduction': 'Produkcja',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Dziennik audytu',

  // ── Audit Log ──
  'auditLog.title': 'Dziennik audytu',
  'auditLog.dateTime': 'Data i czas',
  'auditLog.user': 'Użytkownik',
  'auditLog.action': 'Akcja',
  'auditLog.collection': 'Sekcja',
  'auditLog.documentId': 'ID dokumentu',
  'auditLog.document': 'Dokument',
  'auditLog.details': 'Szczegóły',
  'auditLog.actionCreate': 'Utworzenie',
  'auditLog.actionUpdate': 'Zmiana',
  'auditLog.actionDelete': 'Usunięcie',
  'auditLog.filterCollection': 'Sekcja',
  'auditLog.filterAction': 'Akcja',
  'auditLog.filterFrom': 'Od',
  'auditLog.filterTo': 'Do',
  'auditLog.allCollections': 'Wszystkie sekcje',
  'auditLog.allActions': 'Wszystkie akcje',
  'auditLog.noEntries': 'Nie znaleziono wpisów',
  'auditLog.loadMore': 'Załaduj więcej',
  'auditLog.changes': 'Zmiany',
  'auditLog.field': 'Pole',
  'auditLog.oldValue': 'Przed',
  'auditLog.newValue': 'Po',
  'auditLog.deletedData': 'Usunięte dane',
  'auditLog.newRecord': 'Utworzono nowy rekord',
  'auditLog.fieldsChanged': 'pól zmienionych',
  'auditLog.colCustomers': 'Klienci',
  'auditLog.colStaff': 'Pracownicy',
  'auditLog.colAppointments': 'Wizyty',
  'auditLog.colTransactions': 'Transakcje',
  'auditLog.colOrders': 'Zamówienia',
  'auditLog.colProducts': 'Produkty',
  'auditLog.colStock': 'Stany magazynowe',
  'auditLog.colStockMovements': 'Ruchy magazynowe',
  'auditLog.colServices': 'Usługi',
  'auditLog.colCategories': 'Kategorie',
  'auditLog.colLocations': 'Lokalizacje',
  'auditLog.colRoles': 'Role',
  'auditLog.colUsers': 'Użytkownicy',
  'auditLog.colSalaryHistory': 'Historia wynagrodzeń',
  'auditLog.colSalarySchemes': 'Schematy wynagrodzeń',
  'auditLog.colFixedExpenses': 'Koszty stałe',
  'auditLog.colWarehouses': 'Magazyny',
  'auditLog.colScheduleTemplates': 'Szablony grafików',
  'auditLog.colCashShifts': 'Zmiany kasowe',
  'auditLog.colProductions': 'Produkcja',
  'auditLog.colTechCards': 'Karty technologiczne',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Programy lojalnościowe',
  'loyalty.title': 'Programy lojalnościowe',
  'loyalty.subtitle': 'Punkty, poziomy, kody promo i abonamenty',
  'custModal.tabLoyalty': 'Lojalność',
  'loyalty.tabPoints': 'Punkty',
  'loyalty.tabTiers': 'Poziomy',
  'loyalty.tabCoupons': 'Kody Promo',
  'loyalty.tabSubscriptions': 'Abonamenty',
  'loyalty.tabSettings': 'Ustawienia',
  'loyalty.tabBalances': 'Salda',
  'loyalty.tabHistory': 'Historia',
  'loyalty.tabTierOverview': 'Przegląd klientów',
  'loyalty.tabPlans': 'Plany',
  'loyalty.tabPlansSettings': 'Ustawienia planów',
  'loyalty.tabActiveSubs': 'Aktywne abonamenty',
  'loyalty.statMembers': 'członków',
  'loyalty.statPoints': 'aktywnych punktów',
  'loyalty.saveSettings': 'Zapisz ustawienia',
  'loyalty.saved': 'Ustawienia zapisane',
  'loyalty.searchCustomer': 'Szukaj klienta...',
  'loyalty.days': 'dni',
  'loyalty.pts': 'punktów',
  'loyalty.cancel': 'Anuluj',
  'loyalty.colCustomer': 'Klient',
  'loyalty.colTier': 'Poziom',
  'loyalty.colBalance': 'Saldo',
  'loyalty.colTotalEarned': 'Naliczone',
  'loyalty.colTotalRedeemed': 'Wymienione',
  'loyalty.colTotalSpent': 'Łącznie wydano',
  'loyalty.colDate': 'Data',
  'loyalty.colType': 'Typ',
  'loyalty.colPoints': 'Punkty',
  'loyalty.colNote': 'Uwaga',
  'loyalty.colStatus': 'Status',
  'loyalty.enablePoints': 'Włącz program punktowy',
  'loyalty.pointsDisabled': 'Program punktowy wyłączony',
  'loyalty.sectionEarning': 'Naliczanie punktów',
  'loyalty.currencyPerPoint': 'Kwota za punkt',
  'loyalty.currencyPerPointHint': 'Ile klient musi wydać, aby otrzymać punkty',
  'loyalty.pointsPerUnit': 'Punktów za jednostkę',
  'loyalty.sectionRedemption': 'Wymiana punktów',
  'loyalty.pointValue': 'Wartość punktu',
  'loyalty.maxRedeemPercent': 'Maks. % płatności punktami',
  'loyalty.sectionAutoBonuses': 'Automatyczne bonusy',
  'loyalty.birthdayBonus': 'Bonus urodzinowy',
  'loyalty.referralBonus': 'Bonus za polecenie',
  'loyalty.inactivityDays': 'Dni nieaktywności',
  'loyalty.inactivityBonus': 'Bonus za powrót',
  'loyalty.noBalances': 'Brak członków',
  'loyalty.noBalancesHint': 'Punkty będą naliczane automatycznie przy płatności',
  'loyalty.noHistory': 'Historia pusta',
  'loyalty.txEarn': 'Naliczenie',
  'loyalty.txRedeem': 'Wymiana',
  'loyalty.txBirthday': 'Urodziny',
  'loyalty.txReferral': 'Polecenie',
  'loyalty.txInactivity': 'Powrót',
  'loyalty.txManual': 'Ręcznie',
  'loyalty.sectionPoints': 'Punkty',
  'loyalty.pointsBalance': 'punktów',
  'loyalty.earned': 'naliczone',
  'loyalty.redeemed': 'wymienione',
  'loyalty.manualPlaceholder': '±punktów',
  'loyalty.manualApply': 'Zastosuj',
  'loyalty.manualAdd': 'Ręczne naliczenie',
  'loyalty.manualDeduct': 'Ręczne odjęcie',
  'loyalty.history': 'Historia punktów',
  'loyalty.noTransactions': 'Brak operacji z punktami',
  'loyalty.enableTiers': 'Włącz program poziomów',
  'loyalty.tiersDisabled': 'Program poziomów wyłączony',
  'loyalty.tierPeriod': 'Okres rozliczeniowy',
  'loyalty.periodAllTime': 'Cały czas',
  'loyalty.periodMonths': 'Ostatnie {n} mies.',
  'loyalty.tierPeriodHint': 'Okres obliczania wydatków do określenia poziomu',
  'loyalty.sectionTiers': 'Poziomy klientów',
  'loyalty.tiersHint': 'Rabat jest określany automatycznie na podstawie łącznych wydatków klienta',
  'loyalty.tierName': 'Nazwa',
  'loyalty.tierMinSpent': 'Min. wydano',
  'loyalty.tierDiscount': 'Rabat',
  'loyalty.tierLoadingBtn': 'Obliczanie rabatu',
  'loyalty.tierLoadingHint': 'Obliczanie rabatu poziomu…',
  'loyalty.addTier': 'Dodaj poziom',
  'loyalty.noTierCustomers': 'Brak klientów z wydatkami',
  'loyalty.sectionTierStatus': 'Poziom klienta',
  'loyalty.tierDiscountLabel': 'Rabat poziomu',
  'loyalty.nextTier': 'Następny poziom',
  'loyalty.enableCoupons': 'Włącz kody promo',
  'loyalty.couponsDisabled': 'Kody promo wyłączone',
  'loyalty.searchCoupon': 'Szukaj kodu promo...',
  'loyalty.addCoupon': 'Utwórz kod promo',
  'loyalty.newCoupon': 'Nowy kod promo',
  'loyalty.editCoupon': 'Edytuj kod promo',
  'loyalty.saveCoupon': 'Zapisz kod promo',
  'loyalty.couponCode': 'Kod',
  'loyalty.couponType': 'Typ rabatu',
  'loyalty.couponPercent': 'Procentowy',
  'loyalty.couponFixed': 'Stała kwota',
  'loyalty.couponValue': 'Wartość rabatu',
  'loyalty.couponMinOrder': 'Min. zamówienie',
  'loyalty.couponMaxUses': 'Maks. użyć',
  'loyalty.couponMaxUsesHint': '0 = bez limitu',
  'loyalty.couponExpiry': 'Ważny do',
  'loyalty.couponUsed': 'Użyto',
  'loyalty.generateCode': 'Generuj',
  'loyalty.noCoupons': 'Brak kodów promo',
  'loyalty.statusActive': 'Aktywny',
  'loyalty.statusInactive': 'Nieaktywny',
  'loyalty.statusExpired': 'Wygasły',
  'loyalty.statusMaxed': 'Wyczerpany',
  'loyalty.enableSubscriptions': 'Włącz abonamenty',
  'loyalty.subscriptionsDisabled': 'Abonamenty wyłączone',
  'loyalty.disableConfirmTitle': 'Wyłączyć program?',
  'loyalty.disableConfirmMessage': 'Czy na pewno chcesz wyłączyć ten program lojalnościowy? Przestanie działać dla klientów.',
  'loyalty.disableConfirm': 'Wyłącz',
  'loyalty.addPlan': 'Utwórz plan',
  'loyalty.newPlan': 'Nowy plan',
  'loyalty.editPlan': 'Edytuj plan',
  'loyalty.savePlan': 'Zapisz plan',
  'loyalty.planName': 'Nazwa planu',
  'loyalty.planType': 'Typ',
  'loyalty.planTypeVisits': 'Wg wizyt',
  'loyalty.planTypeTime': 'Wg czasu',
  'loyalty.planTotalVisits': 'Łączna liczba wizyt',
  'loyalty.planValidDays': 'Okres ważności',
  'loyalty.planPrice': 'Cena',
  'loyalty.planServices': 'Usługi',
  'loyalty.planServicesHint': 'Wybierz usługi lub zostaw puste dla wszystkich',
  'loyalty.allServices': 'Wszystkie usługi',
  'loyalty.noPlans': 'Brak planów',
  'loyalty.visits': 'wizyt',
  'loyalty.noActiveSubs': 'Brak aktywnych abonamentów',
  'loyalty.subVisits': 'Wizyty',
  'loyalty.subExpires': 'Wygasa',
  'loyalty.consumedVisitsTitle': 'Wykorzystane wizyty',
  'loyalty.noConsumedVisits': 'Brak wykorzystanych wizyt',
  'loyalty.subStatus_active': 'Aktywny',
  'loyalty.subStatus_expired': 'Wygasły',
  'loyalty.subStatus_used_up': 'Wyczerpany',
  'loyalty.sectionSubscriptions': 'Abonamenty',
  'loyalty.sellSubscription': 'Sprzedaj abonament',
  'loyalty.sellSubTitle': 'Sprzedaż abonamentu',
  'loyalty.selectCustomer': 'Wybierz klienta',
  'loyalty.selectPlan': 'Wybierz plan',
  'loyalty.confirmSell': 'Potwierdź',
  'loyalty.toPayment': 'Przejdź do płatności',
  'loyalty.paymentTitle': 'Płatność za abonament',
  'loyalty.subSold': 'Abonament sprzedany pomyślnie',
  'loyalty.refund': 'Zwrot',
  'loyalty.refundConfirm': 'Zwrócić pieniądze za abonament "{name}"? Zostanie dezaktywowany.',
  'loyalty.subRefunded': 'Zwrócono, abonament dezaktywowany',
  'loyalty.subStatus_refunded': 'Zwrócony',
  'loyalty.subPurchased': 'Zakupiono',
  'loyalty.subPrice': 'Cena',
  'loyalty.noActiveModules': 'Brak aktywnych programów lojalnościowych',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Użyj punktów',
  'loyalty.balance': 'Saldo',
  'loyalty.max': 'Maks.',
  'loyalty.apply': 'Zastosuj',
  'loyalty.enterCoupon': 'Wprowadź kod promo',
  'loyalty.couponNotFound': 'Kod promo nie znaleziony',
  'loyalty.couponInvalid': 'Kod promo nieważny',
  'loyalty.couponErr_not_found': 'Kod promo nie znaleziony',
  'loyalty.couponErr_inactive': 'Kod promo nieaktywny',
  'loyalty.couponErr_expired': 'Kod promo wygasł',
  'loyalty.couponErr_maxed': 'Kod promo wyczerpany',
  'loyalty.couponErr_min_order': 'Kwota poniżej minimum kodu promo',
  'loyalty.payBySubscription': 'Zapłać subskrypcją',
  'loyalty.subscription': 'Subskrypcja',
  'loyalty.pointsRedeemed': 'Punkty wymienione przy płatności',
  'presence.editing': 'Ten rekord jest właśnie edytowany przez',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Integracja z marketplace Rozetka do synchronizacji zamówień',
  'rozetka.login': 'Login (email sprzedawcy)',
  'rozetka.loginRequired': 'Wprowadź login',
  'rozetka.password': 'Hasło',
  'rozetka.save': 'Zapisz',
  'rozetka.saved': 'Ustawienia zapisane',
  'rozetka.error': 'Błąd: ',
  'rozetka.testConnection': 'Test połączenia',
  'rozetka.testSuccess': 'Połączenie udane',
  'rozetka.testError': 'Błąd połączenia',
  'rozetka.ordersCount': 'Zamówienia',
  'rozetka.help': 'Wymagane konto sprzedawcy Rozetka. Użyj tych samych danych logowania co do seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Integracja z marketplace Prom.ua do synchronizacji zamówień',
  'prom.apiToken': 'Token API',
  'prom.tokenRequired': 'Wprowadź token API',
  'prom.save': 'Zapisz',
  'prom.saved': 'Ustawienia zapisane',
  'prom.error': 'Błąd: ',
  'prom.testConnection': 'Test połączenia',
  'prom.testSuccess': 'Połączenie udane',
  'prom.testError': 'Błąd połączenia',
  'prom.help': 'Aby uzyskać token API: Panel sprzedawcy → Ustawienia → Zarządzanie tokenami API. Utwórz token z uprawnieniami do zamówień i produktów.',

  // ── POS (szybka sprzedaż) ──
  'pos.title': 'Sklep',
  'pos.selectWarehouse': 'Wybierz magazyn',
  'pos.noWarehouseHint': 'Wybierz magazyn, aby rozpocząć sprzedaż',
  'pos.tariffPlan': 'Plan taryfowy',
  'pos.standardPrice': 'Cena standardowa',
  'pos.search': 'Szukaj produktu...',
  'pos.allCategories': 'Wszystkie',
  'pos.outOfStock': 'Brak',
  'pos.noProducts': 'Nie znaleziono produktów',
  'pos.cart': 'Koszyk',
  'pos.emptyCart': 'Koszyk jest pusty',
  'pos.subtotal': 'Podsuma',
  'pos.discount': 'Rabat',
  'pos.loyaltyPoints': 'Punkty lojalnościowe',
  'pos.available': 'dostępne',
  'pos.total': 'Do zapłaty',
  'pos.coupon': 'Coupon',
  'pos.couponPlaceholder': 'Enter coupon code...',
  'pos.applyCoupon': 'Apply',
  'pos.invalidCoupon': 'Coupon is invalid or not found',
  'pos.cash': 'Gotówka',
  'pos.card': 'Karta',
  'pos.transfer': 'Przelew',
  'pos.cashGiven': 'Otrzymano',
  'pos.change': 'Reszta',
  'pos.confirm': 'Potwierdź',
  'pos.saleComplete': 'Sprzedaż zakończona!',
  'pos.returnTitle': 'Zwrot towaru',
  'pos.returnHint': 'Podaj ilość do zwrotu',
  'pos.returnAmount': 'Kwota zwrotu',
  'pos.confirmReturn': 'Zwróć',
  'pos.tabSale': 'Sprzedaż',
  'pos.tabHistory': 'Historia',
  'pos.historyEmpty': 'Brak sprzedaży',
  'pos.historyDate': 'Data',
  'pos.historyItems': 'Produkty',
  'pos.historyTotal': 'Suma',
  'pos.historyMethod': 'Metoda',
  'pos.historyAuthor': 'Autor',
  'pos.historyCancel': 'Anuluj',
  'pos.historyCancelConfirm': 'Anulować tę sprzedaż? Produkty wrócą na magazyn.',
  'pos.historyCancelled': 'Sprzedaż anulowana',
  'pos.historyCustomer': 'Klient',
  'pos.historyReturn': 'Zwrot',
  'pos.historyReturned': 'Zwrot',
  'pos.partialReturn': 'Częśc. zwrot',
  'pos.warehouse': 'Magazyn',
  'pos.customer': 'Klient',
  'pos.selectCustomer': 'Szukaj klienta...',
  'bizMonitor.title': 'Monitor Biznesu',
  'bizMonitor.subtitle': 'Przegląd strategiczny dla właściciela',
  'bizMonitor.revenue': 'Przychody', 'bizMonitor.profit': 'Zysk', 'bizMonitor.profitability': 'Rentowność',
  'bizMonitor.activeClients': 'Aktywni klienci', 'bizMonitor.retention': 'Retencja',
  'bizMonitor.services': 'Usługi', 'bizMonitor.goods': 'Produkty',
  'bizMonitor.new': 'Nowi', 'bizMonitor.returning': 'Powracający', 'bizMonitor.prevMonth': 'Pop. mies.',
  'bizMonitor.revenueTrend': 'Trend przychodów', 'bizMonitor.clientHealth': 'Zdrowie bazy klientów',
  'bizMonitor.viewDetails': 'Szczegóły', 'bizMonitor.newClients': 'Nowi', 'bizMonitor.returningClients': 'Powracający',
  'bizMonitor.sleeping': 'Nieaktywni (30d+)', 'bizMonitor.avgCheckServices': 'Śr. rachunek usługi',
  'bizMonitor.avgCheckProducts': 'Śr. rachunek produkty', 'bizMonitor.channels': 'Kanały sprzedaży',
  'bizMonitor.channelAppts': 'Wizyty', 'bizMonitor.channelOrders': 'Zamówienia', 'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Top pracownicy', 'bizMonitor.topServices': 'Top usługi', 'bizMonitor.topProducts': 'Top produkty',
  'bizMonitor.appointments': 'wizyt', 'bizMonitor.times': 'razy', 'bizMonitor.pcs': 'szt', 'bizMonitor.margin': 'Marża',
  'bizMonitor.stockAnalytics': 'Magazyn', 'bizMonitor.stockValue': 'Wartość magazynu', 'bizMonitor.positions': 'pozycji',
  'bizMonitor.lowStockCount': 'Niski stan', 'bizMonitor.noMovementCount': 'Bez ruchu 30d+',
  'bizMonitor.alerts': 'Wymaga uwagi', 'bizMonitor.alertFinance': 'Finanse', 'bizMonitor.alertClients': 'Klienci',
  'bizMonitor.alertStock': 'Produkty/Magazyn', 'bizMonitor.alertStaff': 'Personel', 'bizMonitor.noData': 'Brak danych',
  'sidebar.businessMonitor': 'Monitor Biznesu',

  // ── Komunikacja: klucze brakujące względem uk (2026-09-25) ──
  'nav.instagram': 'Instagram',
  'nav.messenger': 'Messenger',
  'instagram.tagline': 'Wiadomości prywatne z Twojego konta Instagram Business — w CRM',
  'instagram.connected': 'Połączono',
  'instagram.notConnected': 'Nie połączono',
  'instagram.connectIntro': 'Połącz konto Instagram Business przez OAuth, aby otrzymywać wiadomości prywatne od klientów bezpośrednio w CRM.',
  'instagram.connectBtn': 'Połącz Instagram',
  'instagram.tabOpened': 'Instagram otworzył się w nowej karcie. Zaloguj się i wróć tutaj.',
  'instagram.connectFailed': 'Błąd połączenia:',
  'instagram.confirmDisconnect': 'Odłączyć integrację z Instagramem?',
  'instagram.disconnected': 'Instagram odłączony',
  'instagram.disconnectBtn': 'Odłącz',
  'instagram.testBtn': 'Sprawdź połączenie',
  'instagram.testOk': 'Połączenie działa:',
  'instagram.testFailed': 'Test nie powiódł się',
  'instagram.account': 'Konto',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Uprawnienia',
  'instagram.connectedAt': 'Połączono',
  'instagram.expiresAt': 'Ważny do',
  'instagram.reconnectRequired': 'Wymagana ponowna autoryzacja',
  'instagram.reconnectExplain': 'Nie udało się odnowić tokenu długoterminowego (zwykle po ponad 60 dniach bezczynności lub zmianie hasła do Instagrama). Kliknij „Połącz Instagram”, aby dalej otrzymywać wiadomości.',
  'instagram.howItWorks': 'Jak to działa',
  'instagram.step1': 'Kliknij „Połącz Instagram” — autoryzacja Instagrama otworzy się w nowej karcie.',
  'instagram.step2': 'Zaloguj się na konto Instagram Business (konto profesjonalne powiązane ze stroną na Facebooku) i zezwól aplikacji na dostęp do wiadomości prywatnych.',
  'instagram.step3': 'Wróć na tę kartę — status odświeży się automatycznie; sprawdź przyciskiem „Sprawdź połączenie”.',
  'instagram.capabilities': 'Co daje połączenie',
  'instagram.capInboxTitle': 'Wiadomości prywatne — w CRM',
  'instagram.capInboxText': 'Wszystkie wiadomości z Instagram Direct trafiają do Komunikacji w czasie rzeczywistym przez webhooki Meta — obok Telegrama, SMS-ów i e-maili.',
  'instagram.capOutboundTitle': 'Odpowiedź z CRM prosto na Instagram',
  'instagram.capOutboundText': 'Otwórz wątek w Komunikacji i wybierz kanał „Instagram” — wiadomość trafi do Direct klienta.',
  'instagram.limitations': 'Ograniczenia',
  'instagram.limitationsText': 'Działa tylko z profesjonalnym kontem Instagram (Business lub Creator) powiązanym ze stroną na Facebooku. Meta nie obsługuje kont prywatnych w Messaging API.',
  'instagram.resubscribed': 'Subskrypcję webhooków odnowiono. Kliknij „Sprawdź połączenie”, aby zobaczyć nowy stan.',
  'instagram.resubscribeFailed': 'Nie udało się odnowić subskrypcji:',
  'instagram.errorPrefix': 'Błąd:',
  'custModal.subscriptionPurchase': 'Zakup karnetu',
  'custModal.subscriptionRefund': 'Zwrot karnetu',
  'custModal.methodOnline': 'Online',
  'custModal.methodSubscription': 'Karnet',
  'custModal.servicesLabel': 'Usługi',
  'custModal.messageSent': 'Wysłano',
  'emailSet.provider': 'Usługa pocztowa',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'Własny SMTP',
  'emailSet.hintGmail': 'Potrzebne jest hasło do aplikacji z myaccount.google.com/apppasswords (najpierw włącz weryfikację dwuetapową)',
  'emailSet.hintOutlook': 'Login to pełny adres (you@outlook.com). Przy włączonej weryfikacji dwuetapowej może być potrzebne osobne hasło do aplikacji',
  'emailSet.hintUkrnet': 'W Ukr.net: Ustawienia → Poczta → Zezwól na dostęp zewnętrznych programów pocztowych',
  'emailSet.hintMeta': 'W Meta.ua: Ustawienia → IMAP/SMTP → Włącz',
  'emailSet.hintCustom': 'Wpisz ręcznie host, port i dane logowania swojego serwera pocztowego',
  'emailSet.host': 'Serwer SMTP',
  'emailSet.port': 'Port',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'Login SMTP',
  'emailSet.smtpUserHint': 'Zwykle pełny adres e-mail',
  'emailSet.password': 'Hasło SMTP',
  'emailSet.passwordHint': 'Dla Gmail/Outlook — hasło do aplikacji, nie główne',
  'emailSet.fromEmail': 'Adres nadawcy',
  'emailSet.fromEmailHint': 'Jeśli puste — używany jest login SMTP',
  'emailSet.invalidEmail': 'Nieprawidłowy adres e-mail (wymagany format user@domain.com)',
  'emailSet.sectionProvider': 'Usługa pocztowa i serwer',
  'emailSet.sectionCredentials': 'Dane logowania',
  'emailSet.sectionFrom': 'Nadawca',
  'emailSet.howToConnect': 'Jak połączyć {provider}',
  'emailSet.instrGmail': '<ol><li>Włącz weryfikację dwuetapową na koncie Google: <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>Weryfikacja dwuetapowa</strong> → <strong>Włącz</strong>.</li><li>Przejdź do <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Utwórz hasło do aplikacji: typ <strong>Poczta</strong> (lub <strong>Inne</strong> z nazwą <code>Systemic CRM</code>).</li><li>Skopiuj 16-znakowe hasło (wygląda jak <code>abcd efgh ijkl mnop</code>).</li><li>Wklej je w pole <strong>Hasło SMTP</strong> powyżej i kliknij <strong>Wyślij testowy e-mail</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Zaloguj się na <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Otwórz <strong>Zaawansowane opcje zabezpieczeń</strong>.</li><li>W sekcji <strong>Hasła aplikacji</strong> kliknij <strong>Utwórz nowe hasło</strong>.</li><li>Skopiuj wygenerowane hasło i wklej je w <strong>Hasło SMTP</strong>.</li><li><em>Jeśli opcji „Hasła aplikacji” nie ma — najpierw włącz weryfikację dwuetapową.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Zaloguj się do poczty Ukr.net.</li><li>Przejdź do <strong>Ustawienia → Wszystkie ustawienia → Programy pocztowe</strong>.</li><li>Włącz <strong>dostęp przez IMAP/SMTP</strong>.</li><li>W polu <strong>Hasło SMTP</strong> podaj główne hasło do poczty Ukr.net.</li><li><em>Jeśli masz włączoną weryfikację dwuetapową — utwórz osobne hasło do aplikacji w ustawieniach bezpieczeństwa.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Zaloguj się do poczty Meta.ua.</li><li>Przejdź do <strong>Ustawienia → IMAP/SMTP</strong>.</li><li>Włącz protokół SMTP.</li><li>Podaj główne hasło do poczty w polu <strong>Hasło SMTP</strong>.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Poproś administratora systemu lub dostawcę hostingu o parametry SMTP swojego serwera pocztowego.</li><li>Zwykle potrzebne są: <strong>host</strong> (smtp.twoja-domena.com), <strong>port</strong> (587 lub 465), <strong>TLS/SSL</strong> (dla 465 — włączone).</li><li>Login to pełny adres e-mail.</li><li>Hasło to to samo, którego używasz do logowania do poczty (lub osobne hasło SMTP, jeśli dostawca je wydaje).</li></ol>',
  'notifAuto.title': 'Ustawienia komunikacji',
  'notifAuto.subtitle': 'Priorytet kanałów, wiadomości automatyczne i przypomnienia',
  'notifAuto.navItem': 'Ustawienia komunikacji',
  'notifAuto.sectionDefaultPriority': 'Domyślny priorytet dla wiadomości ręcznych',
  'notifAuto.defaultPriorityHint': 'Gdy administrator pisze do klienta w Komunikacji po raz pierwszy, wybierany jest pierwszy dostępny kanał z tej listy; potem podstawiany jest kanał użyty ostatnio z tym klientem. Przeciągnij, aby zmienić kolejność, wyłącz niepotrzebne.',
  'notifAuto.sectionBooking': 'Wiadomość przy utworzeniu wizyty',
  'notifAuto.sectionOrder': 'Wiadomość przy utworzeniu zamówienia produktów',
  'notifAuto.enable': 'Włącz',
  'notifAuto.mode': 'Tryb dostarczania',
  'notifAuto.modePriority': 'Priorytet (pierwszy dostępny kanał)',
  'notifAuto.modeAll': 'Wszystkie kanały jednocześnie',
  'notifAuto.channelsOrder': 'Priorytet kanałów (przeciągnij, aby zmienić kolejność)',
  'notifAuto.channelsEmpty': 'Żaden kanał nie jest włączony — włącz przynajmniej jeden poniżej',
  'notifAuto.otherChannels': 'Inne kanały',
  'notifAuto.dragHint': 'Przeciągnij, aby zmienić kolejność',
  'notifAuto.channelNotConfigured': 'Kanał nie jest skonfigurowany w swojej sekcji — wiadomość nie zostanie wysłana',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'E-mail',
  'notifAuto.channelWeb': 'Czat na stronie',
  'notifAuto.template': 'Szablon wiadomości',
  'notifAuto.templateHint': 'Dostępne zmienne: {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'Obsługuje HTML dla Telegrama/E-maila; dla SMS automatycznie konwertowany na zwykły tekst',
  'notifAuto.preview': 'Podgląd',
  'notifAuto.previewHint': 'Przykład z danymi testowymi',
  'notifAuto.save': 'Zapisz',
  'notifAuto.saved': 'Ustawienia zapisane',
  'notifAuto.moveUp': 'Wyżej',
  'notifAuto.moveDown': 'Niżej',
  'notifAuto.defaultBookingTemplate': 'Witaj, {clientName}! Twoja wizyta została potwierdzona na {date} o {time}. Usługa: {serviceName}, specjalista: {staffName}. Do zobaczenia!',
  'notifAuto.defaultOrderTemplate': 'Dziękujemy za zamówienie nr {orderNumber} na kwotę {total} ₴. Skontaktujemy się, aby potwierdzić dostawę.',
  'notifAuto.sectionReminders': 'Przypomnienia przed wizytą',
  'notifAuto.remindersHint': 'Można dodać kilka reguł z różnymi odstępami (np. 24 godziny i 2 godziny przed). Minimum — 1 godzina.',
  'notifAuto.noReminders': 'Nie skonfigurowano jeszcze przypomnień',
  'notifAuto.addReminder': 'Dodaj przypomnienie',
  'notifAuto.removeReminder': 'Usuń przypomnienie',
  'notifAuto.hoursBefore': 'Ile przed wizytą',
  'notifAuto.hoursBeforeUnit': 'godzin',
  'notifAuto.defaultReminderTemplate': 'Przypominamy: Twoja wizyta {date} o {time}. Usługa: {serviceName}, specjalista: {staffName}. Do zobaczenia!',
  'comm.filterAll': 'Wszystkie',
  'comm.channelWeb': 'Czat na stronie',
  'comm.noChannelsForClient': 'Klient nie ma podłączonych kanałów kontaktu',
  'comm.addContactToCard': 'Dodaj telefon lub e-mail w karcie klienta albo wyślij mu link do bota Telegram',
  'sms.testText': 'Systemic CRM: wiadomość testowa.',
  'sms.testSent': 'Wysłano — sprawdź telefon',
  'sms.testNotSent': 'Nie wysłano',
  'sms.senderRule1': 'Maksymalnie 11 znaków łacińskich, bez spacji — to granica standardu GSM. Nazwa musi być',
  'sms.senderRuleStrong': 'zarejestrowana w panelu dostawcy',
  'sms.senderRule2': 'i zgadzać się co do znaku, z uwzględnieniem wielkości liter.',
  'sms.lastFailed': 'Ostatnia wysyłka nie powiodła się',
  'sms.lastOk': 'Ostatnia udana wysyłka',
  'sms.testLabel': 'Test prawdziwym SMS-em',
  'telegram.statusChecking': 'Sprawdzam stan bota…',
  'telegram.statusRecheck': 'Sprawdź',
  'telegram.statusLastError': 'Ostatni błąd:',
  'telegram.statusBot': 'Bot',
  'telegram.statusWebhook': 'Webhook',
  'telegram.statusWebhookNone': 'nie ustawiony',
  'telegram.statusWebhookExpected': 'oczekiwany',
  'telegram.statusQueue': 'W kolejce',
  'telegram.statusSubscribers': 'Subskrybenci',
  'telegram.statusSubscribersSub': 'klientów, którzy nacisnęli „Start”',
  'telegram.verdictOk': 'Bot jest połączony i działa',
  'telegram.verdictNoToken': 'Bot nie jest skonfigurowany',
  'telegram.verdictNoTokenHint': 'Wklej token z @BotFather i kliknij „Zapisz i połącz”.',
  'telegram.verdictBadToken': 'Token jest nieprawidłowy',
  'telegram.verdictBadTokenHint': 'Bot został usunięty lub token wygenerowano ponownie w @BotFather. Wklej nowy.',
  'telegram.verdictNoWebhook': 'Webhook nie jest ustawiony',
  'telegram.verdictNoWebhookHint': 'Telegram nie wie, dokąd wysyłać aktualizacje. Kliknij „Zapisz i połącz”.',
  'telegram.verdictHostMismatch': 'Webhook wskazuje inny adres',
  'telegram.verdictHostMismatchHint': 'Najczęściej zdarza się, gdy bota podłączono z linku testowego. Kliknij „Zapisz i połącz” pod tym adresem.',
  'telegram.verdictWebhookError': 'Telegram nie może się z nami połączyć',
  'telegram.verdictPending': 'Aktualizacje utknęły w kolejce',
  'telegram.verdictPendingHint': 'Telegram zgromadził aktualizacje, których nie udało się dostarczyć.',
  'telegram.verdictNoSubscribers': 'Bot działa, ale nie ma subskrybentów',
  'telegram.verdictNoSubscribersHint': 'Żaden klient nie nacisnął jeszcze „Start” w bocie. Link osobisty jest w karcie klienta.',
  'telegram.verdictUnreachable': 'Nie udało się sprawdzić stanu',
  'telegram.statusForward': 'Przekazywanie',
  'telegram.statusForwardOk': 'działa',
  'telegram.statusForwardError': 'błąd',
  'telegram.statusForwardPending': 'jeszcze brak aktualizacji',
  'telegram.fwdTitle': 'Zewnętrzny bot: menu i scenariusze',
  'telegram.fwdIntro': 'Jeśli ten bot ma osobny serwer z menu (przyciski, scenariusze), Systemic pozostaje właścicielem webhooka i przekazuje mu kopię każdej aktualizacji. Rozmowy i odpowiedzi operatorów zostają tutaj, jak dotąd.',
  'telegram.fwdUrl': 'Adres przekazywania (https)',
  'telegram.fwdUrlHint': 'Puste pole — przekazywanie wyłączone.',
  'telegram.fwdSecret': 'Hasło przekazywania',
  'telegram.fwdSecretHint': 'Dowolny ciąg znaków. Systemic wyśle go w nagłówku X-Systemic-Secret oraz podpis treści w X-Systemic-Signature — tak zewnętrzny serwer sprawdzi, że żądanie pochodzi od nas.',
  'telegram.fwdSecretStored': 'Hasło jest zapisane na serwerze i nie wraca do przeglądarki. Wpisz nowe, aby je zastąpić.',
  'telegram.fwdSave': 'Zapisz przekazywanie',
  'telegram.fwdSaved': 'Przekazywanie zapisane',
  'telegram.fwdInvalidUrl': 'Adres musi zaczynać się od https://',
  'telegram.fwdHowTitle': 'Jak to działa i o czym pamiętać',
  'telegram.fwdHow1': 'Webhook bota pozostaje w Systemic. Zewnętrzny serwer nie może go zmieniać: karta stanu pokazałaby „Webhook wskazuje inny adres”, a „Zapisz i połącz” odebrałoby webhook z powrotem.',
  'telegram.fwdHow2': 'Systemic przetwarza każdą aktualizację (rozmowy, powiązanie klienta, telefon) i równolegle przekazuje kopię na wskazany adres — łącznie z naciśnięciami przycisków, które sam ignoruje.',
  'telegram.fwdHow3': 'Zewnętrzny serwer pokazuje menu przez token bota. To interfejs, nie rozmowa: nie trafia do Komunikacji. Klientom odpowiadają operatorzy z Systemic.',
  'telegram.fwdHow4': 'Menu buduj z przycisków inline (pod wiadomością). Klawiatura dolna wysyła naciśnięcia jako zwykły tekst i wątek operatora zapełnia się „Usługi”, „Wstecz”.',
  'telegram.fwdHow5': 'Systemic już odpowiada na /start: wita i prosi o numer, aby znaleźć klienta. Menu pokaż po tym lub na osobną komendę, inaczej klient dostanie dwie wiadomości z rzędu.',
  'telegram.fwdHow6': 'Serwer musi odpowiedzieć 200 w ciągu 4 sekund. Nie ma ponowień; stan ostatniego przekazania widać w karcie stanu powyżej.',
  'messengerSet.tagline': 'Wiadomości z Twojej strony na Facebooku — w CRM',
  'messengerSet.tabOpened': 'Facebook otworzył się w nowej karcie. Zaloguj się i wróć tutaj.',
  'messengerSet.connectFailed': 'Błąd połączenia:',
  'messengerSet.confirmDisconnect': 'Odłączyć integrację z Messengerem?',
  'messengerSet.disconnected': 'Messenger odłączony',
  'messengerSet.pageActivated': 'Strona „{name}” aktywowana',
  'messengerSet.subscribeFailed': 'Strona aktywowana, ale subskrypcja webhooka nie powiodła się: {error}. Kliknij „Odnów subskrypcję webhooków”.',
  'messengerSet.activateFailed': 'Nie udało się aktywować strony',
  'messengerSet.errorPrefix': 'Błąd:',
  'messengerSet.pagesRefreshed': 'Lista stron odświeżona',
  'messengerSet.resubscribed': 'Subskrypcję webhooków odnowiono. Kliknij „Sprawdź połączenie”.',
  'messengerSet.resubscribeFailed': 'Nie udało się odnowić subskrypcji:',
  'messengerSet.needsReconnect': 'Wymagana ponowna autoryzacja',
  'messengerSet.reconnectHint': 'Facebook unieważnił token. Kliknij „Połącz”, aby kontynuować.',
  'messengerSet.howTitle': 'Jak to działa',
  'messengerSet.how1': 'Kliknij „Połącz Messenger” — Facebook otworzy autoryzację w nowej karcie.',
  'messengerSet.how2': 'Zezwól aplikacji na zarządzanie wiadomościami Twoich stron.',
  'messengerSet.how3': 'Wróć tutaj — zobaczysz listę swoich stron na Facebooku. Wybierz jedną dla CRM.',
  'messengerSet.how4': 'Gotowe. Wiadomości z tej strony automatycznie trafiają do Komunikacji.',
  'messengerSet.givesTitle': 'Co daje połączenie',
  'messengerSet.capInboxTitle': 'Wiadomości ze strony na Facebooku — w CRM',
  'messengerSet.capInboxText': 'Wszystkie wiadomości do Twojej strony trafiają do Komunikacji w czasie rzeczywistym — obok Telegrama, SMS-ów i e-maili.',
  'messengerSet.capReplyTitle': 'Odpowiedź z CRM prosto na Messengera',
  'messengerSet.capReplyText': 'Otwórz wątek w Komunikacji i wybierz kanał „Messenger” — odpowiedź trafi do klienta. Meta pozwala odpowiadać w ciągu 24 godzin od jego wiadomości.',
  'messengerSet.limitsLabel': 'Ograniczenia:',
  'messengerSet.limitsText': 'Działa tylko ze stronami firmowymi na Facebooku, nie z profilami prywatnymi.',
  'messengerSet.statusOff': 'Nie połączono',
  'messengerSet.statusPending': 'Oczekuje na wybór strony',
  'messengerSet.statusOn': 'Połączono',
  'messengerSet.connectIntro': 'Połącz konto Facebook i wybierz stronę, z której wiadomości będą trafiać do CRM.',
  'messengerSet.connectBtn': 'Połącz Messenger',
  'messengerSet.noPages': 'Na tym koncie nie znaleziono żadnej strony na Facebooku. Utwórz stronę na facebook.com → Pages, a potem odśwież listę.',
  'messengerSet.refreshPages': 'Odśwież listę stron',
  'messengerSet.disconnectBtn': 'Odłącz',
  'messengerSet.pickIntro': 'Wybierz stronę na Facebooku, z której CRM będzie otrzymywać wiadomości:',
  'messengerSet.pageActive': 'Aktywna',
  'messengerSet.pageUse': 'Użyj',
  'messengerSet.refreshList': 'Odśwież listę',
  'messengerSet.fbAccount': 'Konto Facebook:',
  'messengerSet.activePage': 'Aktywna strona:',
  'messengerSet.connectedAt': 'Połączono:',
  'messengerSet.userTokenUntil': 'Token użytkownika ważny do:',
  'messengerSet.unknown': '(nieznane)',
  'messengerSet.testBtn': 'Sprawdź połączenie',
  'messengerSet.resubscribeBtn': 'Odnów subskrypcję webhooków',
  'messengerSet.switchPage': 'Zmień stronę',
  'messengerSet.patOk': '✓ Token strony jest ważny:',
  'messengerSet.patFailed': '✗ Token strony nie przeszedł weryfikacji:',
  'messengerSet.subsTitle': 'Subskrypcje webhooków:',
  'messengerSet.noApps': 'Żadna aplikacja nie subskrybuje tej strony. Kliknij „Odnów subskrypcję webhooków”.',
  'messengerSet.subscribedFields': 'Subskrybowane pola:',
  'messengerSet.noMessagesField': '⚠ Brakuje pola „messages” — Meta nie będzie dostarczać wiadomości. Kliknij „Odnów subskrypcję webhooków”.',
  'messengerSet.subsFailed': '✗ Sprawdzenie subskrypcji nie powiodło się:',
};

export default pl;
